(function() {
  try {
    var e = typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, n = new e.Error().stack;
    n && (e._sentryDebugIds = e._sentryDebugIds || {}, e._sentryDebugIds[n] = "a1412ccd-128b-4efc-a0d0-18f44cbabf9a", e._sentryDebugIdIdentifier = "sentry-dbid-a1412ccd-128b-4efc-a0d0-18f44cbabf9a");
  } catch {
  }
})();
/**
* @vue/shared v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function vr(e) {
  const n = /* @__PURE__ */ Object.create(null);
  for (const t of e.split(","))
    n[t] = 1;
  return (t) => t in n;
}
const z = {}, Mn = [], Ne = () => {
}, y_ = () => !1, ts = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), Tr = (e) => e.startsWith("onUpdate:"), se = Object.assign, Rr = (e, n) => {
  const t = e.indexOf(n);
  t > -1 && e.splice(t, 1);
}, I_ = Object.prototype.hasOwnProperty, W = (e, n) => I_.call(e, n), C = Array.isArray, Ln = (e) => ss(e) === "[object Map]", Ta = (e) => ss(e) === "[object Set]", P = (e) => typeof e == "function", oe = (e) => typeof e == "string", dn = (e) => typeof e == "symbol", Q = (e) => e !== null && typeof e == "object", Ra = (e) => (Q(e) || P(e)) && P(e.then) && P(e.catch), ya = Object.prototype.toString, ss = (e) => ya.call(e), O_ = (e) => ss(e).slice(8, -1), rs = (e) => ss(e) === "[object Object]", yr = (e) => oe(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, ot = /* @__PURE__ */ vr(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), os = (e) => {
  const n = /* @__PURE__ */ Object.create(null);
  return (t) => n[t] || (n[t] = e(t));
}, N_ = /-(\w)/g, De = os(
  (e) => e.replace(N_, (n, t) => t ? t.toUpperCase() : "")
), D_ = /\B([A-Z])/g, Re = os(
  (e) => e.replace(D_, "-$1").toLowerCase()
), Ia = os((e) => e.charAt(0).toUpperCase() + e.slice(1)), ys = os(
  (e) => e ? `on${Ia(e)}` : ""
), pn = (e, n) => !Object.is(e, n), Is = (e, ...n) => {
  for (let t = 0; t < e.length; t++)
    e[t](...n);
}, Oa = (e, n, t, s = !1) => {
  Object.defineProperty(e, n, {
    configurable: !0,
    enumerable: !1,
    writable: s,
    value: t
  });
}, A_ = (e) => {
  const n = parseFloat(e);
  return isNaN(n) ? e : n;
}, uo = (e) => {
  const n = oe(e) ? Number(e) : NaN;
  return isNaN(n) ? e : n;
};
let lo;
const as = () => lo || (lo = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function Ir(e) {
  if (C(e)) {
    const n = {};
    for (let t = 0; t < e.length; t++) {
      const s = e[t], r = oe(s) ? U_(s) : Ir(s);
      if (r)
        for (const o in r)
          n[o] = r[o];
    }
    return n;
  } else if (oe(e) || Q(e))
    return e;
}
const S_ = /;(?![^(]*\))/g, w_ = /:([^]+)/, H_ = /\/\*[^]*?\*\//g;
function U_(e) {
  const n = {};
  return e.replace(H_, "").split(S_).forEach((t) => {
    if (t) {
      const s = t.split(w_);
      s.length > 1 && (n[s[0].trim()] = s[1].trim());
    }
  }), n;
}
function Or(e) {
  let n = "";
  if (oe(e))
    n = e;
  else if (C(e))
    for (let t = 0; t < e.length; t++) {
      const s = Or(e[t]);
      s && (n += s + " ");
    }
  else if (Q(e))
    for (const t in e)
      e[t] && (n += t + " ");
  return n.trim();
}
const C_ = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", P_ = /* @__PURE__ */ vr(C_);
function Na(e) {
  return !!e || e === "";
}
const Da = (e) => !!(e && e.__v_isRef === !0), M_ = (e) => oe(e) ? e : e == null ? "" : C(e) || Q(e) && (e.toString === ya || !P(e.toString)) ? Da(e) ? M_(e.value) : JSON.stringify(e, Aa, 2) : String(e), Aa = (e, n) => Da(n) ? Aa(e, n.value) : Ln(n) ? {
  [`Map(${n.size})`]: [...n.entries()].reduce(
    (t, [s, r], o) => (t[Os(s, o) + " =>"] = r, t),
    {}
  )
} : Ta(n) ? {
  [`Set(${n.size})`]: [...n.values()].map((t) => Os(t))
} : dn(n) ? Os(n) : Q(n) && !C(n) && !rs(n) ? String(n) : n, Os = (e, n = "") => {
  var t;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    dn(e) ? `Symbol(${(t = e.description) != null ? t : n})` : e
  );
};
/**
* @vue/reactivity v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let ue;
class Sa {
  constructor(n = !1) {
    this.detached = n, this._active = !0, this.effects = [], this.cleanups = [], this._isPaused = !1, this.parent = ue, !n && ue && (this.index = (ue.scopes || (ue.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let n, t;
      if (this.scopes)
        for (n = 0, t = this.scopes.length; n < t; n++)
          this.scopes[n].pause();
      for (n = 0, t = this.effects.length; n < t; n++)
        this.effects[n].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let n, t;
      if (this.scopes)
        for (n = 0, t = this.scopes.length; n < t; n++)
          this.scopes[n].resume();
      for (n = 0, t = this.effects.length; n < t; n++)
        this.effects[n].resume();
    }
  }
  run(n) {
    if (this._active) {
      const t = ue;
      try {
        return ue = this, n();
      } finally {
        ue = t;
      }
    }
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    ue = this;
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    ue = this.parent;
  }
  stop(n) {
    if (this._active) {
      this._active = !1;
      let t, s;
      for (t = 0, s = this.effects.length; t < s; t++)
        this.effects[t].stop();
      for (this.effects.length = 0, t = 0, s = this.cleanups.length; t < s; t++)
        this.cleanups[t]();
      if (this.cleanups.length = 0, this.scopes) {
        for (t = 0, s = this.scopes.length; t < s; t++)
          this.scopes[t].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !n) {
        const r = this.parent.scopes.pop();
        r && r !== this && (this.parent.scopes[this.index] = r, r.index = this.index);
      }
      this.parent = void 0;
    }
  }
}
function wa(e) {
  return new Sa(e);
}
function Ha() {
  return ue;
}
function L_(e, n = !1) {
  ue && ue.cleanups.push(e);
}
let J;
const Ns = /* @__PURE__ */ new WeakSet();
class Ua {
  constructor(n) {
    this.fn = n, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, ue && ue.active && ue.effects.push(this);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, Ns.has(this) && (Ns.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || Pa(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, mo(this), Ma(this);
    const n = J, t = Ae;
    J = this, Ae = !0;
    try {
      return this.fn();
    } finally {
      La(this), J = n, Ae = t, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let n = this.deps; n; n = n.nextDep)
        Ar(n);
      this.deps = this.depsTail = void 0, mo(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? Ns.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    Ws(this) && this.run();
  }
  get dirty() {
    return Ws(this);
  }
}
let Ca = 0, at, it;
function Pa(e, n = !1) {
  if (e.flags |= 8, n) {
    e.next = it, it = e;
    return;
  }
  e.next = at, at = e;
}
function Nr() {
  Ca++;
}
function Dr() {
  if (--Ca > 0)
    return;
  if (it) {
    let n = it;
    for (it = void 0; n; ) {
      const t = n.next;
      n.next = void 0, n.flags &= -9, n = t;
    }
  }
  let e;
  for (; at; ) {
    let n = at;
    for (at = void 0; n; ) {
      const t = n.next;
      if (n.next = void 0, n.flags &= -9, n.flags & 1)
        try {
          n.trigger();
        } catch (s) {
          e || (e = s);
        }
      n = t;
    }
  }
  if (e)
    throw e;
}
function Ma(e) {
  for (let n = e.deps; n; n = n.nextDep)
    n.version = -1, n.prevActiveLink = n.dep.activeLink, n.dep.activeLink = n;
}
function La(e) {
  let n, t = e.depsTail, s = t;
  for (; s; ) {
    const r = s.prevDep;
    s.version === -1 ? (s === t && (t = r), Ar(s), G_(s)) : n = s, s.dep.activeLink = s.prevActiveLink, s.prevActiveLink = void 0, s = r;
  }
  e.deps = n, e.depsTail = t;
}
function Ws(e) {
  for (let n = e.deps; n; n = n.nextDep)
    if (n.dep.version !== n.version || n.dep.computed && (Ga(n.dep.computed) || n.dep.version !== n.version))
      return !0;
  return !!e._dirty;
}
function Ga(e) {
  if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === ft))
    return;
  e.globalVersion = ft;
  const n = e.dep;
  if (e.flags |= 2, n.version > 0 && !e.isSSR && e.deps && !Ws(e)) {
    e.flags &= -3;
    return;
  }
  const t = J, s = Ae;
  J = e, Ae = !0;
  try {
    Ma(e);
    const r = e.fn(e._value);
    (n.version === 0 || pn(r, e._value)) && (e._value = r, n.version++);
  } catch (r) {
    throw n.version++, r;
  } finally {
    J = t, Ae = s, La(e), e.flags &= -3;
  }
}
function Ar(e, n = !1) {
  const { dep: t, prevSub: s, nextSub: r } = e;
  if (s && (s.nextSub = r, e.prevSub = void 0), r && (r.prevSub = s, e.nextSub = void 0), t.subs === e && (t.subs = s, !s && t.computed)) {
    t.computed.flags &= -5;
    for (let o = t.computed.deps; o; o = o.nextDep)
      Ar(o, !0);
  }
  !n && !--t.sc && t.map && t.map.delete(t.key);
}
function G_(e) {
  const { prevDep: n, nextDep: t } = e;
  n && (n.nextDep = t, e.prevDep = void 0), t && (t.prevDep = n, e.nextDep = void 0);
}
let Ae = !0;
const xa = [];
function un() {
  xa.push(Ae), Ae = !1;
}
function ln() {
  const e = xa.pop();
  Ae = e === void 0 ? !0 : e;
}
function mo(e) {
  const { cleanup: n } = e;
  if (e.cleanup = void 0, n) {
    const t = J;
    J = void 0;
    try {
      n();
    } finally {
      J = t;
    }
  }
}
let ft = 0;
class x_ {
  constructor(n, t) {
    this.sub = n, this.dep = t, this.version = t.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class Sr {
  constructor(n) {
    this.computed = n, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0;
  }
  track(n) {
    if (!J || !Ae || J === this.computed)
      return;
    let t = this.activeLink;
    if (t === void 0 || t.sub !== J)
      t = this.activeLink = new x_(J, this), J.deps ? (t.prevDep = J.depsTail, J.depsTail.nextDep = t, J.depsTail = t) : J.deps = J.depsTail = t, Ba(t);
    else if (t.version === -1 && (t.version = this.version, t.nextDep)) {
      const s = t.nextDep;
      s.prevDep = t.prevDep, t.prevDep && (t.prevDep.nextDep = s), t.prevDep = J.depsTail, t.nextDep = void 0, J.depsTail.nextDep = t, J.depsTail = t, J.deps === t && (J.deps = s);
    }
    return t;
  }
  trigger(n) {
    this.version++, ft++, this.notify(n);
  }
  notify(n) {
    Nr();
    try {
      for (let t = this.subs; t; t = t.prevSub)
        t.sub.notify() && t.sub.dep.notify();
    } finally {
      Dr();
    }
  }
}
function Ba(e) {
  if (e.dep.sc++, e.sub.flags & 4) {
    const n = e.dep.computed;
    if (n && !e.dep.subs) {
      n.flags |= 20;
      for (let s = n.deps; s; s = s.nextDep)
        Ba(s);
    }
    const t = e.dep.subs;
    t !== e && (e.prevSub = t, t && (t.nextSub = e)), e.dep.subs = e;
  }
}
const Yt = /* @__PURE__ */ new WeakMap(), vn = Symbol(
  ""
), Ys = Symbol(
  ""
), gt = Symbol(
  ""
);
function pe(e, n, t) {
  if (Ae && J) {
    let s = Yt.get(e);
    s || Yt.set(e, s = /* @__PURE__ */ new Map());
    let r = s.get(t);
    r || (s.set(t, r = new Sr()), r.map = s, r.key = t), r.track();
  }
}
function $e(e, n, t, s, r, o) {
  const a = Yt.get(e);
  if (!a) {
    ft++;
    return;
  }
  const i = (_) => {
    _ && _.trigger();
  };
  if (Nr(), n === "clear")
    a.forEach(i);
  else {
    const _ = C(e), p = _ && yr(t);
    if (_ && t === "length") {
      const c = Number(s);
      a.forEach((d, g) => {
        (g === "length" || g === gt || !dn(g) && g >= c) && i(d);
      });
    } else
      switch ((t !== void 0 || a.has(void 0)) && i(a.get(t)), p && i(a.get(gt)), n) {
        case "add":
          _ ? p && i(a.get("length")) : (i(a.get(vn)), Ln(e) && i(a.get(Ys)));
          break;
        case "delete":
          _ || (i(a.get(vn)), Ln(e) && i(a.get(Ys)));
          break;
        case "set":
          Ln(e) && i(a.get(vn));
          break;
      }
  }
  Dr();
}
function B_(e, n) {
  const t = Yt.get(e);
  return t && t.get(n);
}
function Hn(e) {
  const n = F(e);
  return n === e ? n : (pe(n, "iterate", gt), Se(e) ? n : n.map(le));
}
function wr(e) {
  return pe(e = F(e), "iterate", gt), e;
}
const j_ = {
  __proto__: null,
  [Symbol.iterator]() {
    return Ds(this, Symbol.iterator, le);
  },
  concat(...e) {
    return Hn(this).concat(
      ...e.map((n) => C(n) ? Hn(n) : n)
    );
  },
  entries() {
    return Ds(this, "entries", (e) => (e[1] = le(e[1]), e));
  },
  every(e, n) {
    return Ve(this, "every", e, n, void 0, arguments);
  },
  filter(e, n) {
    return Ve(this, "filter", e, n, (t) => t.map(le), arguments);
  },
  find(e, n) {
    return Ve(this, "find", e, n, le, arguments);
  },
  findIndex(e, n) {
    return Ve(this, "findIndex", e, n, void 0, arguments);
  },
  findLast(e, n) {
    return Ve(this, "findLast", e, n, le, arguments);
  },
  findLastIndex(e, n) {
    return Ve(this, "findLastIndex", e, n, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(e, n) {
    return Ve(this, "forEach", e, n, void 0, arguments);
  },
  includes(...e) {
    return As(this, "includes", e);
  },
  indexOf(...e) {
    return As(this, "indexOf", e);
  },
  join(e) {
    return Hn(this).join(e);
  },
  // keys() iterator only reads `length`, no optimisation required
  lastIndexOf(...e) {
    return As(this, "lastIndexOf", e);
  },
  map(e, n) {
    return Ve(this, "map", e, n, void 0, arguments);
  },
  pop() {
    return Zn(this, "pop");
  },
  push(...e) {
    return Zn(this, "push", e);
  },
  reduce(e, ...n) {
    return fo(this, "reduce", e, n);
  },
  reduceRight(e, ...n) {
    return fo(this, "reduceRight", e, n);
  },
  shift() {
    return Zn(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(e, n) {
    return Ve(this, "some", e, n, void 0, arguments);
  },
  splice(...e) {
    return Zn(this, "splice", e);
  },
  toReversed() {
    return Hn(this).toReversed();
  },
  toSorted(e) {
    return Hn(this).toSorted(e);
  },
  toSpliced(...e) {
    return Hn(this).toSpliced(...e);
  },
  unshift(...e) {
    return Zn(this, "unshift", e);
  },
  values() {
    return Ds(this, "values", le);
  }
};
function Ds(e, n, t) {
  const s = wr(e), r = s[n]();
  return s !== e && !Se(e) && (r._next = r.next, r.next = () => {
    const o = r._next();
    return o.value && (o.value = t(o.value)), o;
  }), r;
}
const V_ = Array.prototype;
function Ve(e, n, t, s, r, o) {
  const a = wr(e), i = a !== e && !Se(e), _ = a[n];
  if (_ !== V_[n]) {
    const d = _.apply(e, o);
    return i ? le(d) : d;
  }
  let p = t;
  a !== e && (i ? p = function(d, g) {
    return t.call(this, le(d), g, e);
  } : t.length > 2 && (p = function(d, g) {
    return t.call(this, d, g, e);
  }));
  const c = _.call(a, p, s);
  return i && r ? r(c) : c;
}
function fo(e, n, t, s) {
  const r = wr(e);
  let o = t;
  return r !== e && (Se(e) ? t.length > 3 && (o = function(a, i, _) {
    return t.call(this, a, i, _, e);
  }) : o = function(a, i, _) {
    return t.call(this, a, le(i), _, e);
  }), r[n](o, ...s);
}
function As(e, n, t) {
  const s = F(e);
  pe(s, "iterate", gt);
  const r = s[n](...t);
  return (r === -1 || r === !1) && Cr(t[0]) ? (t[0] = F(t[0]), s[n](...t)) : r;
}
function Zn(e, n, t = []) {
  un(), Nr();
  const s = F(e)[n].apply(e, t);
  return Dr(), ln(), s;
}
const F_ = /* @__PURE__ */ vr("__proto__,__v_isRef,__isVue"), ja = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(dn)
);
function W_(e) {
  dn(e) || (e = String(e));
  const n = F(this);
  return pe(n, "has", e), n.hasOwnProperty(e);
}
class Va {
  constructor(n = !1, t = !1) {
    this._isReadonly = n, this._isShallow = t;
  }
  get(n, t, s) {
    if (t === "__v_skip")
      return n.__v_skip;
    const r = this._isReadonly, o = this._isShallow;
    if (t === "__v_isReactive")
      return !r;
    if (t === "__v_isReadonly")
      return r;
    if (t === "__v_isShallow")
      return o;
    if (t === "__v_raw")
      return s === (r ? o ? ep : Ka : o ? Ya : Wa).get(n) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(n) === Object.getPrototypeOf(s) ? n : void 0;
    const a = C(n);
    if (!r) {
      let _;
      if (a && (_ = j_[t]))
        return _;
      if (t === "hasOwnProperty")
        return W_;
    }
    const i = Reflect.get(
      n,
      t,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      te(n) ? n : s
    );
    return (dn(t) ? ja.has(t) : F_(t)) || (r || pe(n, "get", t), o) ? i : te(i) ? a && yr(t) ? i : i.value : Q(i) ? r ? Xa(i) : is(i) : i;
  }
}
class Fa extends Va {
  constructor(n = !1) {
    super(!1, n);
  }
  set(n, t, s, r) {
    let o = n[t];
    if (!this._isShallow) {
      const _ = yn(o);
      if (!Se(s) && !yn(s) && (o = F(o), s = F(s)), !C(n) && te(o) && !te(s))
        return _ ? !1 : (o.value = s, !0);
    }
    const a = C(n) && yr(t) ? Number(t) < n.length : W(n, t), i = Reflect.set(
      n,
      t,
      s,
      te(n) ? n : r
    );
    return n === F(r) && (a ? pn(s, o) && $e(n, "set", t, s) : $e(n, "add", t, s)), i;
  }
  deleteProperty(n, t) {
    const s = W(n, t);
    n[t];
    const r = Reflect.deleteProperty(n, t);
    return r && s && $e(n, "delete", t, void 0), r;
  }
  has(n, t) {
    const s = Reflect.has(n, t);
    return (!dn(t) || !ja.has(t)) && pe(n, "has", t), s;
  }
  ownKeys(n) {
    return pe(
      n,
      "iterate",
      C(n) ? "length" : vn
    ), Reflect.ownKeys(n);
  }
}
class Y_ extends Va {
  constructor(n = !1) {
    super(!0, n);
  }
  set(n, t) {
    return !0;
  }
  deleteProperty(n, t) {
    return !0;
  }
}
const K_ = /* @__PURE__ */ new Fa(), X_ = /* @__PURE__ */ new Y_(), $_ = /* @__PURE__ */ new Fa(!0);
const Ks = (e) => e, wt = (e) => Reflect.getPrototypeOf(e);
function J_(e, n, t) {
  return function(...s) {
    const r = this.__v_raw, o = F(r), a = Ln(o), i = e === "entries" || e === Symbol.iterator && a, _ = e === "keys" && a, p = r[e](...s), c = t ? Ks : n ? Xs : le;
    return !n && pe(
      o,
      "iterate",
      _ ? Ys : vn
    ), {
      // iterator protocol
      next() {
        const { value: d, done: g } = p.next();
        return g ? { value: d, done: g } : {
          value: i ? [c(d[0]), c(d[1])] : c(d),
          done: g
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function Ht(e) {
  return function(...n) {
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function z_(e, n) {
  const t = {
    get(r) {
      const o = this.__v_raw, a = F(o), i = F(r);
      e || (pn(r, i) && pe(a, "get", r), pe(a, "get", i));
      const { has: _ } = wt(a), p = n ? Ks : e ? Xs : le;
      if (_.call(a, r))
        return p(o.get(r));
      if (_.call(a, i))
        return p(o.get(i));
      o !== a && o.get(r);
    },
    get size() {
      const r = this.__v_raw;
      return !e && pe(F(r), "iterate", vn), Reflect.get(r, "size", r);
    },
    has(r) {
      const o = this.__v_raw, a = F(o), i = F(r);
      return e || (pn(r, i) && pe(a, "has", r), pe(a, "has", i)), r === i ? o.has(r) : o.has(r) || o.has(i);
    },
    forEach(r, o) {
      const a = this, i = a.__v_raw, _ = F(i), p = n ? Ks : e ? Xs : le;
      return !e && pe(_, "iterate", vn), i.forEach((c, d) => r.call(o, p(c), p(d), a));
    }
  };
  return se(
    t,
    e ? {
      add: Ht("add"),
      set: Ht("set"),
      delete: Ht("delete"),
      clear: Ht("clear")
    } : {
      add(r) {
        !n && !Se(r) && !yn(r) && (r = F(r));
        const o = F(this);
        return wt(o).has.call(o, r) || (o.add(r), $e(o, "add", r, r)), this;
      },
      set(r, o) {
        !n && !Se(o) && !yn(o) && (o = F(o));
        const a = F(this), { has: i, get: _ } = wt(a);
        let p = i.call(a, r);
        p || (r = F(r), p = i.call(a, r));
        const c = _.call(a, r);
        return a.set(r, o), p ? pn(o, c) && $e(a, "set", r, o) : $e(a, "add", r, o), this;
      },
      delete(r) {
        const o = F(this), { has: a, get: i } = wt(o);
        let _ = a.call(o, r);
        _ || (r = F(r), _ = a.call(o, r)), i && i.call(o, r);
        const p = o.delete(r);
        return _ && $e(o, "delete", r, void 0), p;
      },
      clear() {
        const r = F(this), o = r.size !== 0, a = r.clear();
        return o && $e(
          r,
          "clear",
          void 0,
          void 0
        ), a;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((r) => {
    t[r] = J_(r, e, n);
  }), t;
}
function Hr(e, n) {
  const t = z_(e, n);
  return (s, r, o) => r === "__v_isReactive" ? !e : r === "__v_isReadonly" ? e : r === "__v_raw" ? s : Reflect.get(
    W(t, r) && r in s ? t : s,
    r,
    o
  );
}
const q_ = {
  get: /* @__PURE__ */ Hr(!1, !1)
}, Z_ = {
  get: /* @__PURE__ */ Hr(!1, !0)
}, Q_ = {
  get: /* @__PURE__ */ Hr(!0, !1)
};
const Wa = /* @__PURE__ */ new WeakMap(), Ya = /* @__PURE__ */ new WeakMap(), Ka = /* @__PURE__ */ new WeakMap(), ep = /* @__PURE__ */ new WeakMap();
function np(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function tp(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : np(O_(e));
}
function is(e) {
  return yn(e) ? e : Ur(
    e,
    !1,
    K_,
    q_,
    Wa
  );
}
function sp(e) {
  return Ur(
    e,
    !1,
    $_,
    Z_,
    Ya
  );
}
function Xa(e) {
  return Ur(
    e,
    !0,
    X_,
    Q_,
    Ka
  );
}
function Ur(e, n, t, s, r) {
  if (!Q(e) || e.__v_raw && !(n && e.__v_isReactive))
    return e;
  const o = r.get(e);
  if (o)
    return o;
  const a = tp(e);
  if (a === 0)
    return e;
  const i = new Proxy(
    e,
    a === 2 ? s : t
  );
  return r.set(e, i), i;
}
function Tn(e) {
  return yn(e) ? Tn(e.__v_raw) : !!(e && e.__v_isReactive);
}
function yn(e) {
  return !!(e && e.__v_isReadonly);
}
function Se(e) {
  return !!(e && e.__v_isShallow);
}
function Cr(e) {
  return e ? !!e.__v_raw : !1;
}
function F(e) {
  const n = e && e.__v_raw;
  return n ? F(n) : e;
}
function Pr(e) {
  return !W(e, "__v_skip") && Object.isExtensible(e) && Oa(e, "__v_skip", !0), e;
}
const le = (e) => Q(e) ? is(e) : e, Xs = (e) => Q(e) ? Xa(e) : e;
function te(e) {
  return e ? e.__v_isRef === !0 : !1;
}
function _t(e) {
  return rp(e, !1);
}
function rp(e, n) {
  return te(e) ? e : new op(e, n);
}
class op {
  constructor(n, t) {
    this.dep = new Sr(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = t ? n : F(n), this._value = t ? n : le(n), this.__v_isShallow = t;
  }
  get value() {
    return this.dep.track(), this._value;
  }
  set value(n) {
    const t = this._rawValue, s = this.__v_isShallow || Se(n) || yn(n);
    n = s ? n : F(n), pn(n, t) && (this._rawValue = n, this._value = s ? n : le(n), this.dep.trigger());
  }
}
function $a(e) {
  return te(e) ? e.value : e;
}
const ap = {
  get: (e, n, t) => n === "__v_raw" ? e : $a(Reflect.get(e, n, t)),
  set: (e, n, t, s) => {
    const r = e[n];
    return te(r) && !te(t) ? (r.value = t, !0) : Reflect.set(e, n, t, s);
  }
};
function Ja(e) {
  return Tn(e) ? e : new Proxy(e, ap);
}
function ip(e) {
  const n = C(e) ? new Array(e.length) : {};
  for (const t in e)
    n[t] = pp(e, t);
  return n;
}
class _p {
  constructor(n, t, s) {
    this._object = n, this._key = t, this._defaultValue = s, this.__v_isRef = !0, this._value = void 0;
  }
  get value() {
    const n = this._object[this._key];
    return this._value = n === void 0 ? this._defaultValue : n;
  }
  set value(n) {
    this._object[this._key] = n;
  }
  get dep() {
    return B_(F(this._object), this._key);
  }
}
function pp(e, n, t) {
  const s = e[n];
  return te(s) ? s : new _p(e, n, t);
}
class cp {
  constructor(n, t, s) {
    this.fn = n, this.setter = t, this._value = void 0, this.dep = new Sr(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = ft - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !t, this.isSSR = s;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    J !== this)
      return Pa(this, !0), !0;
  }
  get value() {
    const n = this.dep.track();
    return Ga(this), n && (n.version = this.dep.version), this._value;
  }
  set value(n) {
    this.setter && this.setter(n);
  }
}
function dp(e, n, t = !1) {
  let s, r;
  return P(e) ? s = e : (s = e.get, r = e.set), new cp(s, r, t);
}
const Ut = {}, Kt = /* @__PURE__ */ new WeakMap();
let kn;
function up(e, n = !1, t = kn) {
  if (t) {
    let s = Kt.get(t);
    s || Kt.set(t, s = []), s.push(e);
  }
}
function lp(e, n, t = z) {
  const { immediate: s, deep: r, once: o, scheduler: a, augmentJob: i, call: _ } = t, p = (D) => r ? D : Se(D) || r === !1 || r === 0 ? rn(D, 1) : rn(D);
  let c, d, g, m, R = !1, y = !1;
  if (te(e) ? (d = () => e.value, R = Se(e)) : Tn(e) ? (d = () => p(e), R = !0) : C(e) ? (y = !0, R = e.some((D) => Tn(D) || Se(D)), d = () => e.map((D) => {
    if (te(D))
      return D.value;
    if (Tn(D))
      return p(D);
    if (P(D))
      return _ ? _(D, 2) : D();
  })) : P(e) ? n ? d = _ ? () => _(e, 2) : e : d = () => {
    if (g) {
      un();
      try {
        g();
      } finally {
        ln();
      }
    }
    const D = kn;
    kn = c;
    try {
      return _ ? _(e, 3, [m]) : e(m);
    } finally {
      kn = D;
    }
  } : d = Ne, n && r) {
    const D = d, j = r === !0 ? 1 / 0 : r;
    d = () => rn(D(), j);
  }
  const A = Ha(), w = () => {
    c.stop(), A && A.active && Rr(A.effects, c);
  };
  if (o && n) {
    const D = n;
    n = (...j) => {
      D(...j), w();
    };
  }
  let G = y ? new Array(e.length).fill(Ut) : Ut;
  const H = (D) => {
    if (!(!(c.flags & 1) || !c.dirty && !D))
      if (n) {
        const j = c.run();
        if (r || R || (y ? j.some((ce, ee) => pn(ce, G[ee])) : pn(j, G))) {
          g && g();
          const ce = kn;
          kn = c;
          try {
            const ee = [
              j,
              // pass undefined as the old value when it's changed for the first time
              G === Ut ? void 0 : y && G[0] === Ut ? [] : G,
              m
            ];
            _ ? _(n, 3, ee) : (
              // @ts-expect-error
              n(...ee)
            ), G = j;
          } finally {
            kn = ce;
          }
        }
      } else
        c.run();
  };
  return i && i(H), c = new Ua(d), c.scheduler = a ? () => a(H, !1) : H, m = (D) => up(D, !1, c), g = c.onStop = () => {
    const D = Kt.get(c);
    if (D) {
      if (_)
        _(D, 4);
      else
        for (const j of D)
          j();
      Kt.delete(c);
    }
  }, n ? s ? H(!0) : G = c.run() : a ? a(H.bind(null, !0), !0) : c.run(), w.pause = c.pause.bind(c), w.resume = c.resume.bind(c), w.stop = w, w;
}
function rn(e, n = 1 / 0, t) {
  if (n <= 0 || !Q(e) || e.__v_skip || (t = t || /* @__PURE__ */ new Set(), t.has(e)))
    return e;
  if (t.add(e), n--, te(e))
    rn(e.value, n, t);
  else if (C(e))
    for (let s = 0; s < e.length; s++)
      rn(e[s], n, t);
  else if (Ta(e) || Ln(e))
    e.forEach((s) => {
      rn(s, n, t);
    });
  else if (rs(e)) {
    for (const s in e)
      rn(e[s], n, t);
    for (const s of Object.getOwnPropertySymbols(e))
      Object.prototype.propertyIsEnumerable.call(e, s) && rn(e[s], n, t);
  }
  return e;
}
/**
* @vue/runtime-core v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function Rt(e, n, t, s) {
  try {
    return s ? e(...s) : e();
  } catch (r) {
    yt(r, n, t);
  }
}
function Be(e, n, t, s) {
  if (P(e)) {
    const r = Rt(e, n, t, s);
    return r && Ra(r) && r.catch((o) => {
      yt(o, n, t);
    }), r;
  }
  if (C(e)) {
    const r = [];
    for (let o = 0; o < e.length; o++)
      r.push(Be(e[o], n, t, s));
    return r;
  }
}
function yt(e, n, t, s = !0) {
  const r = n ? n.vnode : null, { errorHandler: o, throwUnhandledErrorInProduction: a } = n && n.appContext.config || z;
  if (n) {
    let i = n.parent;
    const _ = n.proxy, p = `https://vuejs.org/error-reference/#runtime-${t}`;
    for (; i; ) {
      const c = i.ec;
      if (c) {
        for (let d = 0; d < c.length; d++)
          if (c[d](e, _, p) === !1)
            return;
      }
      i = i.parent;
    }
    if (o) {
      un(), Rt(o, null, 10, [
        e,
        _,
        p
      ]), ln();
      return;
    }
  }
  mp(e, t, r, s, a);
}
function mp(e, n, t, s = !0, r = !1) {
  if (r)
    throw e;
  console.error(e);
}
const me = [];
let Me = -1;
const Gn = [];
let nn = null, Cn = 0;
const za = /* @__PURE__ */ Promise.resolve();
let Xt = null;
function Mr(e) {
  const n = Xt || za;
  return e ? n.then(this ? e.bind(this) : e) : n;
}
function fp(e) {
  let n = Me + 1, t = me.length;
  for (; n < t; ) {
    const s = n + t >>> 1, r = me[s], o = ht(r);
    o < e || o === e && r.flags & 2 ? n = s + 1 : t = s;
  }
  return n;
}
function Lr(e) {
  if (!(e.flags & 1)) {
    const n = ht(e), t = me[me.length - 1];
    !t || // fast path when the job id is larger than the tail
    !(e.flags & 2) && n >= ht(t) ? me.push(e) : me.splice(fp(n), 0, e), e.flags |= 1, qa();
  }
}
function qa() {
  Xt || (Xt = za.then(Qa));
}
function gp(e) {
  C(e) ? Gn.push(...e) : nn && e.id === -1 ? nn.splice(Cn + 1, 0, e) : e.flags & 1 || (Gn.push(e), e.flags |= 1), qa();
}
function go(e, n, t = Me + 1) {
  for (; t < me.length; t++) {
    const s = me[t];
    if (s && s.flags & 2) {
      if (e && s.id !== e.uid)
        continue;
      me.splice(t, 1), t--, s.flags & 4 && (s.flags &= -2), s(), s.flags & 4 || (s.flags &= -2);
    }
  }
}
function Za(e) {
  if (Gn.length) {
    const n = [...new Set(Gn)].sort(
      (t, s) => ht(t) - ht(s)
    );
    if (Gn.length = 0, nn) {
      nn.push(...n);
      return;
    }
    for (nn = n, Cn = 0; Cn < nn.length; Cn++) {
      const t = nn[Cn];
      t.flags & 4 && (t.flags &= -2), t.flags & 8 || t(), t.flags &= -2;
    }
    nn = null, Cn = 0;
  }
}
const ht = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function Qa(e) {
  const n = Ne;
  try {
    for (Me = 0; Me < me.length; Me++) {
      const t = me[Me];
      t && !(t.flags & 8) && (t.flags & 4 && (t.flags &= -2), Rt(
        t,
        t.i,
        t.i ? 15 : 14
      ), t.flags & 4 || (t.flags &= -2));
    }
  } finally {
    for (; Me < me.length; Me++) {
      const t = me[Me];
      t && (t.flags &= -2);
    }
    Me = -1, me.length = 0, Za(), Xt = null, (me.length || Gn.length) && Qa();
  }
}
let Oe = null, ei = null;
function $t(e) {
  const n = Oe;
  return Oe = e, ei = e && e.type.__scopeId || null, n;
}
function hp(e, n = Oe, t) {
  if (!n || e._n)
    return e;
  const s = (...r) => {
    s._d && Io(-1);
    const o = $t(n);
    let a;
    try {
      a = e(...r);
    } finally {
      $t(o), s._d && Io(1);
    }
    return a;
  };
  return s._n = !0, s._c = !0, s._d = !0, s;
}
function hn(e, n, t, s) {
  const r = e.dirs, o = n && n.dirs;
  for (let a = 0; a < r.length; a++) {
    const i = r[a];
    o && (i.oldValue = o[a].value);
    let _ = i.dir[s];
    _ && (un(), Be(_, t, 8, [
      e.el,
      i,
      e,
      n
    ]), ln());
  }
}
const Ep = Symbol("_vte"), bp = (e) => e.__isTeleport;
function Gr(e, n) {
  e.shapeFlag & 6 && e.component ? (e.transition = n, Gr(e.component.subTree, n)) : e.shapeFlag & 128 ? (e.ssContent.transition = n.clone(e.ssContent), e.ssFallback.transition = n.clone(e.ssFallback)) : e.transition = n;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function ni(e, n) {
  return P(e) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (() => se({ name: e.name }, n, { setup: e }))()
  ) : e;
}
function xr(e) {
  e.ids = [e.ids[0] + e.ids[2]++ + "-", 0, 0];
}
function Jt(e, n, t, s, r = !1) {
  if (C(e)) {
    e.forEach(
      (R, y) => Jt(
        R,
        n && (C(n) ? n[y] : n),
        t,
        s,
        r
      )
    );
    return;
  }
  if (pt(s) && !r) {
    s.shapeFlag & 512 && s.type.__asyncResolved && s.component.subTree.component && Jt(e, n, t, s.component.subTree);
    return;
  }
  const o = s.shapeFlag & 4 ? Wr(s.component) : s.el, a = r ? null : o, { i, r: _ } = e, p = n && n.r, c = i.refs === z ? i.refs = {} : i.refs, d = i.setupState, g = F(d), m = d === z ? () => !1 : (R) => W(g, R);
  if (p != null && p !== _ && (oe(p) ? (c[p] = null, m(p) && (d[p] = null)) : te(p) && (p.value = null)), P(_))
    Rt(_, i, 12, [a, c]);
  else {
    const R = oe(_), y = te(_);
    if (R || y) {
      const A = () => {
        if (e.f) {
          const w = R ? m(_) ? d[_] : c[_] : _.value;
          r ? C(w) && Rr(w, o) : C(w) ? w.includes(o) || w.push(o) : R ? (c[_] = [o], m(_) && (d[_] = c[_])) : (_.value = [o], e.k && (c[e.k] = _.value));
        } else
          R ? (c[_] = a, m(_) && (d[_] = a)) : y && (_.value = a, e.k && (c[e.k] = a));
      };
      a ? (A.id = -1, be(A, t)) : A();
    }
  }
}
const ho = (e) => e.nodeType === 8;
as().requestIdleCallback;
as().cancelIdleCallback;
function kp(e, n) {
  if (ho(e) && e.data === "[") {
    let t = 1, s = e.nextSibling;
    for (; s; ) {
      if (s.nodeType === 1) {
        if (n(s) === !1)
          break;
      } else if (ho(s))
        if (s.data === "]") {
          if (--t === 0)
            break;
        } else
          s.data === "[" && t++;
      s = s.nextSibling;
    }
  } else
    n(e);
}
const pt = (e) => !!e.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function _s(e) {
  P(e) && (e = { loader: e });
  const {
    loader: n,
    loadingComponent: t,
    errorComponent: s,
    delay: r = 200,
    hydrate: o,
    timeout: a,
    // undefined = never times out
    suspensible: i = !0,
    onError: _
  } = e;
  let p = null, c, d = 0;
  const g = () => (d++, p = null, m()), m = () => {
    let R;
    return p || (R = p = n().catch((y) => {
      if (y = y instanceof Error ? y : new Error(String(y)), _)
        return new Promise((A, w) => {
          _(y, () => A(g()), () => w(y), d + 1);
        });
      throw y;
    }).then((y) => R !== p && p ? p : (y && (y.__esModule || y[Symbol.toStringTag] === "Module") && (y = y.default), c = y, y)));
  };
  return /* @__PURE__ */ ni({
    name: "AsyncComponentWrapper",
    __asyncLoader: m,
    __asyncHydrate(R, y, A) {
      const w = o ? () => {
        const G = o(
          A,
          (H) => kp(R, H)
        );
        G && (y.bum || (y.bum = [])).push(G);
      } : A;
      c ? w() : m().then(() => !y.isUnmounted && w());
    },
    get __asyncResolved() {
      return c;
    },
    setup() {
      const R = ae;
      if (xr(R), c)
        return () => Ss(c, R);
      const y = (H) => {
        p = null, yt(
          H,
          R,
          13,
          !s
        );
      };
      if (i && R.suspense || Vn)
        return m().then((H) => () => Ss(H, R)).catch((H) => (y(H), () => s ? fe(s, {
          error: H
        }) : null));
      const A = _t(!1), w = _t(), G = _t(!!r);
      return r && setTimeout(() => {
        G.value = !1;
      }, r), a != null && setTimeout(() => {
        if (!A.value && !w.value) {
          const H = new Error(
            `Async component timed out after ${a}ms.`
          );
          y(H), w.value = H;
        }
      }, a), m().then(() => {
        A.value = !0, R.parent && Br(R.parent.vnode) && R.parent.update();
      }).catch((H) => {
        y(H), w.value = H;
      }), () => {
        if (A.value && c)
          return Ss(c, R);
        if (w.value && s)
          return fe(s, {
            error: w.value
          });
        if (t && !G.value)
          return fe(t);
      };
    }
  });
}
function Ss(e, n) {
  const { ref: t, props: s, children: r, ce: o } = n.vnode, a = fe(e, s, r);
  return a.ref = t, a.ce = o, delete n.vnode.ce, a;
}
const Br = (e) => e.type.__isKeepAlive;
function vp(e, n) {
  ti(e, "a", n);
}
function Tp(e, n) {
  ti(e, "da", n);
}
function ti(e, n, t = ae) {
  const s = e.__wdc || (e.__wdc = () => {
    let r = t;
    for (; r; ) {
      if (r.isDeactivated)
        return;
      r = r.parent;
    }
    return e();
  });
  if (ps(n, s, t), t) {
    let r = t.parent;
    for (; r && r.parent; )
      Br(r.parent.vnode) && Rp(s, n, t, r), r = r.parent;
  }
}
function Rp(e, n, t, s) {
  const r = ps(
    n,
    e,
    s,
    !0
    /* prepend */
  );
  si(() => {
    Rr(s[n], r);
  }, t);
}
function ps(e, n, t = ae, s = !1) {
  if (t) {
    const r = t[e] || (t[e] = []), o = n.__weh || (n.__weh = (...a) => {
      un();
      const i = It(t), _ = Be(n, t, e, a);
      return i(), ln(), _;
    });
    return s ? r.unshift(o) : r.push(o), o;
  }
}
const Ze = (e) => (n, t = ae) => {
  (!Vn || e === "sp") && ps(e, (...s) => n(...s), t);
}, yp = Ze("bm"), Ip = Ze("m"), Op = Ze(
  "bu"
), Np = Ze("u"), Dp = Ze(
  "bum"
), si = Ze("um"), Ap = Ze(
  "sp"
), Sp = Ze("rtg"), wp = Ze("rtc");
function Hp(e, n = ae) {
  ps("ec", e, n);
}
const Up = Symbol.for("v-ndc"), $s = (e) => e ? Ii(e) ? Wr(e) : $s(e.parent) : null, ct = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ se(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => e.props,
    $attrs: (e) => e.attrs,
    $slots: (e) => e.slots,
    $refs: (e) => e.refs,
    $parent: (e) => $s(e.parent),
    $root: (e) => $s(e.root),
    $host: (e) => e.ce,
    $emit: (e) => e.emit,
    $options: (e) => jr(e),
    $forceUpdate: (e) => e.f || (e.f = () => {
      Lr(e.update);
    }),
    $nextTick: (e) => e.n || (e.n = Mr.bind(e.proxy)),
    $watch: (e) => tc.bind(e)
  })
), ws = (e, n) => e !== z && !e.__isScriptSetup && W(e, n), Cp = {
  get({ _: e }, n) {
    if (n === "__v_skip")
      return !0;
    const { ctx: t, setupState: s, data: r, props: o, accessCache: a, type: i, appContext: _ } = e;
    let p;
    if (n[0] !== "$") {
      const m = a[n];
      if (m !== void 0)
        switch (m) {
          case 1:
            return s[n];
          case 2:
            return r[n];
          case 4:
            return t[n];
          case 3:
            return o[n];
        }
      else {
        if (ws(s, n))
          return a[n] = 1, s[n];
        if (r !== z && W(r, n))
          return a[n] = 2, r[n];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (p = e.propsOptions[0]) && W(p, n)
        )
          return a[n] = 3, o[n];
        if (t !== z && W(t, n))
          return a[n] = 4, t[n];
        Js && (a[n] = 0);
      }
    }
    const c = ct[n];
    let d, g;
    if (c)
      return n === "$attrs" && pe(e.attrs, "get", ""), c(e);
    if (
      // css module (injected by vue-loader)
      (d = i.__cssModules) && (d = d[n])
    )
      return d;
    if (t !== z && W(t, n))
      return a[n] = 4, t[n];
    if (
      // global properties
      g = _.config.globalProperties, W(g, n)
    )
      return g[n];
  },
  set({ _: e }, n, t) {
    const { data: s, setupState: r, ctx: o } = e;
    return ws(r, n) ? (r[n] = t, !0) : s !== z && W(s, n) ? (s[n] = t, !0) : W(e.props, n) || n[0] === "$" && n.slice(1) in e ? !1 : (o[n] = t, !0);
  },
  has({
    _: { data: e, setupState: n, accessCache: t, ctx: s, appContext: r, propsOptions: o }
  }, a) {
    let i;
    return !!t[a] || e !== z && W(e, a) || ws(n, a) || (i = o[0]) && W(i, a) || W(s, a) || W(ct, a) || W(r.config.globalProperties, a);
  },
  defineProperty(e, n, t) {
    return t.get != null ? e._.accessCache[n] = 0 : W(t, "value") && this.set(e, n, t.value, null), Reflect.defineProperty(e, n, t);
  }
};
function Eo(e) {
  return C(e) ? e.reduce(
    (n, t) => (n[t] = null, n),
    {}
  ) : e;
}
let Js = !0;
function Pp(e) {
  const n = jr(e), t = e.proxy, s = e.ctx;
  Js = !1, n.beforeCreate && bo(n.beforeCreate, e, "bc");
  const {
    // state
    data: r,
    computed: o,
    methods: a,
    watch: i,
    provide: _,
    inject: p,
    // lifecycle
    created: c,
    beforeMount: d,
    mounted: g,
    beforeUpdate: m,
    updated: R,
    activated: y,
    deactivated: A,
    beforeDestroy: w,
    beforeUnmount: G,
    destroyed: H,
    unmounted: D,
    render: j,
    renderTracked: ce,
    renderTriggered: ee,
    errorCaptured: x,
    serverPrefetch: V,
    // public API
    expose: re,
    inheritAttrs: ve,
    // assets
    components: He,
    directives: Qe,
    filters: Jn
  } = n;
  if (p && Mp(p, s, null), a)
    for (const L in a) {
      const X = a[L];
      P(X) && (s[L] = X.bind(t));
    }
  if (r) {
    const L = r.call(t, t);
    Q(L) && (e.data = is(L));
  }
  if (Js = !0, o)
    for (const L in o) {
      const X = o[L], fn = P(X) ? X.bind(t, t) : P(X.get) ? X.get.bind(t, t) : Ne, At = !P(X) && P(X.set) ? X.set.bind(t) : Ne, gn = lt({
        get: fn,
        set: At
      });
      Object.defineProperty(s, L, {
        enumerable: !0,
        configurable: !0,
        get: () => gn.value,
        set: (Ue) => gn.value = Ue
      });
    }
  if (i)
    for (const L in i)
      ri(i[L], s, t, L);
  if (_) {
    const L = P(_) ? _.call(t) : _;
    Reflect.ownKeys(L).forEach((X) => {
      Vp(X, L[X]);
    });
  }
  c && bo(c, e, "c");
  function ne(L, X) {
    C(X) ? X.forEach((fn) => L(fn.bind(t))) : X && L(X.bind(t));
  }
  if (ne(yp, d), ne(Ip, g), ne(Op, m), ne(Np, R), ne(vp, y), ne(Tp, A), ne(Hp, x), ne(wp, ce), ne(Sp, ee), ne(Dp, G), ne(si, D), ne(Ap, V), C(re))
    if (re.length) {
      const L = e.exposed || (e.exposed = {});
      re.forEach((X) => {
        Object.defineProperty(L, X, {
          get: () => t[X],
          set: (fn) => t[X] = fn
        });
      });
    } else
      e.exposed || (e.exposed = {});
  j && e.render === Ne && (e.render = j), ve != null && (e.inheritAttrs = ve), He && (e.components = He), Qe && (e.directives = Qe), V && xr(e);
}
function Mp(e, n, t = Ne) {
  C(e) && (e = zs(e));
  for (const s in e) {
    const r = e[s];
    let o;
    Q(r) ? "default" in r ? o = dt(
      r.from || s,
      r.default,
      !0
    ) : o = dt(r.from || s) : o = dt(r), te(o) ? Object.defineProperty(n, s, {
      enumerable: !0,
      configurable: !0,
      get: () => o.value,
      set: (a) => o.value = a
    }) : n[s] = o;
  }
}
function bo(e, n, t) {
  Be(
    C(e) ? e.map((s) => s.bind(n.proxy)) : e.bind(n.proxy),
    n,
    t
  );
}
function ri(e, n, t, s) {
  let r = s.includes(".") ? Ei(t, s) : () => t[s];
  if (oe(e)) {
    const o = n[e];
    P(o) && jt(r, o);
  } else if (P(e))
    jt(r, e.bind(t));
  else if (Q(e))
    if (C(e))
      e.forEach((o) => ri(o, n, t, s));
    else {
      const o = P(e.handler) ? e.handler.bind(t) : n[e.handler];
      P(o) && jt(r, o, e);
    }
}
function jr(e) {
  const n = e.type, { mixins: t, extends: s } = n, {
    mixins: r,
    optionsCache: o,
    config: { optionMergeStrategies: a }
  } = e.appContext, i = o.get(n);
  let _;
  return i ? _ = i : !r.length && !t && !s ? _ = n : (_ = {}, r.length && r.forEach(
    (p) => zt(_, p, a, !0)
  ), zt(_, n, a)), Q(n) && o.set(n, _), _;
}
function zt(e, n, t, s = !1) {
  const { mixins: r, extends: o } = n;
  o && zt(e, o, t, !0), r && r.forEach(
    (a) => zt(e, a, t, !0)
  );
  for (const a in n)
    if (!(s && a === "expose")) {
      const i = Lp[a] || t && t[a];
      e[a] = i ? i(e[a], n[a]) : n[a];
    }
  return e;
}
const Lp = {
  data: ko,
  props: vo,
  emits: vo,
  // objects
  methods: tt,
  computed: tt,
  // lifecycle
  beforeCreate: de,
  created: de,
  beforeMount: de,
  mounted: de,
  beforeUpdate: de,
  updated: de,
  beforeDestroy: de,
  beforeUnmount: de,
  destroyed: de,
  unmounted: de,
  activated: de,
  deactivated: de,
  errorCaptured: de,
  serverPrefetch: de,
  // assets
  components: tt,
  directives: tt,
  // watch
  watch: xp,
  // provide / inject
  provide: ko,
  inject: Gp
};
function ko(e, n) {
  return n ? e ? function() {
    return se(
      P(e) ? e.call(this, this) : e,
      P(n) ? n.call(this, this) : n
    );
  } : n : e;
}
function Gp(e, n) {
  return tt(zs(e), zs(n));
}
function zs(e) {
  if (C(e)) {
    const n = {};
    for (let t = 0; t < e.length; t++)
      n[e[t]] = e[t];
    return n;
  }
  return e;
}
function de(e, n) {
  return e ? [...new Set([].concat(e, n))] : n;
}
function tt(e, n) {
  return e ? se(/* @__PURE__ */ Object.create(null), e, n) : n;
}
function vo(e, n) {
  return e ? C(e) && C(n) ? [.../* @__PURE__ */ new Set([...e, ...n])] : se(
    /* @__PURE__ */ Object.create(null),
    Eo(e),
    Eo(n ?? {})
  ) : n;
}
function xp(e, n) {
  if (!e)
    return n;
  if (!n)
    return e;
  const t = se(/* @__PURE__ */ Object.create(null), e);
  for (const s in n)
    t[s] = de(e[s], n[s]);
  return t;
}
function oi() {
  return {
    app: null,
    config: {
      isNativeTag: y_,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let Bp = 0;
function jp(e, n) {
  return function(s, r = null) {
    P(s) || (s = se({}, s)), r != null && !Q(r) && (r = null);
    const o = oi(), a = /* @__PURE__ */ new WeakSet(), i = [];
    let _ = !1;
    const p = o.app = {
      _uid: Bp++,
      _component: s,
      _props: r,
      _container: null,
      _context: o,
      _instance: null,
      version: Ic,
      get config() {
        return o.config;
      },
      set config(c) {
      },
      use(c, ...d) {
        return a.has(c) || (c && P(c.install) ? (a.add(c), c.install(p, ...d)) : P(c) && (a.add(c), c(p, ...d))), p;
      },
      mixin(c) {
        return o.mixins.includes(c) || o.mixins.push(c), p;
      },
      component(c, d) {
        return d ? (o.components[c] = d, p) : o.components[c];
      },
      directive(c, d) {
        return d ? (o.directives[c] = d, p) : o.directives[c];
      },
      mount(c, d, g) {
        if (!_) {
          const m = p._ceVNode || fe(s, r);
          return m.appContext = o, g === !0 ? g = "svg" : g === !1 && (g = void 0), d && n ? n(m, c) : e(m, c, g), _ = !0, p._container = c, c.__vue_app__ = p, Wr(m.component);
        }
      },
      onUnmount(c) {
        i.push(c);
      },
      unmount() {
        _ && (Be(
          i,
          p._instance,
          16
        ), e(null, p._container), delete p._container.__vue_app__);
      },
      provide(c, d) {
        return o.provides[c] = d, p;
      },
      runWithContext(c) {
        const d = Rn;
        Rn = p;
        try {
          return c();
        } finally {
          Rn = d;
        }
      }
    };
    return p;
  };
}
let Rn = null;
function Vp(e, n) {
  if (ae) {
    let t = ae.provides;
    const s = ae.parent && ae.parent.provides;
    s === t && (t = ae.provides = Object.create(s)), t[e] = n;
  }
}
function dt(e, n, t = !1) {
  const s = ae || Oe;
  if (s || Rn) {
    const r = Rn ? Rn._context.provides : s ? s.parent == null ? s.vnode.appContext && s.vnode.appContext.provides : s.parent.provides : void 0;
    if (r && e in r)
      return r[e];
    if (arguments.length > 1)
      return t && P(n) ? n.call(s && s.proxy) : n;
  }
}
function Fp() {
  return !!(ae || Oe || Rn);
}
const ai = {}, ii = () => Object.create(ai), _i = (e) => Object.getPrototypeOf(e) === ai;
function Wp(e, n, t, s = !1) {
  const r = {}, o = ii();
  e.propsDefaults = /* @__PURE__ */ Object.create(null), pi(e, n, r, o);
  for (const a in e.propsOptions[0])
    a in r || (r[a] = void 0);
  t ? e.props = s ? r : sp(r) : e.type.props ? e.props = r : e.props = o, e.attrs = o;
}
function Yp(e, n, t, s) {
  const {
    props: r,
    attrs: o,
    vnode: { patchFlag: a }
  } = e, i = F(r), [_] = e.propsOptions;
  let p = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (s || a > 0) && !(a & 16)
  ) {
    if (a & 8) {
      const c = e.vnode.dynamicProps;
      for (let d = 0; d < c.length; d++) {
        let g = c[d];
        if (cs(e.emitsOptions, g))
          continue;
        const m = n[g];
        if (_)
          if (W(o, g))
            m !== o[g] && (o[g] = m, p = !0);
          else {
            const R = De(g);
            r[R] = qs(
              _,
              i,
              R,
              m,
              e,
              !1
            );
          }
        else
          m !== o[g] && (o[g] = m, p = !0);
      }
    }
  } else {
    pi(e, n, r, o) && (p = !0);
    let c;
    for (const d in i)
      (!n || // for camelCase
      !W(n, d) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((c = Re(d)) === d || !W(n, c))) && (_ ? t && // for camelCase
      (t[d] !== void 0 || // for kebab-case
      t[c] !== void 0) && (r[d] = qs(
        _,
        i,
        d,
        void 0,
        e,
        !0
      )) : delete r[d]);
    if (o !== i)
      for (const d in o)
        (!n || !W(n, d)) && (delete o[d], p = !0);
  }
  p && $e(e.attrs, "set", "");
}
function pi(e, n, t, s) {
  const [r, o] = e.propsOptions;
  let a = !1, i;
  if (n)
    for (let _ in n) {
      if (ot(_))
        continue;
      const p = n[_];
      let c;
      r && W(r, c = De(_)) ? !o || !o.includes(c) ? t[c] = p : (i || (i = {}))[c] = p : cs(e.emitsOptions, _) || (!(_ in s) || p !== s[_]) && (s[_] = p, a = !0);
    }
  if (o) {
    const _ = F(t), p = i || z;
    for (let c = 0; c < o.length; c++) {
      const d = o[c];
      t[d] = qs(
        r,
        _,
        d,
        p[d],
        e,
        !W(p, d)
      );
    }
  }
  return a;
}
function qs(e, n, t, s, r, o) {
  const a = e[t];
  if (a != null) {
    const i = W(a, "default");
    if (i && s === void 0) {
      const _ = a.default;
      if (a.type !== Function && !a.skipFactory && P(_)) {
        const { propsDefaults: p } = r;
        if (t in p)
          s = p[t];
        else {
          const c = It(r);
          s = p[t] = _.call(
            null,
            n
          ), c();
        }
      } else
        s = _;
      r.ce && r.ce._setProp(t, s);
    }
    a[
      0
      /* shouldCast */
    ] && (o && !i ? s = !1 : a[
      1
      /* shouldCastTrue */
    ] && (s === "" || s === Re(t)) && (s = !0));
  }
  return s;
}
const Kp = /* @__PURE__ */ new WeakMap();
function ci(e, n, t = !1) {
  const s = t ? Kp : n.propsCache, r = s.get(e);
  if (r)
    return r;
  const o = e.props, a = {}, i = [];
  let _ = !1;
  if (!P(e)) {
    const c = (d) => {
      _ = !0;
      const [g, m] = ci(d, n, !0);
      se(a, g), m && i.push(...m);
    };
    !t && n.mixins.length && n.mixins.forEach(c), e.extends && c(e.extends), e.mixins && e.mixins.forEach(c);
  }
  if (!o && !_)
    return Q(e) && s.set(e, Mn), Mn;
  if (C(o))
    for (let c = 0; c < o.length; c++) {
      const d = De(o[c]);
      To(d) && (a[d] = z);
    }
  else if (o)
    for (const c in o) {
      const d = De(c);
      if (To(d)) {
        const g = o[c], m = a[d] = C(g) || P(g) ? { type: g } : se({}, g), R = m.type;
        let y = !1, A = !0;
        if (C(R))
          for (let w = 0; w < R.length; ++w) {
            const G = R[w], H = P(G) && G.name;
            if (H === "Boolean") {
              y = !0;
              break;
            } else
              H === "String" && (A = !1);
          }
        else
          y = P(R) && R.name === "Boolean";
        m[
          0
          /* shouldCast */
        ] = y, m[
          1
          /* shouldCastTrue */
        ] = A, (y || W(m, "default")) && i.push(d);
      }
    }
  const p = [a, i];
  return Q(e) && s.set(e, p), p;
}
function To(e) {
  return e[0] !== "$" && !ot(e);
}
const di = (e) => e[0] === "_" || e === "$stable", Vr = (e) => C(e) ? e.map(Le) : [Le(e)], Xp = (e, n, t) => {
  if (n._n)
    return n;
  const s = hp((...r) => Vr(n(...r)), t);
  return s._c = !1, s;
}, ui = (e, n, t) => {
  const s = e._ctx;
  for (const r in e) {
    if (di(r))
      continue;
    const o = e[r];
    if (P(o))
      n[r] = Xp(r, o, s);
    else if (o != null) {
      const a = Vr(o);
      n[r] = () => a;
    }
  }
}, li = (e, n) => {
  const t = Vr(n);
  e.slots.default = () => t;
}, mi = (e, n, t) => {
  for (const s in n)
    (t || s !== "_") && (e[s] = n[s]);
}, $p = (e, n, t) => {
  const s = e.slots = ii();
  if (e.vnode.shapeFlag & 32) {
    const r = n._;
    r ? (mi(s, n, t), t && Oa(s, "_", r, !0)) : ui(n, s);
  } else
    n && li(e, n);
}, Jp = (e, n, t) => {
  const { vnode: s, slots: r } = e;
  let o = !0, a = z;
  if (s.shapeFlag & 32) {
    const i = n._;
    i ? t && i === 1 ? o = !1 : mi(r, n, t) : (o = !n.$stable, ui(n, r)), a = n;
  } else
    n && (li(e, n), a = { default: 1 });
  if (o)
    for (const i in r)
      !di(i) && a[i] == null && delete r[i];
}, be = pc;
function zp(e) {
  return qp(e);
}
function qp(e, n) {
  const t = as();
  t.__VUE__ = !0;
  const {
    insert: s,
    remove: r,
    patchProp: o,
    createElement: a,
    createText: i,
    createComment: _,
    setText: p,
    setElementText: c,
    parentNode: d,
    nextSibling: g,
    setScopeId: m = Ne,
    insertStaticContent: R
  } = e, y = (u, l, f, b = null, h = null, E = null, I = void 0, T = null, v = !!l.dynamicChildren) => {
    if (u === l)
      return;
    u && !Qn(u, l) && (b = St(u), Ue(u, h, E, !0), u = null), l.patchFlag === -2 && (v = !1, l.dynamicChildren = null);
    const { type: k, ref: S, shapeFlag: O } = l;
    switch (k) {
      case ds:
        A(u, l, f, b);
        break;
      case In:
        w(u, l, f, b);
        break;
      case Cs:
        u == null && G(l, f, b, I);
        break;
      case Ke:
        He(
          u,
          l,
          f,
          b,
          h,
          E,
          I,
          T,
          v
        );
        break;
      default:
        O & 1 ? j(
          u,
          l,
          f,
          b,
          h,
          E,
          I,
          T,
          v
        ) : O & 6 ? Qe(
          u,
          l,
          f,
          b,
          h,
          E,
          I,
          T,
          v
        ) : (O & 64 || O & 128) && k.process(
          u,
          l,
          f,
          b,
          h,
          E,
          I,
          T,
          v,
          wn
        );
    }
    S != null && h && Jt(S, u && u.ref, E, l || u, !l);
  }, A = (u, l, f, b) => {
    if (u == null)
      s(
        l.el = i(l.children),
        f,
        b
      );
    else {
      const h = l.el = u.el;
      l.children !== u.children && p(h, l.children);
    }
  }, w = (u, l, f, b) => {
    u == null ? s(
      l.el = _(l.children || ""),
      f,
      b
    ) : l.el = u.el;
  }, G = (u, l, f, b) => {
    [u.el, u.anchor] = R(
      u.children,
      l,
      f,
      b,
      u.el,
      u.anchor
    );
  }, H = ({ el: u, anchor: l }, f, b) => {
    let h;
    for (; u && u !== l; )
      h = g(u), s(u, f, b), u = h;
    s(l, f, b);
  }, D = ({ el: u, anchor: l }) => {
    let f;
    for (; u && u !== l; )
      f = g(u), r(u), u = f;
    r(l);
  }, j = (u, l, f, b, h, E, I, T, v) => {
    l.type === "svg" ? I = "svg" : l.type === "math" && (I = "mathml"), u == null ? ce(
      l,
      f,
      b,
      h,
      E,
      I,
      T,
      v
    ) : V(
      u,
      l,
      h,
      E,
      I,
      T,
      v
    );
  }, ce = (u, l, f, b, h, E, I, T) => {
    let v, k;
    const { props: S, shapeFlag: O, transition: N, dirs: U } = u;
    if (v = u.el = a(
      u.type,
      E,
      S && S.is,
      S
    ), O & 8 ? c(v, u.children) : O & 16 && x(
      u.children,
      v,
      null,
      b,
      h,
      Hs(u, E),
      I,
      T
    ), U && hn(u, null, b, "created"), ee(v, u, u.scopeId, I, b), S) {
      for (const $ in S)
        $ !== "value" && !ot($) && o(v, $, null, S[$], E, b);
      "value" in S && o(v, "value", null, S.value, E), (k = S.onVnodeBeforeMount) && Pe(k, b, u);
    }
    U && hn(u, null, b, "beforeMount");
    const B = Zp(h, N);
    B && N.beforeEnter(v), s(v, l, f), ((k = S && S.onVnodeMounted) || B || U) && be(() => {
      k && Pe(k, b, u), B && N.enter(v), U && hn(u, null, b, "mounted");
    }, h);
  }, ee = (u, l, f, b, h) => {
    if (f && m(u, f), b)
      for (let E = 0; E < b.length; E++)
        m(u, b[E]);
    if (h) {
      let E = h.subTree;
      if (l === E || ki(E.type) && (E.ssContent === l || E.ssFallback === l)) {
        const I = h.vnode;
        ee(
          u,
          I,
          I.scopeId,
          I.slotScopeIds,
          h.parent
        );
      }
    }
  }, x = (u, l, f, b, h, E, I, T, v = 0) => {
    for (let k = v; k < u.length; k++) {
      const S = u[k] = T ? tn(u[k]) : Le(u[k]);
      y(
        null,
        S,
        l,
        f,
        b,
        h,
        E,
        I,
        T
      );
    }
  }, V = (u, l, f, b, h, E, I) => {
    const T = l.el = u.el;
    let { patchFlag: v, dynamicChildren: k, dirs: S } = l;
    v |= u.patchFlag & 16;
    const O = u.props || z, N = l.props || z;
    let U;
    if (f && En(f, !1), (U = N.onVnodeBeforeUpdate) && Pe(U, f, l, u), S && hn(l, u, f, "beforeUpdate"), f && En(f, !0), (O.innerHTML && N.innerHTML == null || O.textContent && N.textContent == null) && c(T, ""), k ? re(
      u.dynamicChildren,
      k,
      T,
      f,
      b,
      Hs(l, h),
      E
    ) : I || X(
      u,
      l,
      T,
      null,
      f,
      b,
      Hs(l, h),
      E,
      !1
    ), v > 0) {
      if (v & 16)
        ve(T, O, N, f, h);
      else if (v & 2 && O.class !== N.class && o(T, "class", null, N.class, h), v & 4 && o(T, "style", O.style, N.style, h), v & 8) {
        const B = l.dynamicProps;
        for (let $ = 0; $ < B.length; $++) {
          const Y = B[$], ge = O[Y], _e = N[Y];
          (_e !== ge || Y === "value") && o(T, Y, ge, _e, h, f);
        }
      }
      v & 1 && u.children !== l.children && c(T, l.children);
    } else
      !I && k == null && ve(T, O, N, f, h);
    ((U = N.onVnodeUpdated) || S) && be(() => {
      U && Pe(U, f, l, u), S && hn(l, u, f, "updated");
    }, b);
  }, re = (u, l, f, b, h, E, I) => {
    for (let T = 0; T < l.length; T++) {
      const v = u[T], k = l[T], S = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        v.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (v.type === Ke || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Qn(v, k) || // - In the case of a component, it could contain anything.
        v.shapeFlag & 70) ? d(v.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          f
        )
      );
      y(
        v,
        k,
        S,
        null,
        b,
        h,
        E,
        I,
        !0
      );
    }
  }, ve = (u, l, f, b, h) => {
    if (l !== f) {
      if (l !== z)
        for (const E in l)
          !ot(E) && !(E in f) && o(
            u,
            E,
            l[E],
            null,
            h,
            b
          );
      for (const E in f) {
        if (ot(E))
          continue;
        const I = f[E], T = l[E];
        I !== T && E !== "value" && o(u, E, T, I, h, b);
      }
      "value" in f && o(u, "value", l.value, f.value, h);
    }
  }, He = (u, l, f, b, h, E, I, T, v) => {
    const k = l.el = u ? u.el : i(""), S = l.anchor = u ? u.anchor : i("");
    let { patchFlag: O, dynamicChildren: N, slotScopeIds: U } = l;
    U && (T = T ? T.concat(U) : U), u == null ? (s(k, f, b), s(S, f, b), x(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      l.children || [],
      f,
      S,
      h,
      E,
      I,
      T,
      v
    )) : O > 0 && O & 64 && N && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    u.dynamicChildren ? (re(
      u.dynamicChildren,
      N,
      f,
      h,
      E,
      I,
      T
    ), // #2080 if the stable fragment has a key, it's a <template v-for> that may
    //  get moved around. Make sure all root level vnodes inherit el.
    // #2134 or if it's a component root, it may also get moved around
    // as the component is being moved.
    (l.key != null || h && l === h.subTree) && fi(
      u,
      l,
      !0
      /* shallow */
    )) : X(
      u,
      l,
      f,
      S,
      h,
      E,
      I,
      T,
      v
    );
  }, Qe = (u, l, f, b, h, E, I, T, v) => {
    l.slotScopeIds = T, u == null ? l.shapeFlag & 512 ? h.ctx.activate(
      l,
      f,
      b,
      I,
      v
    ) : Jn(
      l,
      f,
      b,
      h,
      E,
      I,
      v
    ) : Dt(u, l, v);
  }, Jn = (u, l, f, b, h, E, I) => {
    const T = u.component = bc(
      u,
      b,
      h
    );
    if (Br(u) && (T.ctx.renderer = wn), kc(T, !1, I), T.asyncDep) {
      if (h && h.registerDep(T, ne, I), !u.el) {
        const v = T.subTree = fe(In);
        w(null, v, l, f);
      }
    } else
      ne(
        T,
        u,
        l,
        f,
        h,
        E,
        I
      );
  }, Dt = (u, l, f) => {
    const b = l.component = u.component;
    if (ic(u, l, f))
      if (b.asyncDep && !b.asyncResolved) {
        L(b, l, f);
        return;
      } else
        b.next = l, b.update();
    else
      l.el = u.el, b.vnode = l;
  }, ne = (u, l, f, b, h, E, I) => {
    const T = () => {
      if (u.isMounted) {
        let { next: O, bu: N, u: U, parent: B, vnode: $ } = u;
        {
          const he = gi(u);
          if (he) {
            O && (O.el = $.el, L(u, O, I)), he.asyncDep.then(() => {
              u.isUnmounted || T();
            });
            return;
          }
        }
        let Y = O, ge;
        En(u, !1), O ? (O.el = $.el, L(u, O, I)) : O = $, N && Is(N), (ge = O.props && O.props.onVnodeBeforeUpdate) && Pe(ge, B, O, $), En(u, !0);
        const _e = Us(u), ye = u.subTree;
        u.subTree = _e, y(
          ye,
          _e,
          // parent may have changed if it's in a teleport
          d(ye.el),
          // anchor may have changed if it's in a fragment
          St(ye),
          u,
          h,
          E
        ), O.el = _e.el, Y === null && _c(u, _e.el), U && be(U, h), (ge = O.props && O.props.onVnodeUpdated) && be(
          () => Pe(ge, B, O, $),
          h
        );
      } else {
        let O;
        const { el: N, props: U } = l, { bm: B, m: $, parent: Y, root: ge, type: _e } = u, ye = pt(l);
        if (En(u, !1), B && Is(B), !ye && (O = U && U.onVnodeBeforeMount) && Pe(O, Y, l), En(u, !0), N && Rs) {
          const he = () => {
            u.subTree = Us(u), Rs(
              N,
              u.subTree,
              u,
              h,
              null
            );
          };
          ye && _e.__asyncHydrate ? _e.__asyncHydrate(
            N,
            u,
            he
          ) : he();
        } else {
          ge.ce && ge.ce._injectChildStyle(_e);
          const he = u.subTree = Us(u);
          y(
            null,
            he,
            f,
            b,
            u,
            h,
            E
          ), l.el = he.el;
        }
        if ($ && be($, h), !ye && (O = U && U.onVnodeMounted)) {
          const he = l;
          be(
            () => Pe(O, Y, he),
            h
          );
        }
        (l.shapeFlag & 256 || Y && pt(Y.vnode) && Y.vnode.shapeFlag & 256) && u.a && be(u.a, h), u.isMounted = !0, l = f = b = null;
      }
    };
    u.scope.on();
    const v = u.effect = new Ua(T);
    u.scope.off();
    const k = u.update = v.run.bind(v), S = u.job = v.runIfDirty.bind(v);
    S.i = u, S.id = u.uid, v.scheduler = () => Lr(S), En(u, !0), k();
  }, L = (u, l, f) => {
    l.component = u;
    const b = u.vnode.props;
    u.vnode = l, u.next = null, Yp(u, l.props, b, f), Jp(u, l.children, f), un(), go(u), ln();
  }, X = (u, l, f, b, h, E, I, T, v = !1) => {
    const k = u && u.children, S = u ? u.shapeFlag : 0, O = l.children, { patchFlag: N, shapeFlag: U } = l;
    if (N > 0) {
      if (N & 128) {
        At(
          k,
          O,
          f,
          b,
          h,
          E,
          I,
          T,
          v
        );
        return;
      } else if (N & 256) {
        fn(
          k,
          O,
          f,
          b,
          h,
          E,
          I,
          T,
          v
        );
        return;
      }
    }
    U & 8 ? (S & 16 && zn(k, h, E), O !== k && c(f, O)) : S & 16 ? U & 16 ? At(
      k,
      O,
      f,
      b,
      h,
      E,
      I,
      T,
      v
    ) : zn(k, h, E, !0) : (S & 8 && c(f, ""), U & 16 && x(
      O,
      f,
      b,
      h,
      E,
      I,
      T,
      v
    ));
  }, fn = (u, l, f, b, h, E, I, T, v) => {
    u = u || Mn, l = l || Mn;
    const k = u.length, S = l.length, O = Math.min(k, S);
    let N;
    for (N = 0; N < O; N++) {
      const U = l[N] = v ? tn(l[N]) : Le(l[N]);
      y(
        u[N],
        U,
        f,
        null,
        h,
        E,
        I,
        T,
        v
      );
    }
    k > S ? zn(
      u,
      h,
      E,
      !0,
      !1,
      O
    ) : x(
      l,
      f,
      b,
      h,
      E,
      I,
      T,
      v,
      O
    );
  }, At = (u, l, f, b, h, E, I, T, v) => {
    let k = 0;
    const S = l.length;
    let O = u.length - 1, N = S - 1;
    for (; k <= O && k <= N; ) {
      const U = u[k], B = l[k] = v ? tn(l[k]) : Le(l[k]);
      if (Qn(U, B))
        y(
          U,
          B,
          f,
          null,
          h,
          E,
          I,
          T,
          v
        );
      else
        break;
      k++;
    }
    for (; k <= O && k <= N; ) {
      const U = u[O], B = l[N] = v ? tn(l[N]) : Le(l[N]);
      if (Qn(U, B))
        y(
          U,
          B,
          f,
          null,
          h,
          E,
          I,
          T,
          v
        );
      else
        break;
      O--, N--;
    }
    if (k > O) {
      if (k <= N) {
        const U = N + 1, B = U < S ? l[U].el : b;
        for (; k <= N; )
          y(
            null,
            l[k] = v ? tn(l[k]) : Le(l[k]),
            f,
            B,
            h,
            E,
            I,
            T,
            v
          ), k++;
      }
    } else if (k > N)
      for (; k <= O; )
        Ue(u[k], h, E, !0), k++;
    else {
      const U = k, B = k, $ = /* @__PURE__ */ new Map();
      for (k = B; k <= N; k++) {
        const Ee = l[k] = v ? tn(l[k]) : Le(l[k]);
        Ee.key != null && $.set(Ee.key, k);
      }
      let Y, ge = 0;
      const _e = N - B + 1;
      let ye = !1, he = 0;
      const qn = new Array(_e);
      for (k = 0; k < _e; k++)
        qn[k] = 0;
      for (k = U; k <= O; k++) {
        const Ee = u[k];
        if (ge >= _e) {
          Ue(Ee, h, E, !0);
          continue;
        }
        let Ce;
        if (Ee.key != null)
          Ce = $.get(Ee.key);
        else
          for (Y = B; Y <= N; Y++)
            if (qn[Y - B] === 0 && Qn(Ee, l[Y])) {
              Ce = Y;
              break;
            }
        Ce === void 0 ? Ue(Ee, h, E, !0) : (qn[Ce - B] = k + 1, Ce >= he ? he = Ce : ye = !0, y(
          Ee,
          l[Ce],
          f,
          null,
          h,
          E,
          I,
          T,
          v
        ), ge++);
      }
      const po = ye ? Qp(qn) : Mn;
      for (Y = po.length - 1, k = _e - 1; k >= 0; k--) {
        const Ee = B + k, Ce = l[Ee], co = Ee + 1 < S ? l[Ee + 1].el : b;
        qn[k] === 0 ? y(
          null,
          Ce,
          f,
          co,
          h,
          E,
          I,
          T,
          v
        ) : ye && (Y < 0 || k !== po[Y] ? gn(Ce, f, co, 2) : Y--);
      }
    }
  }, gn = (u, l, f, b, h = null) => {
    const { el: E, type: I, transition: T, children: v, shapeFlag: k } = u;
    if (k & 6) {
      gn(u.component.subTree, l, f, b);
      return;
    }
    if (k & 128) {
      u.suspense.move(l, f, b);
      return;
    }
    if (k & 64) {
      I.move(u, l, f, wn);
      return;
    }
    if (I === Ke) {
      s(E, l, f);
      for (let O = 0; O < v.length; O++)
        gn(v[O], l, f, b);
      s(u.anchor, l, f);
      return;
    }
    if (I === Cs) {
      H(u, l, f);
      return;
    }
    if (b !== 2 && k & 1 && T)
      if (b === 0)
        T.beforeEnter(E), s(E, l, f), be(() => T.enter(E), h);
      else {
        const { leave: O, delayLeave: N, afterLeave: U } = T, B = () => s(E, l, f), $ = () => {
          O(E, () => {
            B(), U && U();
          });
        };
        N ? N(E, B, $) : $();
      }
    else
      s(E, l, f);
  }, Ue = (u, l, f, b = !1, h = !1) => {
    const {
      type: E,
      props: I,
      ref: T,
      children: v,
      dynamicChildren: k,
      shapeFlag: S,
      patchFlag: O,
      dirs: N,
      cacheIndex: U
    } = u;
    if (O === -2 && (h = !1), T != null && Jt(T, null, f, u, !0), U != null && (l.renderCache[U] = void 0), S & 256) {
      l.ctx.deactivate(u);
      return;
    }
    const B = S & 1 && N, $ = !pt(u);
    let Y;
    if ($ && (Y = I && I.onVnodeBeforeUnmount) && Pe(Y, l, u), S & 6)
      R_(u.component, f, b);
    else {
      if (S & 128) {
        u.suspense.unmount(f, b);
        return;
      }
      B && hn(u, null, l, "beforeUnmount"), S & 64 ? u.type.remove(
        u,
        l,
        f,
        wn,
        b
      ) : k && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !k.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (E !== Ke || O > 0 && O & 64) ? zn(
        k,
        l,
        f,
        !1,
        !0
      ) : (E === Ke && O & 384 || !h && S & 16) && zn(v, l, f), b && io(u);
    }
    ($ && (Y = I && I.onVnodeUnmounted) || B) && be(() => {
      Y && Pe(Y, l, u), B && hn(u, null, l, "unmounted");
    }, f);
  }, io = (u) => {
    const { type: l, el: f, anchor: b, transition: h } = u;
    if (l === Ke) {
      T_(f, b);
      return;
    }
    if (l === Cs) {
      D(u);
      return;
    }
    const E = () => {
      r(f), h && !h.persisted && h.afterLeave && h.afterLeave();
    };
    if (u.shapeFlag & 1 && h && !h.persisted) {
      const { leave: I, delayLeave: T } = h, v = () => I(f, E);
      T ? T(u.el, E, v) : v();
    } else
      E();
  }, T_ = (u, l) => {
    let f;
    for (; u !== l; )
      f = g(u), r(u), u = f;
    r(l);
  }, R_ = (u, l, f) => {
    const { bum: b, scope: h, job: E, subTree: I, um: T, m: v, a: k } = u;
    Ro(v), Ro(k), b && Is(b), h.stop(), E && (E.flags |= 8, Ue(I, u, l, f)), T && be(T, l), be(() => {
      u.isUnmounted = !0;
    }, l), l && l.pendingBranch && !l.isUnmounted && u.asyncDep && !u.asyncResolved && u.suspenseId === l.pendingId && (l.deps--, l.deps === 0 && l.resolve());
  }, zn = (u, l, f, b = !1, h = !1, E = 0) => {
    for (let I = E; I < u.length; I++)
      Ue(u[I], l, f, b, h);
  }, St = (u) => {
    if (u.shapeFlag & 6)
      return St(u.component.subTree);
    if (u.shapeFlag & 128)
      return u.suspense.next();
    const l = g(u.anchor || u.el), f = l && l[Ep];
    return f ? g(f) : l;
  };
  let vs = !1;
  const _o = (u, l, f) => {
    u == null ? l._vnode && Ue(l._vnode, null, null, !0) : y(
      l._vnode || null,
      u,
      l,
      null,
      null,
      null,
      f
    ), l._vnode = u, vs || (vs = !0, go(), Za(), vs = !1);
  }, wn = {
    p: y,
    um: Ue,
    m: gn,
    r: io,
    mt: Jn,
    mc: x,
    pc: X,
    pbc: re,
    n: St,
    o: e
  };
  let Ts, Rs;
  return n && ([Ts, Rs] = n(
    wn
  )), {
    render: _o,
    hydrate: Ts,
    createApp: jp(_o, Ts)
  };
}
function Hs({ type: e, props: n }, t) {
  return t === "svg" && e === "foreignObject" || t === "mathml" && e === "annotation-xml" && n && n.encoding && n.encoding.includes("html") ? void 0 : t;
}
function En({ effect: e, job: n }, t) {
  t ? (e.flags |= 32, n.flags |= 4) : (e.flags &= -33, n.flags &= -5);
}
function Zp(e, n) {
  return (!e || e && !e.pendingBranch) && n && !n.persisted;
}
function fi(e, n, t = !1) {
  const s = e.children, r = n.children;
  if (C(s) && C(r))
    for (let o = 0; o < s.length; o++) {
      const a = s[o];
      let i = r[o];
      i.shapeFlag & 1 && !i.dynamicChildren && ((i.patchFlag <= 0 || i.patchFlag === 32) && (i = r[o] = tn(r[o]), i.el = a.el), !t && i.patchFlag !== -2 && fi(a, i)), i.type === ds && (i.el = a.el);
    }
}
function Qp(e) {
  const n = e.slice(), t = [0];
  let s, r, o, a, i;
  const _ = e.length;
  for (s = 0; s < _; s++) {
    const p = e[s];
    if (p !== 0) {
      if (r = t[t.length - 1], e[r] < p) {
        n[s] = r, t.push(s);
        continue;
      }
      for (o = 0, a = t.length - 1; o < a; )
        i = o + a >> 1, e[t[i]] < p ? o = i + 1 : a = i;
      p < e[t[o]] && (o > 0 && (n[s] = t[o - 1]), t[o] = s);
    }
  }
  for (o = t.length, a = t[o - 1]; o-- > 0; )
    t[o] = a, a = n[a];
  return t;
}
function gi(e) {
  const n = e.subTree.component;
  if (n)
    return n.asyncDep && !n.asyncResolved ? n : gi(n);
}
function Ro(e) {
  if (e)
    for (let n = 0; n < e.length; n++)
      e[n].flags |= 8;
}
const ec = Symbol.for("v-scx"), nc = () => dt(ec);
function jt(e, n, t) {
  return hi(e, n, t);
}
function hi(e, n, t = z) {
  const { immediate: s, deep: r, flush: o, once: a } = t, i = se({}, t), _ = n && s || !n && o !== "post";
  let p;
  if (Vn) {
    if (o === "sync") {
      const m = nc();
      p = m.__watcherHandles || (m.__watcherHandles = []);
    } else if (!_) {
      const m = () => {
      };
      return m.stop = Ne, m.resume = Ne, m.pause = Ne, m;
    }
  }
  const c = ae;
  i.call = (m, R, y) => Be(m, c, R, y);
  let d = !1;
  o === "post" ? i.scheduler = (m) => {
    be(m, c && c.suspense);
  } : o !== "sync" && (d = !0, i.scheduler = (m, R) => {
    R ? m() : Lr(m);
  }), i.augmentJob = (m) => {
    n && (m.flags |= 4), d && (m.flags |= 2, c && (m.id = c.uid, m.i = c));
  };
  const g = lp(e, n, i);
  return Vn && (p ? p.push(g) : _ && g()), g;
}
function tc(e, n, t) {
  const s = this.proxy, r = oe(e) ? e.includes(".") ? Ei(s, e) : () => s[e] : e.bind(s, s);
  let o;
  P(n) ? o = n : (o = n.handler, t = n);
  const a = It(this), i = hi(r, o.bind(s), t);
  return a(), i;
}
function Ei(e, n) {
  const t = n.split(".");
  return () => {
    let s = e;
    for (let r = 0; r < t.length && s; r++)
      s = s[t[r]];
    return s;
  };
}
const sc = (e, n) => n === "modelValue" || n === "model-value" ? e.modelModifiers : e[`${n}Modifiers`] || e[`${De(n)}Modifiers`] || e[`${Re(n)}Modifiers`];
function rc(e, n, ...t) {
  if (e.isUnmounted)
    return;
  const s = e.vnode.props || z;
  let r = t;
  const o = n.startsWith("update:"), a = o && sc(s, n.slice(7));
  a && (a.trim && (r = t.map((c) => oe(c) ? c.trim() : c)), a.number && (r = t.map(A_)));
  let i, _ = s[i = ys(n)] || // also try camelCase event handler (#2249)
  s[i = ys(De(n))];
  !_ && o && (_ = s[i = ys(Re(n))]), _ && Be(
    _,
    e,
    6,
    r
  );
  const p = s[i + "Once"];
  if (p) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[i])
      return;
    e.emitted[i] = !0, Be(
      p,
      e,
      6,
      r
    );
  }
}
function bi(e, n, t = !1) {
  const s = n.emitsCache, r = s.get(e);
  if (r !== void 0)
    return r;
  const o = e.emits;
  let a = {}, i = !1;
  if (!P(e)) {
    const _ = (p) => {
      const c = bi(p, n, !0);
      c && (i = !0, se(a, c));
    };
    !t && n.mixins.length && n.mixins.forEach(_), e.extends && _(e.extends), e.mixins && e.mixins.forEach(_);
  }
  return !o && !i ? (Q(e) && s.set(e, null), null) : (C(o) ? o.forEach((_) => a[_] = null) : se(a, o), Q(e) && s.set(e, a), a);
}
function cs(e, n) {
  return !e || !ts(n) ? !1 : (n = n.slice(2).replace(/Once$/, ""), W(e, n[0].toLowerCase() + n.slice(1)) || W(e, Re(n)) || W(e, n));
}
function Us(e) {
  const {
    type: n,
    vnode: t,
    proxy: s,
    withProxy: r,
    propsOptions: [o],
    slots: a,
    attrs: i,
    emit: _,
    render: p,
    renderCache: c,
    props: d,
    data: g,
    setupState: m,
    ctx: R,
    inheritAttrs: y
  } = e, A = $t(e);
  let w, G;
  try {
    if (t.shapeFlag & 4) {
      const D = r || s, j = D;
      w = Le(
        p.call(
          j,
          D,
          c,
          d,
          m,
          g,
          R
        )
      ), G = i;
    } else {
      const D = n;
      w = Le(
        D.length > 1 ? D(
          d,
          { attrs: i, slots: a, emit: _ }
        ) : D(
          d,
          null
        )
      ), G = n.props ? i : oc(i);
    }
  } catch (D) {
    ut.length = 0, yt(D, e, 1), w = fe(In);
  }
  let H = w;
  if (G && y !== !1) {
    const D = Object.keys(G), { shapeFlag: j } = H;
    D.length && j & 7 && (o && D.some(Tr) && (G = ac(
      G,
      o
    )), H = jn(H, G, !1, !0));
  }
  return t.dirs && (H = jn(H, null, !1, !0), H.dirs = H.dirs ? H.dirs.concat(t.dirs) : t.dirs), t.transition && Gr(H, t.transition), w = H, $t(A), w;
}
const oc = (e) => {
  let n;
  for (const t in e)
    (t === "class" || t === "style" || ts(t)) && ((n || (n = {}))[t] = e[t]);
  return n;
}, ac = (e, n) => {
  const t = {};
  for (const s in e)
    (!Tr(s) || !(s.slice(9) in n)) && (t[s] = e[s]);
  return t;
};
function ic(e, n, t) {
  const { props: s, children: r, component: o } = e, { props: a, children: i, patchFlag: _ } = n, p = o.emitsOptions;
  if (n.dirs || n.transition)
    return !0;
  if (t && _ >= 0) {
    if (_ & 1024)
      return !0;
    if (_ & 16)
      return s ? yo(s, a, p) : !!a;
    if (_ & 8) {
      const c = n.dynamicProps;
      for (let d = 0; d < c.length; d++) {
        const g = c[d];
        if (a[g] !== s[g] && !cs(p, g))
          return !0;
      }
    }
  } else
    return (r || i) && (!i || !i.$stable) ? !0 : s === a ? !1 : s ? a ? yo(s, a, p) : !0 : !!a;
  return !1;
}
function yo(e, n, t) {
  const s = Object.keys(n);
  if (s.length !== Object.keys(e).length)
    return !0;
  for (let r = 0; r < s.length; r++) {
    const o = s[r];
    if (n[o] !== e[o] && !cs(t, o))
      return !0;
  }
  return !1;
}
function _c({ vnode: e, parent: n }, t) {
  for (; n; ) {
    const s = n.subTree;
    if (s.suspense && s.suspense.activeBranch === e && (s.el = e.el), s === e)
      (e = n.vnode).el = t, n = n.parent;
    else
      break;
  }
}
const ki = (e) => e.__isSuspense;
function pc(e, n) {
  n && n.pendingBranch ? C(e) ? n.effects.push(...e) : n.effects.push(e) : gp(e);
}
const Ke = Symbol.for("v-fgt"), ds = Symbol.for("v-txt"), In = Symbol.for("v-cmt"), Cs = Symbol.for("v-stc"), ut = [];
let ke = null;
function cc(e = !1) {
  ut.push(ke = e ? null : []);
}
function dc() {
  ut.pop(), ke = ut[ut.length - 1] || null;
}
let Et = 1;
function Io(e, n = !1) {
  Et += e, e < 0 && ke && n && (ke.hasOnce = !0);
}
function vi(e) {
  return e.dynamicChildren = Et > 0 ? ke || Mn : null, dc(), Et > 0 && ke && ke.push(e), e;
}
function Bf(e, n, t, s, r, o) {
  return vi(
    yi(
      e,
      n,
      t,
      s,
      r,
      o,
      !0
    )
  );
}
function uc(e, n, t, s, r) {
  return vi(
    fe(
      e,
      n,
      t,
      s,
      r,
      !0
    )
  );
}
function Ti(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function Qn(e, n) {
  return e.type === n.type && e.key === n.key;
}
const Ri = ({ key: e }) => e ?? null, Vt = ({
  ref: e,
  ref_key: n,
  ref_for: t
}) => (typeof e == "number" && (e = "" + e), e != null ? oe(e) || te(e) || P(e) ? { i: Oe, r: e, k: n, f: !!t } : e : null);
function yi(e, n = null, t = null, s = 0, r = null, o = e === Ke ? 0 : 1, a = !1, i = !1) {
  const _ = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: n,
    key: n && Ri(n),
    ref: n && Vt(n),
    scopeId: ei,
    slotScopeIds: null,
    children: t,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: o,
    patchFlag: s,
    dynamicProps: r,
    dynamicChildren: null,
    appContext: null,
    ctx: Oe
  };
  return i ? (Fr(_, t), o & 128 && e.normalize(_)) : t && (_.shapeFlag |= oe(t) ? 8 : 16), Et > 0 && // avoid a block node from tracking itself
  !a && // has current parent block
  ke && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (_.patchFlag > 0 || o & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  _.patchFlag !== 32 && ke.push(_), _;
}
const fe = lc;
function lc(e, n = null, t = null, s = 0, r = null, o = !1) {
  if ((!e || e === Up) && (e = In), Ti(e)) {
    const i = jn(
      e,
      n,
      !0
      /* mergeRef: true */
    );
    return t && Fr(i, t), Et > 0 && !o && ke && (i.shapeFlag & 6 ? ke[ke.indexOf(e)] = i : ke.push(i)), i.patchFlag = -2, i;
  }
  if (yc(e) && (e = e.__vccOpts), n) {
    n = mc(n);
    let { class: i, style: _ } = n;
    i && !oe(i) && (n.class = Or(i)), Q(_) && (Cr(_) && !C(_) && (_ = se({}, _)), n.style = Ir(_));
  }
  const a = oe(e) ? 1 : ki(e) ? 128 : bp(e) ? 64 : Q(e) ? 4 : P(e) ? 2 : 0;
  return yi(
    e,
    n,
    t,
    s,
    r,
    a,
    o,
    !0
  );
}
function mc(e) {
  return e ? Cr(e) || _i(e) ? se({}, e) : e : null;
}
function jn(e, n, t = !1, s = !1) {
  const { props: r, ref: o, patchFlag: a, children: i, transition: _ } = e, p = n ? gc(r || {}, n) : r, c = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: p,
    key: p && Ri(p),
    ref: n && n.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      t && o ? C(o) ? o.concat(Vt(n)) : [o, Vt(n)] : Vt(n)
    ) : o,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: i,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: n && e.type !== Ke ? a === -1 ? 16 : a | 16 : a,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: _,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && jn(e.ssContent),
    ssFallback: e.ssFallback && jn(e.ssFallback),
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
  return _ && s && Gr(
    c,
    _.clone(c)
  ), c;
}
function fc(e = " ", n = 0) {
  return fe(ds, null, e, n);
}
function jf(e = "", n = !1) {
  return n ? (cc(), uc(In, null, e)) : fe(In, null, e);
}
function Le(e) {
  return e == null || typeof e == "boolean" ? fe(In) : C(e) ? fe(
    Ke,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : Ti(e) ? tn(e) : fe(ds, null, String(e));
}
function tn(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : jn(e);
}
function Fr(e, n) {
  let t = 0;
  const { shapeFlag: s } = e;
  if (n == null)
    n = null;
  else if (C(n))
    t = 16;
  else if (typeof n == "object")
    if (s & 65) {
      const r = n.default;
      r && (r._c && (r._d = !1), Fr(e, r()), r._c && (r._d = !0));
      return;
    } else {
      t = 32;
      const r = n._;
      !r && !_i(n) ? n._ctx = Oe : r === 3 && Oe && (Oe.slots._ === 1 ? n._ = 1 : (n._ = 2, e.patchFlag |= 1024));
    }
  else
    P(n) ? (n = { default: n, _ctx: Oe }, t = 32) : (n = String(n), s & 64 ? (t = 16, n = [fc(n)]) : t = 8);
  e.children = n, e.shapeFlag |= t;
}
function gc(...e) {
  const n = {};
  for (let t = 0; t < e.length; t++) {
    const s = e[t];
    for (const r in s)
      if (r === "class")
        n.class !== s.class && (n.class = Or([n.class, s.class]));
      else if (r === "style")
        n.style = Ir([n.style, s.style]);
      else if (ts(r)) {
        const o = n[r], a = s[r];
        a && o !== a && !(C(o) && o.includes(a)) && (n[r] = o ? [].concat(o, a) : a);
      } else
        r !== "" && (n[r] = s[r]);
  }
  return n;
}
function Pe(e, n, t, s = null) {
  Be(e, n, 7, [
    t,
    s
  ]);
}
const hc = oi();
let Ec = 0;
function bc(e, n, t) {
  const s = e.type, r = (n ? n.appContext : e.appContext) || hc, o = {
    uid: Ec++,
    vnode: e,
    type: s,
    parent: n,
    appContext: r,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new Sa(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: n ? n.provides : Object.create(r.provides),
    ids: n ? n.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: ci(s, r),
    emitsOptions: bi(s, r),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: z,
    // inheritAttrs
    inheritAttrs: s.inheritAttrs,
    // state
    ctx: z,
    data: z,
    props: z,
    attrs: z,
    slots: z,
    refs: z,
    setupState: z,
    setupContext: null,
    // suspense related
    suspense: t,
    suspenseId: t ? t.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return o.ctx = { _: o }, o.root = n ? n.root : o, o.emit = rc.bind(null, o), e.ce && e.ce(o), o;
}
let ae = null, qt, Zs;
{
  const e = as(), n = (t, s) => {
    let r;
    return (r = e[t]) || (r = e[t] = []), r.push(s), (o) => {
      r.length > 1 ? r.forEach((a) => a(o)) : r[0](o);
    };
  };
  qt = n(
    "__VUE_INSTANCE_SETTERS__",
    (t) => ae = t
  ), Zs = n(
    "__VUE_SSR_SETTERS__",
    (t) => Vn = t
  );
}
const It = (e) => {
  const n = ae;
  return qt(e), e.scope.on(), () => {
    e.scope.off(), qt(n);
  };
}, Oo = () => {
  ae && ae.scope.off(), qt(null);
};
function Ii(e) {
  return e.vnode.shapeFlag & 4;
}
let Vn = !1;
function kc(e, n = !1, t = !1) {
  n && Zs(n);
  const { props: s, children: r } = e.vnode, o = Ii(e);
  Wp(e, s, o, n), $p(e, r, t);
  const a = o ? vc(e, n) : void 0;
  return n && Zs(!1), a;
}
function vc(e, n) {
  const t = e.type;
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = new Proxy(e.ctx, Cp);
  const { setup: s } = t;
  if (s) {
    un();
    const r = e.setupContext = s.length > 1 ? Rc(e) : null, o = It(e), a = Rt(
      s,
      e,
      0,
      [
        e.props,
        r
      ]
    ), i = Ra(a);
    if (ln(), o(), (i || e.sp) && !pt(e) && xr(e), i) {
      if (a.then(Oo, Oo), n)
        return a.then((_) => {
          No(e, _, n);
        }).catch((_) => {
          yt(_, e, 0);
        });
      e.asyncDep = a;
    } else
      No(e, a, n);
  } else
    Oi(e, n);
}
function No(e, n, t) {
  P(n) ? e.type.__ssrInlineRender ? e.ssrRender = n : e.render = n : Q(n) && (e.setupState = Ja(n)), Oi(e, t);
}
let Do;
function Oi(e, n, t) {
  const s = e.type;
  if (!e.render) {
    if (!n && Do && !s.render) {
      const r = s.template || jr(e).template;
      if (r) {
        const { isCustomElement: o, compilerOptions: a } = e.appContext.config, { delimiters: i, compilerOptions: _ } = s, p = se(
          se(
            {
              isCustomElement: o,
              delimiters: i
            },
            a
          ),
          _
        );
        s.render = Do(r, p);
      }
    }
    e.render = s.render || Ne;
  }
  {
    const r = It(e);
    un();
    try {
      Pp(e);
    } finally {
      ln(), r();
    }
  }
}
const Tc = {
  get(e, n) {
    return pe(e, "get", ""), e[n];
  }
};
function Rc(e) {
  const n = (t) => {
    e.exposed = t || {};
  };
  return {
    attrs: new Proxy(e.attrs, Tc),
    slots: e.slots,
    emit: e.emit,
    expose: n
  };
}
function Wr(e) {
  return e.exposed ? e.exposeProxy || (e.exposeProxy = new Proxy(Ja(Pr(e.exposed)), {
    get(n, t) {
      if (t in n)
        return n[t];
      if (t in ct)
        return ct[t](e);
    },
    has(n, t) {
      return t in n || t in ct;
    }
  })) : e.proxy;
}
function yc(e) {
  return P(e) && "__vccOpts" in e;
}
const lt = (e, n) => dp(e, n, Vn), Ic = "3.5.13";
/**
* @vue/runtime-dom v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let Qs;
const Ao = typeof window < "u" && window.trustedTypes;
if (Ao)
  try {
    Qs = /* @__PURE__ */ Ao.createPolicy("vue", {
      createHTML: (e) => e
    });
  } catch {
  }
const Ni = Qs ? (e) => Qs.createHTML(e) : (e) => e, Oc = "http://www.w3.org/2000/svg", Nc = "http://www.w3.org/1998/Math/MathML", We = typeof document < "u" ? document : null, So = We && /* @__PURE__ */ We.createElement("template"), Dc = {
  insert: (e, n, t) => {
    n.insertBefore(e, t || null);
  },
  remove: (e) => {
    const n = e.parentNode;
    n && n.removeChild(e);
  },
  createElement: (e, n, t, s) => {
    const r = n === "svg" ? We.createElementNS(Oc, e) : n === "mathml" ? We.createElementNS(Nc, e) : t ? We.createElement(e, { is: t }) : We.createElement(e);
    return e === "select" && s && s.multiple != null && r.setAttribute("multiple", s.multiple), r;
  },
  createText: (e) => We.createTextNode(e),
  createComment: (e) => We.createComment(e),
  setText: (e, n) => {
    e.nodeValue = n;
  },
  setElementText: (e, n) => {
    e.textContent = n;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => We.querySelector(e),
  setScopeId(e, n) {
    e.setAttribute(n, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, n, t, s, r, o) {
    const a = t ? t.previousSibling : n.lastChild;
    if (r && (r === o || r.nextSibling))
      for (; n.insertBefore(r.cloneNode(!0), t), !(r === o || !(r = r.nextSibling)); )
        ;
    else {
      So.innerHTML = Ni(
        s === "svg" ? `<svg>${e}</svg>` : s === "mathml" ? `<math>${e}</math>` : e
      );
      const i = So.content;
      if (s === "svg" || s === "mathml") {
        const _ = i.firstChild;
        for (; _.firstChild; )
          i.appendChild(_.firstChild);
        i.removeChild(_);
      }
      n.insertBefore(i, t);
    }
    return [
      // first
      a ? a.nextSibling : n.firstChild,
      // last
      t ? t.previousSibling : n.lastChild
    ];
  }
}, Ac = Symbol("_vtc");
function Sc(e, n, t) {
  const s = e[Ac];
  s && (n = (n ? [n, ...s] : [...s]).join(" ")), n == null ? e.removeAttribute("class") : t ? e.setAttribute("class", n) : e.className = n;
}
const wo = Symbol("_vod"), wc = Symbol("_vsh"), Hc = Symbol(""), Uc = /(^|;)\s*display\s*:/;
function Cc(e, n, t) {
  const s = e.style, r = oe(t);
  let o = !1;
  if (t && !r) {
    if (n)
      if (oe(n))
        for (const a of n.split(";")) {
          const i = a.slice(0, a.indexOf(":")).trim();
          t[i] == null && Ft(s, i, "");
        }
      else
        for (const a in n)
          t[a] == null && Ft(s, a, "");
    for (const a in t)
      a === "display" && (o = !0), Ft(s, a, t[a]);
  } else if (r) {
    if (n !== t) {
      const a = s[Hc];
      a && (t += ";" + a), s.cssText = t, o = Uc.test(t);
    }
  } else
    n && e.removeAttribute("style");
  wo in e && (e[wo] = o ? s.display : "", e[wc] && (s.display = "none"));
}
const Ho = /\s*!important$/;
function Ft(e, n, t) {
  if (C(t))
    t.forEach((s) => Ft(e, n, s));
  else if (t == null && (t = ""), n.startsWith("--"))
    e.setProperty(n, t);
  else {
    const s = Pc(e, n);
    Ho.test(t) ? e.setProperty(
      Re(s),
      t.replace(Ho, ""),
      "important"
    ) : e[s] = t;
  }
}
const Uo = ["Webkit", "Moz", "ms"], Ps = {};
function Pc(e, n) {
  const t = Ps[n];
  if (t)
    return t;
  let s = De(n);
  if (s !== "filter" && s in e)
    return Ps[n] = s;
  s = Ia(s);
  for (let r = 0; r < Uo.length; r++) {
    const o = Uo[r] + s;
    if (o in e)
      return Ps[n] = o;
  }
  return n;
}
const Co = "http://www.w3.org/1999/xlink";
function Po(e, n, t, s, r, o = P_(n)) {
  s && n.startsWith("xlink:") ? t == null ? e.removeAttributeNS(Co, n.slice(6, n.length)) : e.setAttributeNS(Co, n, t) : t == null || o && !Na(t) ? e.removeAttribute(n) : e.setAttribute(
    n,
    o ? "" : dn(t) ? String(t) : t
  );
}
function Mo(e, n, t, s, r) {
  if (n === "innerHTML" || n === "textContent") {
    t != null && (e[n] = n === "innerHTML" ? Ni(t) : t);
    return;
  }
  const o = e.tagName;
  if (n === "value" && o !== "PROGRESS" && // custom elements may use _value internally
  !o.includes("-")) {
    const i = o === "OPTION" ? e.getAttribute("value") || "" : e.value, _ = t == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      e.type === "checkbox" ? "on" : ""
    ) : String(t);
    (i !== _ || !("_value" in e)) && (e.value = _), t == null && e.removeAttribute(n), e._value = t;
    return;
  }
  let a = !1;
  if (t === "" || t == null) {
    const i = typeof e[n];
    i === "boolean" ? t = Na(t) : t == null && i === "string" ? (t = "", a = !0) : i === "number" && (t = 0, a = !0);
  }
  try {
    e[n] = t;
  } catch {
  }
  a && e.removeAttribute(r || n);
}
function Mc(e, n, t, s) {
  e.addEventListener(n, t, s);
}
function Lc(e, n, t, s) {
  e.removeEventListener(n, t, s);
}
const Lo = Symbol("_vei");
function Gc(e, n, t, s, r = null) {
  const o = e[Lo] || (e[Lo] = {}), a = o[n];
  if (s && a)
    a.value = s;
  else {
    const [i, _] = xc(n);
    if (s) {
      const p = o[n] = Vc(
        s,
        r
      );
      Mc(e, i, p, _);
    } else
      a && (Lc(e, i, a, _), o[n] = void 0);
  }
}
const Go = /(?:Once|Passive|Capture)$/;
function xc(e) {
  let n;
  if (Go.test(e)) {
    n = {};
    let s;
    for (; s = e.match(Go); )
      e = e.slice(0, e.length - s[0].length), n[s[0].toLowerCase()] = !0;
  }
  return [e[2] === ":" ? e.slice(3) : Re(e.slice(2)), n];
}
let Ms = 0;
const Bc = /* @__PURE__ */ Promise.resolve(), jc = () => Ms || (Bc.then(() => Ms = 0), Ms = Date.now());
function Vc(e, n) {
  const t = (s) => {
    if (!s._vts)
      s._vts = Date.now();
    else if (s._vts <= t.attached)
      return;
    Be(
      Fc(s, t.value),
      n,
      5,
      [s]
    );
  };
  return t.value = e, t.attached = jc(), t;
}
function Fc(e, n) {
  if (C(n)) {
    const t = e.stopImmediatePropagation;
    return e.stopImmediatePropagation = () => {
      t.call(e), e._stopped = !0;
    }, n.map(
      (s) => (r) => !r._stopped && s && s(r)
    );
  } else
    return n;
}
const xo = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // lowercase letter
e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, Wc = (e, n, t, s, r, o) => {
  const a = r === "svg";
  n === "class" ? Sc(e, s, a) : n === "style" ? Cc(e, t, s) : ts(n) ? Tr(n) || Gc(e, n, t, s, o) : (n[0] === "." ? (n = n.slice(1), !0) : n[0] === "^" ? (n = n.slice(1), !1) : Yc(e, n, s, a)) ? (Mo(e, n, s), !e.tagName.includes("-") && (n === "value" || n === "checked" || n === "selected") && Po(e, n, s, a, o, n !== "value")) : /* #11081 force set props for possible async custom element */ e._isVueCE && (/[A-Z]/.test(n) || !oe(s)) ? Mo(e, De(n), s, o, n) : (n === "true-value" ? e._trueValue = s : n === "false-value" && (e._falseValue = s), Po(e, n, s, a));
};
function Yc(e, n, t, s) {
  if (s)
    return !!(n === "innerHTML" || n === "textContent" || n in e && xo(n) && P(t));
  if (n === "spellcheck" || n === "draggable" || n === "translate" || n === "form" || n === "list" && e.tagName === "INPUT" || n === "type" && e.tagName === "TEXTAREA")
    return !1;
  if (n === "width" || n === "height") {
    const r = e.tagName;
    if (r === "IMG" || r === "VIDEO" || r === "CANVAS" || r === "SOURCE")
      return !1;
  }
  return xo(n) && oe(t) ? !1 : n in e;
}
const Bo = {};
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Kc(e, n, t) {
  const s = /* @__PURE__ */ ni(e, n);
  rs(s) && se(s, n);
  class r extends Yr {
    constructor(a) {
      super(s, a, t);
    }
  }
  return r.def = s, r;
}
const Xc = typeof HTMLElement < "u" ? HTMLElement : class {
};
class Yr extends Xc {
  constructor(n, t = {}, s = er) {
    super(), this._def = n, this._props = t, this._createApp = s, this._isVueCE = !0, this._instance = null, this._app = null, this._nonce = this._def.nonce, this._connected = !1, this._resolved = !1, this._numberProps = null, this._styleChildren = /* @__PURE__ */ new WeakSet(), this._ob = null, this.shadowRoot && s !== er ? this._root = this.shadowRoot : n.shadowRoot !== !1 ? (this.attachShadow({ mode: "open" }), this._root = this.shadowRoot) : this._root = this, this._def.__asyncLoader || this._resolveProps(this._def);
  }
  connectedCallback() {
    if (!this.isConnected)
      return;
    this.shadowRoot || this._parseSlots(), this._connected = !0;
    let n = this;
    for (; n = n && (n.parentNode || n.host); )
      if (n instanceof Yr) {
        this._parent = n;
        break;
      }
    this._instance || (this._resolved ? (this._setParent(), this._update()) : n && n._pendingResolve ? this._pendingResolve = n._pendingResolve.then(() => {
      this._pendingResolve = void 0, this._resolveDef();
    }) : this._resolveDef());
  }
  _setParent(n = this._parent) {
    n && (this._instance.parent = n._instance, this._instance.provides = n._instance.provides);
  }
  disconnectedCallback() {
    this._connected = !1, Mr(() => {
      this._connected || (this._ob && (this._ob.disconnect(), this._ob = null), this._app && this._app.unmount(), this._instance && (this._instance.ce = void 0), this._app = this._instance = null);
    });
  }
  /**
   * resolve inner component definition (handle possible async component)
   */
  _resolveDef() {
    if (this._pendingResolve)
      return;
    for (let s = 0; s < this.attributes.length; s++)
      this._setAttr(this.attributes[s].name);
    this._ob = new MutationObserver((s) => {
      for (const r of s)
        this._setAttr(r.attributeName);
    }), this._ob.observe(this, { attributes: !0 });
    const n = (s, r = !1) => {
      this._resolved = !0, this._pendingResolve = void 0;
      const { props: o, styles: a } = s;
      let i;
      if (o && !C(o))
        for (const _ in o) {
          const p = o[_];
          (p === Number || p && p.type === Number) && (_ in this._props && (this._props[_] = uo(this._props[_])), (i || (i = /* @__PURE__ */ Object.create(null)))[De(_)] = !0);
        }
      this._numberProps = i, r && this._resolveProps(s), this.shadowRoot && this._applyStyles(a), this._mount(s);
    }, t = this._def.__asyncLoader;
    t ? this._pendingResolve = t().then(
      (s) => n(this._def = s, !0)
    ) : n(this._def);
  }
  _mount(n) {
    this._app = this._createApp(n), n.configureApp && n.configureApp(this._app), this._app._ceVNode = this._createVNode(), this._app.mount(this._root);
    const t = this._instance && this._instance.exposed;
    if (t)
      for (const s in t)
        W(this, s) || Object.defineProperty(this, s, {
          // unwrap ref to be consistent with public instance behavior
          get: () => $a(t[s])
        });
  }
  _resolveProps(n) {
    const { props: t } = n, s = C(t) ? t : Object.keys(t || {});
    for (const r of Object.keys(this))
      r[0] !== "_" && s.includes(r) && this._setProp(r, this[r]);
    for (const r of s.map(De))
      Object.defineProperty(this, r, {
        get() {
          return this._getProp(r);
        },
        set(o) {
          this._setProp(r, o, !0, !0);
        }
      });
  }
  _setAttr(n) {
    if (n.startsWith("data-v-"))
      return;
    const t = this.hasAttribute(n);
    let s = t ? this.getAttribute(n) : Bo;
    const r = De(n);
    t && this._numberProps && this._numberProps[r] && (s = uo(s)), this._setProp(r, s, !1, !0);
  }
  /**
   * @internal
   */
  _getProp(n) {
    return this._props[n];
  }
  /**
   * @internal
   */
  _setProp(n, t, s = !0, r = !1) {
    if (t !== this._props[n] && (t === Bo ? delete this._props[n] : (this._props[n] = t, n === "key" && this._app && (this._app._ceVNode.key = t)), r && this._instance && this._update(), s)) {
      const o = this._ob;
      o && o.disconnect(), t === !0 ? this.setAttribute(Re(n), "") : typeof t == "string" || typeof t == "number" ? this.setAttribute(Re(n), t + "") : t || this.removeAttribute(Re(n)), o && o.observe(this, { attributes: !0 });
    }
  }
  _update() {
    Jc(this._createVNode(), this._root);
  }
  _createVNode() {
    const n = {};
    this.shadowRoot || (n.onVnodeMounted = n.onVnodeUpdated = this._renderSlots.bind(this));
    const t = fe(this._def, se(n, this._props));
    return this._instance || (t.ce = (s) => {
      this._instance = s, s.ce = this, s.isCE = !0;
      const r = (o, a) => {
        this.dispatchEvent(
          new CustomEvent(
            o,
            rs(a[0]) ? se({ detail: a }, a[0]) : { detail: a }
          )
        );
      };
      s.emit = (o, ...a) => {
        r(o, a), Re(o) !== o && r(Re(o), a);
      }, this._setParent();
    }), t;
  }
  _applyStyles(n, t) {
    if (!n)
      return;
    if (t) {
      if (t === this._def || this._styleChildren.has(t))
        return;
      this._styleChildren.add(t);
    }
    const s = this._nonce;
    for (let r = n.length - 1; r >= 0; r--) {
      const o = document.createElement("style");
      s && o.setAttribute("nonce", s), o.textContent = n[r], this.shadowRoot.prepend(o);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _parseSlots() {
    const n = this._slots = {};
    let t;
    for (; t = this.firstChild; ) {
      const s = t.nodeType === 1 && t.getAttribute("slot") || "default";
      (n[s] || (n[s] = [])).push(t), this.removeChild(t);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _renderSlots() {
    const n = (this._teleportTarget || this).querySelectorAll("slot"), t = this._instance.type.__scopeId;
    for (let s = 0; s < n.length; s++) {
      const r = n[s], o = r.getAttribute("name") || "default", a = this._slots[o], i = r.parentNode;
      if (a)
        for (const _ of a) {
          if (t && _.nodeType === 1) {
            const p = t + "-s", c = document.createTreeWalker(_, 1);
            _.setAttribute(p, "");
            let d;
            for (; d = c.nextNode(); )
              d.setAttribute(p, "");
          }
          i.insertBefore(_, r);
        }
      else
        for (; r.firstChild; )
          i.insertBefore(r.firstChild, r);
      i.removeChild(r);
    }
  }
  /**
   * @internal
   */
  _injectChildStyle(n) {
    this._applyStyles(n.styles, n);
  }
  /**
   * @internal
   */
  _removeChildStyle(n) {
  }
}
const $c = /* @__PURE__ */ se({ patchProp: Wc }, Dc);
let jo;
function Di() {
  return jo || (jo = zp($c));
}
const Jc = (...e) => {
  Di().render(...e);
}, er = (...e) => {
  const n = Di().createApp(...e), { mount: t } = n;
  return n.mount = (s) => {
    const r = qc(s);
    if (!r)
      return;
    const o = n._component;
    !P(o) && !o.render && !o.template && (o.template = r.innerHTML), r.nodeType === 1 && (r.textContent = "");
    const a = t(r, !1, zc(r));
    return r instanceof Element && (r.removeAttribute("v-cloak"), r.setAttribute("data-v-app", "")), a;
  }, n;
};
function zc(e) {
  if (e instanceof SVGElement)
    return "svg";
  if (typeof MathMLElement == "function" && e instanceof MathMLElement)
    return "mathml";
}
function qc(e) {
  return oe(e) ? document.querySelector(e) : e;
}
const Zc = {
  name: "InitApp"
};
var Qc = !1;
/*!
 * pinia v2.2.8
 * (c) 2024 Eduardo San Martin Morote
 * @license MIT
 */
let Ai;
const us = (e) => Ai = e, Si = (
  /* istanbul ignore next */
  Symbol()
);
function nr(e) {
  return e && typeof e == "object" && Object.prototype.toString.call(e) === "[object Object]" && typeof e.toJSON != "function";
}
var mt;
(function(e) {
  e.direct = "direct", e.patchObject = "patch object", e.patchFunction = "patch function";
})(mt || (mt = {}));
function ed() {
  const e = wa(!0), n = e.run(() => _t({}));
  let t = [], s = [];
  const r = Pr({
    install(o) {
      us(r), r._a = o, o.provide(Si, r), o.config.globalProperties.$pinia = r, s.forEach((a) => t.push(a)), s = [];
    },
    use(o) {
      return !this._a && !Qc ? s.push(o) : t.push(o), this;
    },
    _p: t,
    // it's actually undefined here
    // @ts-expect-error
    _a: null,
    _e: e,
    _s: /* @__PURE__ */ new Map(),
    state: n
  });
  return r;
}
const wi = () => {
};
function Vo(e, n, t, s = wi) {
  e.push(n);
  const r = () => {
    const o = e.indexOf(n);
    o > -1 && (e.splice(o, 1), s());
  };
  return !t && Ha() && L_(r), r;
}
function Un(e, ...n) {
  e.slice().forEach((t) => {
    t(...n);
  });
}
const nd = (e) => e(), Fo = Symbol(), Ls = Symbol();
function tr(e, n) {
  e instanceof Map && n instanceof Map ? n.forEach((t, s) => e.set(s, t)) : e instanceof Set && n instanceof Set && n.forEach(e.add, e);
  for (const t in n) {
    if (!n.hasOwnProperty(t))
      continue;
    const s = n[t], r = e[t];
    nr(r) && nr(s) && e.hasOwnProperty(t) && !te(s) && !Tn(s) ? e[t] = tr(r, s) : e[t] = s;
  }
  return e;
}
const td = (
  /* istanbul ignore next */
  Symbol()
);
function sd(e) {
  return !nr(e) || !e.hasOwnProperty(td);
}
const { assign: en } = Object;
function rd(e) {
  return !!(te(e) && e.effect);
}
function od(e, n, t, s) {
  const { state: r, actions: o, getters: a } = n, i = t.state.value[e];
  let _;
  function p() {
    i || (t.state.value[e] = r ? r() : {});
    const c = ip(t.state.value[e]);
    return en(c, o, Object.keys(a || {}).reduce((d, g) => (d[g] = Pr(lt(() => {
      us(t);
      const m = t._s.get(e);
      return a[g].call(m, m);
    })), d), {}));
  }
  return _ = Hi(e, p, n, t, s, !0), _;
}
function Hi(e, n, t = {}, s, r, o) {
  let a;
  const i = en({ actions: {} }, t), _ = { deep: !0 };
  let p, c, d = [], g = [], m;
  const R = s.state.value[e];
  !o && !R && (s.state.value[e] = {}), _t({});
  let y;
  function A(x) {
    let V;
    p = c = !1, typeof x == "function" ? (x(s.state.value[e]), V = {
      type: mt.patchFunction,
      storeId: e,
      events: m
    }) : (tr(s.state.value[e], x), V = {
      type: mt.patchObject,
      payload: x,
      storeId: e,
      events: m
    });
    const re = y = Symbol();
    Mr().then(() => {
      y === re && (p = !0);
    }), c = !0, Un(d, V, s.state.value[e]);
  }
  const w = o ? function() {
    const { state: V } = t, re = V ? V() : {};
    this.$patch((ve) => {
      en(ve, re);
    });
  } : (
    /* istanbul ignore next */
    wi
  );
  function G() {
    a.stop(), d = [], g = [], s._s.delete(e);
  }
  const H = (x, V = "") => {
    if (Fo in x)
      return x[Ls] = V, x;
    const re = function() {
      us(s);
      const ve = Array.from(arguments), He = [], Qe = [];
      function Jn(L) {
        He.push(L);
      }
      function Dt(L) {
        Qe.push(L);
      }
      Un(g, {
        args: ve,
        name: re[Ls],
        store: j,
        after: Jn,
        onError: Dt
      });
      let ne;
      try {
        ne = x.apply(this && this.$id === e ? this : j, ve);
      } catch (L) {
        throw Un(Qe, L), L;
      }
      return ne instanceof Promise ? ne.then((L) => (Un(He, L), L)).catch((L) => (Un(Qe, L), Promise.reject(L))) : (Un(He, ne), ne);
    };
    return re[Fo] = !0, re[Ls] = V, re;
  }, D = {
    _p: s,
    // _s: scope,
    $id: e,
    $onAction: Vo.bind(null, g),
    $patch: A,
    $reset: w,
    $subscribe(x, V = {}) {
      const re = Vo(d, x, V.detached, () => ve()), ve = a.run(() => jt(() => s.state.value[e], (He) => {
        (V.flush === "sync" ? c : p) && x({
          storeId: e,
          type: mt.direct,
          events: m
        }, He);
      }, en({}, _, V)));
      return re;
    },
    $dispose: G
  }, j = is(D);
  s._s.set(e, j);
  const ee = (s._a && s._a.runWithContext || nd)(() => s._e.run(() => (a = wa()).run(() => n({ action: H }))));
  for (const x in ee) {
    const V = ee[x];
    if (te(V) && !rd(V) || Tn(V))
      o || (R && sd(V) && (te(V) ? V.value = R[x] : tr(V, R[x])), s.state.value[e][x] = V);
    else if (typeof V == "function") {
      const re = H(V, x);
      ee[x] = re, i.actions[x] = V;
    }
  }
  return en(j, ee), en(F(j), ee), Object.defineProperty(j, "$state", {
    get: () => s.state.value[e],
    set: (x) => {
      A((V) => {
        en(V, x);
      });
    }
  }), s._p.forEach((x) => {
    en(j, a.run(() => x({
      store: j,
      app: s._a,
      pinia: s,
      options: i
    })));
  }), R && o && t.hydrate && t.hydrate(j.$state, R), p = !0, c = !0, j;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Vf(e, n, t) {
  let s, r;
  const o = typeof n == "function";
  typeof e == "string" ? (s = e, r = o ? t : n) : (r = e, s = e.id);
  function a(i, _) {
    const p = Fp();
    return i = // in test mode, ignore the argument provided as we can always retrieve a
    // pinia instance with getActivePinia()
    i || (p ? dt(Si, null) : null), i && us(i), i = Ai, i._s.has(s) || (o ? Hi(s, n, r, i) : od(s, r, i)), i._s.get(s);
  }
  return a.$id = s, a;
}
let ad = "Store";
function Ff(...e) {
  return e.reduce((n, t) => (n[t.$id + ad] = function() {
    return t(this.$pinia);
  }, n), {});
}
function Wf(e, n) {
  return Array.isArray(n) ? n.reduce((t, s) => (t[s] = function() {
    return e(this.$pinia)[s];
  }, t), {}) : Object.keys(n).reduce((t, s) => (t[s] = function() {
    const r = e(this.$pinia), o = n[s];
    return typeof o == "function" ? o.call(this, r) : (
      // @ts-expect-error: FIXME: should work?
      r[o]
    );
  }, t), {});
}
function Yf(e, n) {
  return Array.isArray(n) ? n.reduce((t, s) => (t[s] = function(...r) {
    return e(this.$pinia)[s](...r);
  }, t), {}) : Object.keys(n).reduce((t, s) => (t[s] = function(...r) {
    return e(this.$pinia)[n[s]](...r);
  }, t), {});
}
var id = typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
id.SENTRY_RELEASE = { id: "ats-web-components@0.90.2" };
var Fe = /* @__PURE__ */ ((e) => (e.INITIAL = "initial", e.LOADING = "loading", e.LOADED = "loaded", e.ERROR = "error", e))(Fe || {}), _d = /* @__PURE__ */ ((e) => (e.EN = "en", e.FR = "fr", e))(_d || {}), pd = /* @__PURE__ */ ((e) => (e.EN = "en-CA", e.FR = "fr-CA", e))(pd || {}), cd = /* @__PURE__ */ ((e) => (e.Cash = "cash", e.Finance = "finance", e.Lease = "lease", e))(cd || {}), Ui = /* @__PURE__ */ ((e) => (e.GLOBAL = "global", e.CACHE = "cache", e))(Ui || {}), Ci = /* @__PURE__ */ ((e) => (e.REQUEST = "request", e.CACHE_CLEANUP = "cache_cleanup", e.CACHE_ERROR = "cache_error", e))(Ci || {}), Zt = /* @__PURE__ */ ((e) => (e.LOCAL = "local", e.DEV = "dev", e.PROD = "prod", e))(Zt || {});
class dd extends Error {
  constructor(n) {
    super(n), this.name = this.constructor.name;
  }
}
var Xe = /* @__PURE__ */ ((e) => (e.TRACE = "trace", e.DEBUG = "debug", e.INFO = "info", e.WARN = "warn", e.ERROR = "error", e.FATAL = "fatal", e))(Xe || {}), Pi = /* @__PURE__ */ ((e) => (e.CLIENT = "client", e.SERVER = "server", e))(Pi || {}), bt = /* @__PURE__ */ ((e) => (e.NEW_RELIC = "NEW_RELIC", e.SENTRY = "SENTRY", e))(bt || {}), ud = Object.defineProperty, ld = (e, n, t) => n in e ? ud(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, Ie = (e, n, t) => (ld(e, typeof n != "symbol" ? n + "" : n, t), t);
function md(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ls = { exports: {} };
function fd(e) {
  try {
    return JSON.stringify(e);
  } catch {
    return '"[Circular]"';
  }
}
var gd = hd;
function hd(e, n, t) {
  var s = t && t.stringify || fd, r = 1;
  if (typeof e == "object" && e !== null) {
    var o = n.length + r;
    if (o === 1)
      return e;
    var a = new Array(o);
    a[0] = s(e);
    for (var i = 1; i < o; i++)
      a[i] = s(n[i]);
    return a.join(" ");
  }
  if (typeof e != "string")
    return e;
  var _ = n.length;
  if (_ === 0)
    return e;
  for (var p = "", c = 1 - r, d = -1, g = e && e.length || 0, m = 0; m < g; ) {
    if (e.charCodeAt(m) === 37 && m + 1 < g) {
      switch (d = d > -1 ? d : 0, e.charCodeAt(m + 1)) {
        case 100:
        case 102:
          if (c >= _ || n[c] == null)
            break;
          d < m && (p += e.slice(d, m)), p += Number(n[c]), d = m + 2, m++;
          break;
        case 105:
          if (c >= _ || n[c] == null)
            break;
          d < m && (p += e.slice(d, m)), p += Math.floor(Number(n[c])), d = m + 2, m++;
          break;
        case 79:
        case 111:
        case 106:
          if (c >= _ || n[c] === void 0)
            break;
          d < m && (p += e.slice(d, m));
          var R = typeof n[c];
          if (R === "string") {
            p += "'" + n[c] + "'", d = m + 2, m++;
            break;
          }
          if (R === "function") {
            p += n[c].name || "<anonymous>", d = m + 2, m++;
            break;
          }
          p += s(n[c]), d = m + 2, m++;
          break;
        case 115:
          if (c >= _)
            break;
          d < m && (p += e.slice(d, m)), p += String(n[c]), d = m + 2, m++;
          break;
        case 37:
          d < m && (p += e.slice(d, m)), p += "%", d = m + 2, m++, c--;
          break;
      }
      ++c;
    }
    ++m;
  }
  return d === -1 ? e : (d < g && (p += e.slice(d)), p);
}
const Wo = gd;
ls.exports = qe;
const kt = Hd().console || {}, Ed = {
  mapHttpRequest: Ct,
  mapHttpResponse: Ct,
  wrapRequestSerializer: Gs,
  wrapResponseSerializer: Gs,
  wrapErrorSerializer: Gs,
  req: Ct,
  res: Ct,
  err: Ko,
  errWithCause: Ko
};
function an(e, n) {
  return e === "silent" ? 1 / 0 : n.levels.values[e];
}
const Kr = Symbol("pino.logFuncs"), sr = Symbol("pino.hierarchy"), bd = {
  error: "log",
  fatal: "error",
  warn: "error",
  info: "log",
  debug: "log",
  trace: "log"
};
function Yo(e, n) {
  const t = {
    logger: n,
    parent: e[sr]
  };
  n[sr] = t;
}
function kd(e, n, t) {
  const s = {};
  n.forEach((r) => {
    s[r] = t[r] ? t[r] : kt[r] || kt[bd[r] || "log"] || xn;
  }), e[Kr] = s;
}
function vd(e, n) {
  return Array.isArray(e) ? e.filter(function(s) {
    return s !== "!stdSerializers.err";
  }) : e === !0 ? Object.keys(n) : !1;
}
function qe(e) {
  e = e || {}, e.browser = e.browser || {};
  const n = e.browser.transmit;
  if (n && typeof n.send != "function")
    throw Error("pino: transmit option must have a send function");
  const t = e.browser.write || kt;
  e.browser.write && (e.browser.asObject = !0);
  const s = e.serializers || {}, r = vd(e.browser.serialize, s);
  let o = e.browser.serialize;
  Array.isArray(e.browser.serialize) && e.browser.serialize.indexOf("!stdSerializers.err") > -1 && (o = !1);
  const a = Object.keys(e.customLevels || {}), i = ["error", "fatal", "warn", "info", "debug", "trace"].concat(a);
  typeof t == "function" && i.forEach(function(y) {
    t[y] = t;
  }), (e.enabled === !1 || e.browser.disabled) && (e.level = "silent");
  const _ = e.level || "info", p = Object.create(t);
  p.log || (p.log = xn), kd(p, i, t), Yo({}, p), Object.defineProperty(p, "levelVal", {
    get: d
  }), Object.defineProperty(p, "level", {
    get: g,
    set: m
  });
  const c = {
    transmit: n,
    serialize: r,
    asObject: e.browser.asObject,
    formatters: e.browser.formatters,
    levels: i,
    timestamp: Ad(e),
    messageKey: e.messageKey || "msg",
    onChild: e.onChild || xn
  };
  p.levels = Td(e), p.level = _, p.setMaxListeners = p.getMaxListeners = p.emit = p.addListener = p.on = p.prependListener = p.once = p.prependOnceListener = p.removeListener = p.removeAllListeners = p.listeners = p.listenerCount = p.eventNames = p.write = p.flush = xn, p.serializers = s, p._serialize = r, p._stdErrSerialize = o, p.child = function(...y) {
    return R.call(this, c, ...y);
  }, n && (p._logEvent = rr());
  function d() {
    return an(this.level, this);
  }
  function g() {
    return this._level;
  }
  function m(y) {
    if (y !== "silent" && !this.levels.values[y])
      throw Error("unknown level " + y);
    this._level = y, bn(this, c, p, "error"), bn(this, c, p, "fatal"), bn(this, c, p, "warn"), bn(this, c, p, "info"), bn(this, c, p, "debug"), bn(this, c, p, "trace"), a.forEach((A) => {
      bn(this, c, p, A);
    });
  }
  function R(y, A, w) {
    if (!A)
      throw new Error("missing bindings for child Pino");
    w = w || {}, r && A.serializers && (w.serializers = A.serializers);
    const G = w.serializers;
    if (r && G) {
      var H = Object.assign({}, s, G), D = e.browser.serialize === !0 ? Object.keys(H) : r;
      delete A.serializers, Xr([A], D, H, this._stdErrSerialize);
    }
    function j(ee) {
      this._childLevel = (ee._childLevel | 0) + 1, this.bindings = A, H && (this.serializers = H, this._serialize = D), n && (this._logEvent = rr(
        [].concat(ee._logEvent.bindings, A)
      ));
    }
    j.prototype = this;
    const ce = new j(this);
    return Yo(this, ce), ce.child = function(...ee) {
      return R.call(this, y, ...ee);
    }, ce.level = w.level || this.level, y.onChild(ce), ce;
  }
  return p;
}
function Td(e) {
  const n = e.customLevels || {}, t = Object.assign({}, qe.levels.values, n), s = Object.assign({}, qe.levels.labels, Rd(n));
  return {
    values: t,
    labels: s
  };
}
function Rd(e) {
  const n = {};
  return Object.keys(e).forEach(function(t) {
    n[e[t]] = t;
  }), n;
}
qe.levels = {
  values: {
    fatal: 60,
    error: 50,
    warn: 40,
    info: 30,
    debug: 20,
    trace: 10
  },
  labels: {
    10: "trace",
    20: "debug",
    30: "info",
    40: "warn",
    50: "error",
    60: "fatal"
  }
};
qe.stdSerializers = Ed;
qe.stdTimeFunctions = Object.assign({}, { nullTime: Mi, epochTime: Li, unixTime: Sd, isoTime: wd });
function yd(e) {
  const n = [];
  e.bindings && n.push(e.bindings);
  let t = e[sr];
  for (; t.parent; )
    t = t.parent, t.logger.bindings && n.push(t.logger.bindings);
  return n.reverse();
}
function bn(e, n, t, s) {
  if (Object.defineProperty(e, s, {
    value: an(e.level, t) > an(s, t) ? xn : t[Kr][s],
    writable: !0,
    enumerable: !0,
    configurable: !0
  }), e[s] === xn) {
    if (!n.transmit)
      return;
    const o = n.transmit.level || e.level, a = an(o, t);
    if (an(s, t) < a)
      return;
  }
  e[s] = Od(e, n, t, s);
  const r = yd(e);
  r.length !== 0 && (e[s] = Id(r, e[s]));
}
function Id(e, n) {
  return function() {
    return n.apply(this, [...e, ...arguments]);
  };
}
function Od(e, n, t, s) {
  return function(r) {
    return function() {
      const a = n.timestamp(), i = new Array(arguments.length), _ = Object.getPrototypeOf && Object.getPrototypeOf(this) === kt ? kt : this;
      for (var p = 0; p < i.length; p++)
        i[p] = arguments[p];
      var c = !1;
      if (n.serialize && (Xr(i, this._serialize, this.serializers, this._stdErrSerialize), c = !0), n.asObject || n.formatters ? r.call(_, Nd(this, s, i, a, n)) : r.apply(_, i), n.transmit) {
        const d = n.transmit.level || e._level, g = an(d, t), m = an(s, t);
        if (m < g)
          return;
        Dd(this, {
          ts: a,
          methodLevel: s,
          methodValue: m,
          transmitLevel: d,
          transmitValue: t.levels.values[n.transmit.level || e._level],
          send: n.transmit.send,
          val: an(e._level, t)
        }, i, c);
      }
    };
  }(e[Kr][s]);
}
function Nd(e, n, t, s, r) {
  const {
    level: o,
    log: a = (g) => g
  } = r.formatters || {}, i = t.slice();
  let _ = i[0];
  const p = {};
  if (s && (p.time = s), o) {
    const g = o(n, e.levels.values[n]);
    Object.assign(p, g);
  } else
    p.level = e.levels.values[n];
  let c = (e._childLevel | 0) + 1;
  if (c < 1 && (c = 1), _ !== null && typeof _ == "object") {
    for (; c-- && typeof i[0] == "object"; )
      Object.assign(p, i.shift());
    _ = i.length ? Wo(i.shift(), i) : void 0;
  } else
    typeof _ == "string" && (_ = Wo(i.shift(), i));
  return _ !== void 0 && (p[r.messageKey] = _), a(p);
}
function Xr(e, n, t, s) {
  for (const r in e)
    if (s && e[r] instanceof Error)
      e[r] = qe.stdSerializers.err(e[r]);
    else if (typeof e[r] == "object" && !Array.isArray(e[r]) && n)
      for (const o in e[r])
        n.indexOf(o) > -1 && o in t && (e[r][o] = t[o](e[r][o]));
}
function Dd(e, n, t, s = !1) {
  const r = n.send, o = n.ts, a = n.methodLevel, i = n.methodValue, _ = n.val, p = e._logEvent.bindings;
  s || Xr(
    t,
    e._serialize || Object.keys(e.serializers),
    e.serializers,
    e._stdErrSerialize === void 0 ? !0 : e._stdErrSerialize
  ), e._logEvent.ts = o, e._logEvent.messages = t.filter(function(c) {
    return p.indexOf(c) === -1;
  }), e._logEvent.level.label = a, e._logEvent.level.value = i, r(a, e._logEvent, _), e._logEvent = rr(p);
}
function rr(e) {
  return {
    ts: 0,
    messages: [],
    bindings: e || [],
    level: { label: "", value: 0 }
  };
}
function Ko(e) {
  const n = {
    type: e.constructor.name,
    msg: e.message,
    stack: e.stack
  };
  for (const t in e)
    n[t] === void 0 && (n[t] = e[t]);
  return n;
}
function Ad(e) {
  return typeof e.timestamp == "function" ? e.timestamp : e.timestamp === !1 ? Mi : Li;
}
function Ct() {
  return {};
}
function Gs(e) {
  return e;
}
function xn() {
}
function Mi() {
  return !1;
}
function Li() {
  return Date.now();
}
function Sd() {
  return Math.round(Date.now() / 1e3);
}
function wd() {
  return new Date(Date.now()).toISOString();
}
function Hd() {
  function e(n) {
    return typeof n < "u" && n;
  }
  try {
    return typeof globalThis < "u" || Object.defineProperty(Object.prototype, "globalThis", {
      get: function() {
        return delete Object.prototype.globalThis, this.globalThis = this;
      },
      configurable: !0
    }), globalThis;
  } catch {
    return e(self) || e(window) || e(this) || {};
  }
}
ls.exports.default = qe;
ls.exports.pino = qe;
var Ud = ls.exports;
const Cd = /* @__PURE__ */ md(Ud), Pd = (e) => ({
  level: e === Zt.PROD ? "info" : "debug"
}), Md = {
  initialize: (e) => Cd({
    ...Pd(e.environment),
    ...e
  })
}, Xo = {
  /**
   * The external services to which the logger sends the log messages.
   * If you want to send the log messages to an external service, add
   * the service to this array. The order is irrelevant.
   */
  logSenders: [bt.NEW_RELIC, bt.SENTRY]
};
class Ld {
  constructor({ logPayload: n, credentials: t }) {
    Ie(this, "_API_URL", "https://log-api.newrelic.com/log/v1"), Ie(this, "_logPayload"), Ie(this, "_isEnabled"), Ie(this, "_licenseKey"), this._logPayload = n;
    const { enabled: s, licenseKey: r } = t;
    if (this._isEnabled = s ?? !1, this._licenseKey = r ?? "", !this._isEnabled) {
      console.warn("New Relic is not enabled. Logs will not be sent.");
      return;
    }
    if (!this._licenseKey) {
      console.warn("New Relic license key is not defined. Logs will not be sent.");
      return;
    }
  }
  /**
   * Sends the log message to New Relic.
   *
   * We send all log levels to New Relic.
   */
  send(n) {
    if (!this._isEnabled) {
      console.warn("New Relic is not enabled. Log will not be sent.");
      return;
    }
    if (!this._licenseKey) {
      console.warn("New Relic license key is not defined. Log will not be sent.");
      return;
    }
    const t = this._prepare_request(n);
    fetch(this._API_URL, t).catch((s) => {
      console.error("Error sending log:", s);
    });
  }
  _prepare_request(n) {
    return {
      method: "POST",
      headers: this._get_headers(),
      body: JSON.stringify({ ...this._logPayload, message: n })
    };
  }
  _get_headers() {
    return {
      "Content-Type": "application/json",
      "Api-Key": this._licenseKey
    };
  }
}
const Gi = Object.prototype.toString;
function xi(e) {
  switch (Gi.call(e)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
      return !0;
    default:
      return On(e, Error);
  }
}
function Xn(e, n) {
  return Gi.call(e) === `[object ${n}]`;
}
function $r(e) {
  return Xn(e, "ErrorEvent");
}
function $o(e) {
  return Xn(e, "DOMError");
}
function Gd(e) {
  return Xn(e, "DOMException");
}
function Je(e) {
  return Xn(e, "String");
}
function Jr(e) {
  return e === null || typeof e != "object" && typeof e != "function";
}
function Fn(e) {
  return Xn(e, "Object");
}
function ms(e) {
  return typeof Event < "u" && On(e, Event);
}
function xd(e) {
  return typeof Element < "u" && On(e, Element);
}
function Bd(e) {
  return Xn(e, "RegExp");
}
function zr(e) {
  return !!(e && e.then && typeof e.then == "function");
}
function jd(e) {
  return Fn(e) && "nativeEvent" in e && "preventDefault" in e && "stopPropagation" in e;
}
function Vd(e) {
  return typeof e == "number" && e !== e;
}
function On(e, n) {
  try {
    return e instanceof n;
  } catch {
    return !1;
  }
}
function Bi(e) {
  return !!(typeof e == "object" && e !== null && (e.__isVue || e._isVue));
}
function Bn(e, n = 0) {
  return typeof e != "string" || n === 0 || e.length <= n ? e : `${e.slice(0, n)}...`;
}
function Jo(e, n) {
  if (!Array.isArray(e))
    return "";
  const t = [];
  for (let s = 0; s < e.length; s++) {
    const r = e[s];
    try {
      Bi(r) ? t.push("[VueViewModel]") : t.push(String(r));
    } catch {
      t.push("[value cannot be serialized]");
    }
  }
  return t.join(n);
}
function Fd(e, n, t = !1) {
  return Je(e) ? Bd(n) ? n.test(e) : Je(n) ? t ? e === n : e.includes(n) : !1 : !1;
}
function fs(e, n = [], t = !1) {
  return n.some((s) => Fd(e, s, t));
}
function Wd(e, n, t = 250, s, r, o, a) {
  if (!o.exception || !o.exception.values || !a || !On(a.originalException, Error))
    return;
  const i = o.exception.values.length > 0 ? o.exception.values[o.exception.values.length - 1] : void 0;
  i && (o.exception.values = Yd(
    or(
      e,
      n,
      r,
      a.originalException,
      s,
      o.exception.values,
      i,
      0
    ),
    t
  ));
}
function or(e, n, t, s, r, o, a, i) {
  if (o.length >= t + 1)
    return o;
  let _ = [...o];
  if (On(s[r], Error)) {
    zo(a, i);
    const p = e(n, s[r]), c = _.length;
    qo(p, r, c, i), _ = or(
      e,
      n,
      t,
      s[r],
      r,
      [p, ..._],
      p,
      c
    );
  }
  return Array.isArray(s.errors) && s.errors.forEach((p, c) => {
    if (On(p, Error)) {
      zo(a, i);
      const d = e(n, p), g = _.length;
      qo(d, `errors[${c}]`, g, i), _ = or(
        e,
        n,
        t,
        p,
        r,
        [d, ..._],
        d,
        g
      );
    }
  }), _;
}
function zo(e, n) {
  e.mechanism = e.mechanism || { type: "generic", handled: !0 }, e.mechanism = {
    ...e.mechanism,
    is_exception_group: !0,
    exception_id: n
  };
}
function qo(e, n, t, s) {
  e.mechanism = e.mechanism || { type: "generic", handled: !0 }, e.mechanism = {
    ...e.mechanism,
    type: "chained",
    source: n,
    exception_id: t,
    parent_id: s
  };
}
function Yd(e, n) {
  return e.map((t) => (t.value && (t.value = Bn(t.value, n)), t));
}
function Pt(e) {
  return e && e.Math == Math ? e : void 0;
}
const K = typeof globalThis == "object" && Pt(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && Pt(window) || typeof self == "object" && Pt(self) || typeof global == "object" && Pt(global) || function() {
  return this;
}() || {};
function gs() {
  return K;
}
function ji(e, n, t) {
  const s = t || K, r = s.__SENTRY__ = s.__SENTRY__ || {};
  return r[e] || (r[e] = n());
}
const qr = gs(), Kd = 80;
function Vi(e, n = {}) {
  if (!e)
    return "<unknown>";
  try {
    let t = e;
    const s = 5, r = [];
    let o = 0, a = 0;
    const i = " > ", _ = i.length;
    let p;
    const c = Array.isArray(n) ? n : n.keyAttrs, d = !Array.isArray(n) && n.maxStringLength || Kd;
    for (; t && o++ < s && (p = Xd(t, c), !(p === "html" || o > 1 && a + r.length * _ + p.length >= d)); )
      r.push(p), a += p.length, t = t.parentNode;
    return r.reverse().join(i);
  } catch {
    return "<unknown>";
  }
}
function Xd(e, n) {
  const t = e, s = [];
  let r, o, a, i, _;
  if (!t || !t.tagName)
    return "";
  if (qr.HTMLElement && t instanceof HTMLElement && t.dataset && t.dataset.sentryComponent)
    return t.dataset.sentryComponent;
  s.push(t.tagName.toLowerCase());
  const p = n && n.length ? n.filter((d) => t.getAttribute(d)).map((d) => [d, t.getAttribute(d)]) : null;
  if (p && p.length)
    p.forEach((d) => {
      s.push(`[${d[0]}="${d[1]}"]`);
    });
  else if (t.id && s.push(`#${t.id}`), r = t.className, r && Je(r))
    for (o = r.split(/\s+/), _ = 0; _ < o.length; _++)
      s.push(`.${o[_]}`);
  const c = ["aria-label", "type", "name", "title", "alt"];
  for (_ = 0; _ < c.length; _++)
    a = c[_], i = t.getAttribute(a), i && s.push(`[${a}="${i}"]`);
  return s.join("");
}
function $d() {
  try {
    return qr.document.location.href;
  } catch {
    return "";
  }
}
function Jd(e) {
  if (!qr.HTMLElement)
    return null;
  let n = e;
  const t = 5;
  for (let s = 0; s < t; s++) {
    if (!n)
      return null;
    if (n instanceof HTMLElement && n.dataset.sentryComponent)
      return n.dataset.sentryComponent;
    n = n.parentNode;
  }
  return null;
}
const Ot = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, zd = "Sentry Logger ", ar = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], Qt = {};
function Zr(e) {
  if (!("console" in K))
    return e();
  const n = K.console, t = {}, s = Object.keys(Qt);
  s.forEach((r) => {
    const o = Qt[r];
    t[r] = n[r], n[r] = o;
  });
  try {
    return e();
  } finally {
    s.forEach((r) => {
      n[r] = t[r];
    });
  }
}
function qd() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return Ot ? ar.forEach((t) => {
    n[t] = (...s) => {
      e && Zr(() => {
        K.console[t](`${zd}[${t}]:`, ...s);
      });
    };
  }) : ar.forEach((t) => {
    n[t] = () => {
    };
  }), n;
}
const M = qd(), Zd = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function Qd(e) {
  return e === "http" || e === "https";
}
function Nt(e, n = !1) {
  const { host: t, path: s, pass: r, port: o, projectId: a, protocol: i, publicKey: _ } = e;
  return `${i}://${_}${n && r ? `:${r}` : ""}@${t}${o ? `:${o}` : ""}/${s && `${s}/`}${a}`;
}
function eu(e) {
  const n = Zd.exec(e);
  if (!n) {
    Zr(() => {
      console.error(`Invalid Sentry Dsn: ${e}`);
    });
    return;
  }
  const [t, s, r = "", o, a = "", i] = n.slice(1);
  let _ = "", p = i;
  const c = p.split("/");
  if (c.length > 1 && (_ = c.slice(0, -1).join("/"), p = c.pop()), p) {
    const d = p.match(/^\d+/);
    d && (p = d[0]);
  }
  return Fi({ host: o, pass: r, path: _, projectId: p, port: a, protocol: t, publicKey: s });
}
function Fi(e) {
  return {
    protocol: e.protocol,
    publicKey: e.publicKey || "",
    pass: e.pass || "",
    host: e.host,
    port: e.port || "",
    path: e.path || "",
    projectId: e.projectId
  };
}
function nu(e) {
  if (!Ot)
    return !0;
  const { port: n, projectId: t, protocol: s } = e;
  return ["protocol", "publicKey", "host", "projectId"].find((a) => e[a] ? !1 : (M.error(`Invalid Sentry Dsn: ${a} missing`), !0)) ? !1 : t.match(/^\d+$/) ? Qd(s) ? n && isNaN(parseInt(n, 10)) ? (M.error(`Invalid Sentry Dsn: Invalid port ${n}`), !1) : !0 : (M.error(`Invalid Sentry Dsn: Invalid protocol ${s}`), !1) : (M.error(`Invalid Sentry Dsn: Invalid projectId ${t}`), !1);
}
function tu(e) {
  const n = typeof e == "string" ? eu(e) : Fi(e);
  if (!(!n || !nu(n)))
    return n;
}
class Ge extends Error {
  /** Display name of this error instance. */
  constructor(n, t = "warn") {
    super(n), this.message = n, this.name = new.target.prototype.constructor.name, Object.setPrototypeOf(this, new.target.prototype), this.logLevel = t;
  }
}
function ie(e, n, t) {
  if (!(n in e))
    return;
  const s = e[n], r = t(s);
  typeof r == "function" && Wi(r, s), e[n] = r;
}
function vt(e, n, t) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: t,
      writable: !0,
      configurable: !0
    });
  } catch {
    Ot && M.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
function Wi(e, n) {
  try {
    const t = n.prototype || {};
    e.prototype = n.prototype = t, vt(e, "__sentry_original__", n);
  } catch {
  }
}
function Qr(e) {
  return e.__sentry_original__;
}
function su(e) {
  return Object.keys(e).map((n) => `${encodeURIComponent(n)}=${encodeURIComponent(e[n])}`).join("&");
}
function Yi(e) {
  if (xi(e))
    return {
      message: e.message,
      name: e.name,
      stack: e.stack,
      ...Qo(e)
    };
  if (ms(e)) {
    const n = {
      type: e.type,
      target: Zo(e.target),
      currentTarget: Zo(e.currentTarget),
      ...Qo(e)
    };
    return typeof CustomEvent < "u" && On(e, CustomEvent) && (n.detail = e.detail), n;
  } else
    return e;
}
function Zo(e) {
  try {
    return xd(e) ? Vi(e) : Object.prototype.toString.call(e);
  } catch {
    return "<unknown>";
  }
}
function Qo(e) {
  if (typeof e == "object" && e !== null) {
    const n = {};
    for (const t in e)
      Object.prototype.hasOwnProperty.call(e, t) && (n[t] = e[t]);
    return n;
  } else
    return {};
}
function ru(e, n = 40) {
  const t = Object.keys(Yi(e));
  if (t.sort(), !t.length)
    return "[object has no keys]";
  if (t[0].length >= n)
    return Bn(t[0], n);
  for (let s = t.length; s > 0; s--) {
    const r = t.slice(0, s).join(", ");
    if (!(r.length > n))
      return s === t.length ? r : Bn(r, n);
  }
  return "";
}
function hs(e) {
  return ir(e, /* @__PURE__ */ new Map());
}
function ir(e, n) {
  if (Fn(e)) {
    const t = n.get(e);
    if (t !== void 0)
      return t;
    const s = {};
    n.set(e, s);
    for (const r of Object.keys(e))
      typeof e[r] < "u" && (s[r] = ir(e[r], n));
    return s;
  }
  if (Array.isArray(e)) {
    const t = n.get(e);
    if (t !== void 0)
      return t;
    const s = [];
    return n.set(e, s), e.forEach((r) => {
      s.push(ir(r, n));
    }), s;
  }
  return e;
}
const Ki = 50, ea = /\(error: (.*)\)/, na = /captureMessage|captureException/;
function ou(...e) {
  const n = e.sort((t, s) => t[0] - s[0]).map((t) => t[1]);
  return (t, s = 0) => {
    const r = [], o = t.split(`
`);
    for (let a = s; a < o.length; a++) {
      const i = o[a];
      if (i.length > 1024)
        continue;
      const _ = ea.test(i) ? i.replace(ea, "$1") : i;
      if (!_.match(/\S*Error: /)) {
        for (const p of n) {
          const c = p(_);
          if (c) {
            r.push(c);
            break;
          }
        }
        if (r.length >= Ki)
          break;
      }
    }
    return au(r);
  };
}
function au(e) {
  if (!e.length)
    return [];
  const n = Array.from(e);
  return /sentryWrapped/.test(n[n.length - 1].function || "") && n.pop(), n.reverse(), na.test(n[n.length - 1].function || "") && (n.pop(), na.test(n[n.length - 1].function || "") && n.pop()), n.slice(0, Ki).map((t) => ({
    ...t,
    filename: t.filename || n[n.length - 1].filename,
    function: t.function || "?"
  }));
}
const xs = "<anonymous>";
function cn(e) {
  try {
    return !e || typeof e != "function" ? xs : e.name || xs;
  } catch {
    return xs;
  }
}
const Wt = {}, ta = {};
function Dn(e, n) {
  Wt[e] = Wt[e] || [], Wt[e].push(n);
}
function An(e, n) {
  ta[e] || (n(), ta[e] = !0);
}
function we(e, n) {
  const t = e && Wt[e];
  if (t)
    for (const s of t)
      try {
        s(n);
      } catch (r) {
        Ot && M.error(
          `Error while triggering instrumentation handler.
Type: ${e}
Name: ${cn(s)}
Error:`,
          r
        );
      }
}
function iu(e) {
  const n = "console";
  Dn(n, e), An(n, _u);
}
function _u() {
  "console" in K && ar.forEach(function(e) {
    e in K.console && ie(K.console, e, function(n) {
      return Qt[e] = n, function(...t) {
        we("console", { args: t, level: e });
        const r = Qt[e];
        r && r.apply(K.console, t);
      };
    });
  });
}
function ze() {
  const e = K, n = e.crypto || e.msCrypto;
  let t = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (t = () => {
      const s = new Uint8Array(1);
      return n.getRandomValues(s), s[0];
    });
  } catch {
  }
  return ([1e7] + 1e3 + 4e3 + 8e3 + 1e11).replace(
    /[018]/g,
    (s) => (
      // eslint-disable-next-line no-bitwise
      (s ^ (t() & 15) >> s / 4).toString(16)
    )
  );
}
function Xi(e) {
  return e.exception && e.exception.values ? e.exception.values[0] : void 0;
}
function on(e) {
  const { message: n, event_id: t } = e;
  if (n)
    return n;
  const s = Xi(e);
  return s ? s.type && s.value ? `${s.type}: ${s.value}` : s.type || s.value || t || "<unknown>" : t || "<unknown>";
}
function _r(e, n, t) {
  const s = e.exception = e.exception || {}, r = s.values = s.values || [], o = r[0] = r[0] || {};
  o.value || (o.value = n || ""), o.type || (o.type = t || "Error");
}
function Tt(e, n) {
  const t = Xi(e);
  if (!t)
    return;
  const s = { type: "generic", handled: !0 }, r = t.mechanism;
  if (t.mechanism = { ...s, ...r, ...n }, n && "data" in n) {
    const o = { ...r && r.data, ...n.data };
    t.mechanism.data = o;
  }
}
function sa(e) {
  if (e && e.__sentry_captured__)
    return !0;
  try {
    vt(e, "__sentry_captured__", !0);
  } catch {
  }
  return !1;
}
function pu(e) {
  return Array.isArray(e) ? e : [e];
}
const Pn = K, cu = 1e3;
let ra, pr, cr;
function du(e) {
  const n = "dom";
  Dn(n, e), An(n, uu);
}
function uu() {
  if (!Pn.document)
    return;
  const e = we.bind(null, "dom"), n = oa(e, !0);
  Pn.document.addEventListener("click", n, !1), Pn.document.addEventListener("keypress", n, !1), ["EventTarget", "Node"].forEach((t) => {
    const s = Pn[t] && Pn[t].prototype;
    !s || !s.hasOwnProperty || !s.hasOwnProperty("addEventListener") || (ie(s, "addEventListener", function(r) {
      return function(o, a, i) {
        if (o === "click" || o == "keypress")
          try {
            const _ = this, p = _.__sentry_instrumentation_handlers__ = _.__sentry_instrumentation_handlers__ || {}, c = p[o] = p[o] || { refCount: 0 };
            if (!c.handler) {
              const d = oa(e);
              c.handler = d, r.call(this, o, d, i);
            }
            c.refCount++;
          } catch {
          }
        return r.call(this, o, a, i);
      };
    }), ie(
      s,
      "removeEventListener",
      function(r) {
        return function(o, a, i) {
          if (o === "click" || o == "keypress")
            try {
              const _ = this, p = _.__sentry_instrumentation_handlers__ || {}, c = p[o];
              c && (c.refCount--, c.refCount <= 0 && (r.call(this, o, c.handler, i), c.handler = void 0, delete p[o]), Object.keys(p).length === 0 && delete _.__sentry_instrumentation_handlers__);
            } catch {
            }
          return r.call(this, o, a, i);
        };
      }
    ));
  });
}
function lu(e) {
  if (e.type !== pr)
    return !1;
  try {
    if (!e.target || e.target._sentryId !== cr)
      return !1;
  } catch {
  }
  return !0;
}
function mu(e, n) {
  return e !== "keypress" ? !1 : !n || !n.tagName ? !0 : !(n.tagName === "INPUT" || n.tagName === "TEXTAREA" || n.isContentEditable);
}
function oa(e, n = !1) {
  return (t) => {
    if (!t || t._sentryCaptured)
      return;
    const s = fu(t);
    if (mu(t.type, s))
      return;
    vt(t, "_sentryCaptured", !0), s && !s._sentryId && vt(s, "_sentryId", ze());
    const r = t.type === "keypress" ? "input" : t.type;
    lu(t) || (e({ event: t, name: r, global: n }), pr = t.type, cr = s ? s._sentryId : void 0), clearTimeout(ra), ra = Pn.setTimeout(() => {
      cr = void 0, pr = void 0;
    }, cu);
  };
}
function fu(e) {
  try {
    return e.target;
  } catch {
    return null;
  }
}
const dr = gs();
function gu() {
  if (!("fetch" in dr))
    return !1;
  try {
    return new Headers(), new Request("http://www.example.com"), new Response(), !0;
  } catch {
    return !1;
  }
}
function ur(e) {
  return e && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
}
function hu() {
  if (typeof EdgeRuntime == "string")
    return !0;
  if (!gu())
    return !1;
  if (ur(dr.fetch))
    return !0;
  let e = !1;
  const n = dr.document;
  if (n && typeof n.createElement == "function")
    try {
      const t = n.createElement("iframe");
      t.hidden = !0, n.head.appendChild(t), t.contentWindow && t.contentWindow.fetch && (e = ur(t.contentWindow.fetch)), n.head.removeChild(t);
    } catch (t) {
      Ot && M.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", t);
    }
  return e;
}
function Eu(e) {
  const n = "fetch";
  Dn(n, e), An(n, bu);
}
function bu() {
  hu() && ie(K, "fetch", function(e) {
    return function(...n) {
      const { method: t, url: s } = ku(n), r = {
        args: n,
        fetchData: {
          method: t,
          url: s
        },
        startTimestamp: Date.now()
      };
      return we("fetch", {
        ...r
      }), e.apply(K, n).then(
        (o) => {
          const a = {
            ...r,
            endTimestamp: Date.now(),
            response: o
          };
          return we("fetch", a), o;
        },
        (o) => {
          const a = {
            ...r,
            endTimestamp: Date.now(),
            error: o
          };
          throw we("fetch", a), o;
        }
      );
    };
  });
}
function lr(e, n) {
  return !!e && typeof e == "object" && !!e[n];
}
function aa(e) {
  return typeof e == "string" ? e : e ? lr(e, "url") ? e.url : e.toString ? e.toString() : "" : "";
}
function ku(e) {
  if (e.length === 0)
    return { method: "GET", url: "" };
  if (e.length === 2) {
    const [t, s] = e;
    return {
      url: aa(t),
      method: lr(s, "method") ? String(s.method).toUpperCase() : "GET"
    };
  }
  const n = e[0];
  return {
    url: aa(n),
    method: lr(n, "method") ? String(n.method).toUpperCase() : "GET"
  };
}
let Mt = null;
function vu(e) {
  const n = "error";
  Dn(n, e), An(n, Tu);
}
function Tu() {
  Mt = K.onerror, K.onerror = function(e, n, t, s, r) {
    return we("error", {
      column: s,
      error: r,
      line: t,
      msg: e,
      url: n
    }), Mt && !Mt.__SENTRY_LOADER__ ? Mt.apply(this, arguments) : !1;
  }, K.onerror.__SENTRY_INSTRUMENTED__ = !0;
}
let Lt = null;
function Ru(e) {
  const n = "unhandledrejection";
  Dn(n, e), An(n, yu);
}
function yu() {
  Lt = K.onunhandledrejection, K.onunhandledrejection = function(e) {
    return we("unhandledrejection", e), Lt && !Lt.__SENTRY_LOADER__ ? Lt.apply(this, arguments) : !0;
  }, K.onunhandledrejection.__SENTRY_INSTRUMENTED__ = !0;
}
const Gt = gs();
function Iu() {
  const e = Gt.chrome, n = e && e.app && e.app.runtime, t = "history" in Gt && !!Gt.history.pushState && !!Gt.history.replaceState;
  return !n && t;
}
const et = K;
let xt;
function Ou(e) {
  const n = "history";
  Dn(n, e), An(n, Nu);
}
function Nu() {
  if (!Iu())
    return;
  const e = et.onpopstate;
  et.onpopstate = function(...t) {
    const s = et.location.href, r = xt;
    if (xt = s, we("history", { from: r, to: s }), e)
      try {
        return e.apply(this, t);
      } catch {
      }
  };
  function n(t) {
    return function(...s) {
      const r = s.length > 2 ? s[2] : void 0;
      if (r) {
        const o = xt, a = String(r);
        xt = a, we("history", { from: o, to: a });
      }
      return t.apply(this, s);
    };
  }
  ie(et.history, "pushState", n), ie(et.history, "replaceState", n);
}
const Du = K, st = "__sentry_xhr_v3__";
function Au(e) {
  const n = "xhr";
  Dn(n, e), An(n, Su);
}
function Su() {
  if (!Du.XMLHttpRequest)
    return;
  const e = XMLHttpRequest.prototype;
  ie(e, "open", function(n) {
    return function(...t) {
      const s = Date.now(), r = Je(t[0]) ? t[0].toUpperCase() : void 0, o = wu(t[1]);
      if (!r || !o)
        return n.apply(this, t);
      this[st] = {
        method: r,
        url: o,
        request_headers: {}
      }, r === "POST" && o.match(/sentry_key/) && (this.__sentry_own_request__ = !0);
      const a = () => {
        const i = this[st];
        if (i && this.readyState === 4) {
          try {
            i.status_code = this.status;
          } catch {
          }
          const _ = {
            args: [r, o],
            endTimestamp: Date.now(),
            startTimestamp: s,
            xhr: this
          };
          we("xhr", _);
        }
      };
      return "onreadystatechange" in this && typeof this.onreadystatechange == "function" ? ie(this, "onreadystatechange", function(i) {
        return function(..._) {
          return a(), i.apply(this, _);
        };
      }) : this.addEventListener("readystatechange", a), ie(this, "setRequestHeader", function(i) {
        return function(..._) {
          const [p, c] = _, d = this[st];
          return d && Je(p) && Je(c) && (d.request_headers[p.toLowerCase()] = c), i.apply(this, _);
        };
      }), n.apply(this, t);
    };
  }), ie(e, "send", function(n) {
    return function(...t) {
      const s = this[st];
      if (!s)
        return n.apply(this, t);
      t[0] !== void 0 && (s.body = t[0]);
      const r = {
        args: [s.method, s.url],
        startTimestamp: Date.now(),
        xhr: this
      };
      return we("xhr", r), n.apply(this, t);
    };
  });
}
function wu(e) {
  if (Je(e))
    return e;
  try {
    return e.toString();
  } catch {
  }
}
function Hu() {
  return typeof __SENTRY_BROWSER_BUNDLE__ < "u" && !!__SENTRY_BROWSER_BUNDLE__;
}
function Uu() {
  return "npm";
}
function Cu() {
  return !Hu() && Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]";
}
function Pu(e, n) {
  return e.require(n);
}
function Mu() {
  const e = typeof WeakSet == "function", n = e ? /* @__PURE__ */ new WeakSet() : [];
  function t(r) {
    if (e)
      return n.has(r) ? !0 : (n.add(r), !1);
    for (let o = 0; o < n.length; o++)
      if (n[o] === r)
        return !0;
    return n.push(r), !1;
  }
  function s(r) {
    if (e)
      n.delete(r);
    else
      for (let o = 0; o < n.length; o++)
        if (n[o] === r) {
          n.splice(o, 1);
          break;
        }
  }
  return [t, s];
}
function sn(e, n = 100, t = 1 / 0) {
  try {
    return mr("", e, n, t);
  } catch (s) {
    return { ERROR: `**non-serializable** (${s})` };
  }
}
function $i(e, n = 3, t = 100 * 1024) {
  const s = sn(e, n);
  return Bu(s) > t ? $i(e, n - 1, t) : s;
}
function mr(e, n, t = 1 / 0, s = 1 / 0, r = Mu()) {
  const [o, a] = r;
  if (n == null || // this matches null and undefined -> eqeq not eqeqeq
  ["number", "boolean", "string"].includes(typeof n) && !Vd(n))
    return n;
  const i = Lu(e, n);
  if (!i.startsWith("[object "))
    return i;
  if (n.__sentry_skip_normalization__)
    return n;
  const _ = typeof n.__sentry_override_normalization_depth__ == "number" ? n.__sentry_override_normalization_depth__ : t;
  if (_ === 0)
    return i.replace("object ", "");
  if (o(n))
    return "[Circular ~]";
  const p = n;
  if (p && typeof p.toJSON == "function")
    try {
      const m = p.toJSON();
      return mr("", m, _ - 1, s, r);
    } catch {
    }
  const c = Array.isArray(n) ? [] : {};
  let d = 0;
  const g = Yi(n);
  for (const m in g) {
    if (!Object.prototype.hasOwnProperty.call(g, m))
      continue;
    if (d >= s) {
      c[m] = "[MaxProperties ~]";
      break;
    }
    const R = g[m];
    c[m] = mr(m, R, _ - 1, s, r), d++;
  }
  return a(n), c;
}
function Lu(e, n) {
  try {
    if (e === "domain" && n && typeof n == "object" && n._events)
      return "[Domain]";
    if (e === "domainEmitter")
      return "[DomainEmitter]";
    if (typeof global < "u" && n === global)
      return "[Global]";
    if (typeof window < "u" && n === window)
      return "[Window]";
    if (typeof document < "u" && n === document)
      return "[Document]";
    if (Bi(n))
      return "[VueViewModel]";
    if (jd(n))
      return "[SyntheticEvent]";
    if (typeof n == "number" && n !== n)
      return "[NaN]";
    if (typeof n == "function")
      return `[Function: ${cn(n)}]`;
    if (typeof n == "symbol")
      return `[${String(n)}]`;
    if (typeof n == "bigint")
      return `[BigInt: ${String(n)}]`;
    const t = Gu(n);
    return /^HTML(\w*)Element$/.test(t) ? `[HTMLElement: ${t}]` : `[object ${t}]`;
  } catch (t) {
    return `**non-serializable** (${t})`;
  }
}
function Gu(e) {
  const n = Object.getPrototypeOf(e);
  return n ? n.constructor.name : "null prototype";
}
function xu(e) {
  return ~-encodeURI(e).split(/%..|./).length;
}
function Bu(e) {
  return xu(JSON.stringify(e));
}
var Ye;
(function(e) {
  e[e.PENDING = 0] = "PENDING";
  const t = 1;
  e[e.RESOLVED = t] = "RESOLVED";
  const s = 2;
  e[e.REJECTED = s] = "REJECTED";
})(Ye || (Ye = {}));
function Wn(e) {
  return new Te((n) => {
    n(e);
  });
}
function eo(e) {
  return new Te((n, t) => {
    t(e);
  });
}
class Te {
  constructor(n) {
    Te.prototype.__init.call(this), Te.prototype.__init2.call(this), Te.prototype.__init3.call(this), Te.prototype.__init4.call(this), this._state = Ye.PENDING, this._handlers = [];
    try {
      n(this._resolve, this._reject);
    } catch (t) {
      this._reject(t);
    }
  }
  /** JSDoc */
  then(n, t) {
    return new Te((s, r) => {
      this._handlers.push([
        !1,
        (o) => {
          if (!n)
            s(o);
          else
            try {
              s(n(o));
            } catch (a) {
              r(a);
            }
        },
        (o) => {
          if (!t)
            r(o);
          else
            try {
              s(t(o));
            } catch (a) {
              r(a);
            }
        }
      ]), this._executeHandlers();
    });
  }
  /** JSDoc */
  catch(n) {
    return this.then((t) => t, n);
  }
  /** JSDoc */
  finally(n) {
    return new Te((t, s) => {
      let r, o;
      return this.then(
        (a) => {
          o = !1, r = a, n && n();
        },
        (a) => {
          o = !0, r = a, n && n();
        }
      ).then(() => {
        if (o) {
          s(r);
          return;
        }
        t(r);
      });
    });
  }
  /** JSDoc */
  __init() {
    this._resolve = (n) => {
      this._setResult(Ye.RESOLVED, n);
    };
  }
  /** JSDoc */
  __init2() {
    this._reject = (n) => {
      this._setResult(Ye.REJECTED, n);
    };
  }
  /** JSDoc */
  __init3() {
    this._setResult = (n, t) => {
      if (this._state === Ye.PENDING) {
        if (zr(t)) {
          t.then(this._resolve, this._reject);
          return;
        }
        this._state = n, this._value = t, this._executeHandlers();
      }
    };
  }
  /** JSDoc */
  __init4() {
    this._executeHandlers = () => {
      if (this._state === Ye.PENDING)
        return;
      const n = this._handlers.slice();
      this._handlers = [], n.forEach((t) => {
        t[0] || (this._state === Ye.RESOLVED && t[1](this._value), this._state === Ye.REJECTED && t[2](this._value), t[0] = !0);
      });
    };
  }
}
function ju(e) {
  const n = [];
  function t() {
    return e === void 0 || n.length < e;
  }
  function s(a) {
    return n.splice(n.indexOf(a), 1)[0];
  }
  function r(a) {
    if (!t())
      return eo(new Ge("Not adding Promise because buffer limit was reached."));
    const i = a();
    return n.indexOf(i) === -1 && n.push(i), i.then(() => s(i)).then(
      null,
      () => s(i).then(null, () => {
      })
    ), i;
  }
  function o(a) {
    return new Te((i, _) => {
      let p = n.length;
      if (!p)
        return i(!0);
      const c = setTimeout(() => {
        a && a > 0 && i(!1);
      }, a);
      n.forEach((d) => {
        Wn(d).then(() => {
          --p || (clearTimeout(c), i(!0));
        }, _);
      });
    });
  }
  return {
    $: n,
    add: r,
    drain: o
  };
}
function Bs(e) {
  if (!e)
    return {};
  const n = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!n)
    return {};
  const t = n[6] || "", s = n[8] || "";
  return {
    host: n[4],
    path: n[5],
    protocol: n[2],
    search: t,
    hash: s,
    relative: n[5] + t + s
    // everything minus origin
  };
}
const Vu = ["fatal", "error", "warning", "log", "info", "debug"];
function Fu(e) {
  return e === "warn" ? "warning" : Vu.includes(e) ? e : "log";
}
const Ji = gs(), fr = {
  nowSeconds: () => Date.now() / 1e3
};
function Wu() {
  const { performance: e } = Ji;
  if (!e || !e.now)
    return;
  const n = Date.now() - e.now();
  return {
    now: () => e.now(),
    timeOrigin: n
  };
}
function Yu() {
  try {
    return Pu(module, "perf_hooks").performance;
  } catch {
    return;
  }
}
const js = Cu() ? Yu() : Wu(), ia = js === void 0 ? fr : {
  nowSeconds: () => (js.timeOrigin + js.now()) / 1e3
}, Es = fr.nowSeconds.bind(fr), zi = ia.nowSeconds.bind(ia);
(() => {
  const { performance: e } = Ji;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, t = e.now(), s = Date.now(), r = e.timeOrigin ? Math.abs(e.timeOrigin + t - s) : n, o = r < n, a = e.timing && e.timing.navigationStart, _ = typeof a == "number" ? Math.abs(a + t - s) : n, p = _ < n;
  return o || p ? r <= _ ? e.timeOrigin : a : s;
})();
function $n(e, n = []) {
  return [e, n];
}
function Ku(e, n) {
  const [t, s] = e;
  return [t, [...s, n]];
}
function _a(e, n) {
  const t = e[1];
  for (const s of t) {
    const r = s[0].type;
    if (n(s, r))
      return !0;
  }
  return !1;
}
function gr(e, n) {
  return (n || new TextEncoder()).encode(e);
}
function Xu(e, n) {
  const [t, s] = e;
  let r = JSON.stringify(t);
  function o(a) {
    typeof r == "string" ? r = typeof a == "string" ? r + a : [gr(r, n), a] : r.push(typeof a == "string" ? gr(a, n) : a);
  }
  for (const a of s) {
    const [i, _] = a;
    if (o(`
${JSON.stringify(i)}
`), typeof _ == "string" || _ instanceof Uint8Array)
      o(_);
    else {
      let p;
      try {
        p = JSON.stringify(_);
      } catch {
        p = JSON.stringify(sn(_));
      }
      o(p);
    }
  }
  return typeof r == "string" ? r : $u(r);
}
function $u(e) {
  const n = e.reduce((r, o) => r + o.length, 0), t = new Uint8Array(n);
  let s = 0;
  for (const r of e)
    t.set(r, s), s += r.length;
  return t;
}
function Ju(e, n) {
  const t = typeof e.data == "string" ? gr(e.data, n) : e.data;
  return [
    hs({
      type: "attachment",
      length: t.length,
      filename: e.filename,
      content_type: e.contentType,
      attachment_type: e.attachmentType
    }),
    t
  ];
}
const zu = {
  session: "session",
  sessions: "session",
  attachment: "attachment",
  transaction: "transaction",
  event: "error",
  client_report: "internal",
  user_report: "default",
  profile: "profile",
  replay_event: "replay",
  replay_recording: "replay",
  check_in: "monitor",
  feedback: "feedback",
  // TODO: This is a temporary workaround until we have a proper data category for metrics
  statsd: "unknown"
};
function pa(e) {
  return zu[e];
}
function qi(e) {
  if (!e || !e.sdk)
    return;
  const { name: n, version: t } = e.sdk;
  return { name: n, version: t };
}
function qu(e, n, t, s) {
  const r = e.sdkProcessingMetadata && e.sdkProcessingMetadata.dynamicSamplingContext;
  return {
    event_id: e.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...n && { sdk: n },
    ...!!t && s && { dsn: Nt(s) },
    ...r && {
      trace: hs({ ...r })
    }
  };
}
function Zu(e, n, t) {
  const s = [
    { type: "client_report" },
    {
      timestamp: t || Es(),
      discarded_events: e
    }
  ];
  return $n(n ? { dsn: n } : {}, [s]);
}
const Qu = 60 * 1e3;
function el(e, n = Date.now()) {
  const t = parseInt(`${e}`, 10);
  if (!isNaN(t))
    return t * 1e3;
  const s = Date.parse(`${e}`);
  return isNaN(s) ? Qu : s - n;
}
function nl(e, n) {
  return e[n] || e.all || 0;
}
function tl(e, n, t = Date.now()) {
  return nl(e, n) > t;
}
function sl(e, { statusCode: n, headers: t }, s = Date.now()) {
  const r = {
    ...e
  }, o = t && t["x-sentry-rate-limits"], a = t && t["retry-after"];
  if (o)
    for (const i of o.trim().split(",")) {
      const [_, p] = i.split(":", 2), c = parseInt(_, 10), d = (isNaN(c) ? 60 : c) * 1e3;
      if (!p)
        r.all = s + d;
      else
        for (const g of p.split(";"))
          r[g] = s + d;
    }
  else
    a ? r.all = s + el(a, s) : n === 429 && (r.all = s + 60 * 1e3);
  return r;
}
const q = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, no = "production";
function to() {
  return ji("globalEventProcessors", () => []);
}
function rl(e) {
  to().push(e);
}
function es(e, n, t, s = 0) {
  return new Te((r, o) => {
    const a = e[s];
    if (n === null || typeof a != "function")
      r(n);
    else {
      const i = a({ ...n }, t);
      q && a.id && i === null && M.log(`Event processor "${a.id}" dropped event`), zr(i) ? i.then((_) => es(e, _, t, s + 1).then(r)).then(null, o) : es(e, i, t, s + 1).then(r).then(null, o);
    }
  });
}
function ol(e) {
  const n = zi(), t = {
    sid: ze(),
    init: !0,
    timestamp: n,
    started: n,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: !1,
    toJSON: () => il(t)
  };
  return e && Yn(t, e), t;
}
function Yn(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || zi(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : ze()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const t = e.timestamp - e.started;
    e.duration = t >= 0 ? t : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
function al(e, n) {
  let t = {};
  n ? t = { status: n } : e.status === "ok" && (t = { status: "exited" }), Yn(e, t);
}
function il(e) {
  return hs({
    sid: `${e.sid}`,
    init: e.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(e.started * 1e3).toISOString(),
    timestamp: new Date(e.timestamp * 1e3).toISOString(),
    status: e.status,
    errors: e.errors,
    did: typeof e.did == "number" || typeof e.did == "string" ? `${e.did}` : void 0,
    duration: e.duration,
    abnormal_mechanism: e.abnormal_mechanism,
    attrs: {
      release: e.release,
      environment: e.environment,
      ip_address: e.ipAddress,
      user_agent: e.userAgent
    }
  });
}
function Zi(e, n) {
  const { fingerprint: t, span: s, breadcrumbs: r, sdkProcessingMetadata: o, propagationContext: a } = n;
  _l(e, n), s && dl(e, s), ul(e, t), pl(e, r), cl(e, o, a);
}
function ca(e, n) {
  const {
    extra: t,
    tags: s,
    user: r,
    contexts: o,
    level: a,
    sdkProcessingMetadata: i,
    breadcrumbs: _,
    fingerprint: p,
    eventProcessors: c,
    attachments: d,
    propagationContext: g,
    transactionName: m,
    span: R
  } = n;
  nt(e, "extra", t), nt(e, "tags", s), nt(e, "user", r), nt(e, "contexts", o), nt(e, "sdkProcessingMetadata", i), a && (e.level = a), m && (e.transactionName = m), R && (e.span = R), _.length && (e.breadcrumbs = [...e.breadcrumbs, ..._]), p.length && (e.fingerprint = [...e.fingerprint, ...p]), c.length && (e.eventProcessors = [...e.eventProcessors, ...c]), d.length && (e.attachments = [...e.attachments, ...d]), e.propagationContext = { ...e.propagationContext, ...g };
}
function nt(e, n, t) {
  t && Object.keys(t).length && (e[n] = { ...e[n], ...t });
}
function _l(e, n) {
  const { extra: t, tags: s, user: r, contexts: o, level: a, transactionName: i } = n;
  t && Object.keys(t).length && (e.extra = { ...t, ...e.extra }), s && Object.keys(s).length && (e.tags = { ...s, ...e.tags }), r && Object.keys(r).length && (e.user = { ...r, ...e.user }), o && Object.keys(o).length && (e.contexts = { ...o, ...e.contexts }), a && (e.level = a), i && (e.transaction = i);
}
function pl(e, n) {
  const t = [...e.breadcrumbs || [], ...n];
  e.breadcrumbs = t.length ? t : void 0;
}
function cl(e, n, t) {
  e.sdkProcessingMetadata = {
    ...e.sdkProcessingMetadata,
    ...n,
    propagationContext: t
  };
}
function dl(e, n) {
  e.contexts = { trace: n.getTraceContext(), ...e.contexts };
  const t = n.transaction;
  if (t) {
    e.sdkProcessingMetadata = {
      dynamicSamplingContext: t.getDynamicSamplingContext(),
      ...e.sdkProcessingMetadata
    };
    const s = t.name;
    s && (e.tags = { transaction: s, ...e.tags });
  }
}
function ul(e, n) {
  e.fingerprint = e.fingerprint ? pu(e.fingerprint) : [], n && (e.fingerprint = e.fingerprint.concat(n)), e.fingerprint && !e.fingerprint.length && delete e.fingerprint;
}
const ll = 100;
let Vs;
class xe {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called after {@link applyToEvent}. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  // eslint-disable-next-line deprecation/deprecation
  /** Transaction Name */
  /** Span */
  /** Session */
  /** Request Mode Session Status */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = da();
  }
  /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */
  static clone(n) {
    return n ? n.clone() : new xe();
  }
  /**
   * Clone this scope instance.
   */
  clone() {
    const n = new xe();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._span = this._span, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n;
  }
  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {}, this._session && Yn(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, t) {
    return this._tags = { ...this._tags, [n]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, t) {
    return this._extra = { ...this._extra, [n]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, t) {
    return t === null ? delete this._contexts[n] : this._contexts[n] = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSpan(n) {
    return this._span = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSpan() {
    return this._span;
  }
  /**
   * @inheritDoc
   */
  getTransaction() {
    const n = this.getSpan();
    return n && n.transaction;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    if (typeof n == "function") {
      const t = n(this);
      return t instanceof xe ? t : this;
    }
    return n instanceof xe ? (this._tags = { ...this._tags, ...n._tags }, this._extra = { ...this._extra, ...n._extra }, this._contexts = { ...this._contexts, ...n._contexts }, n._user && Object.keys(n._user).length && (this._user = n._user), n._level && (this._level = n._level), n._fingerprint && (this._fingerprint = n._fingerprint), n._requestSession && (this._requestSession = n._requestSession), n._propagationContext && (this._propagationContext = n._propagationContext)) : Fn(n) && (n = n, this._tags = { ...this._tags, ...n.tags }, this._extra = { ...this._extra, ...n.extra }, this._contexts = { ...this._contexts, ...n.contexts }, n.user && (this._user = n.user), n.level && (this._level = n.level), n.fingerprint && (this._fingerprint = n.fingerprint), n.requestSession && (this._requestSession = n.requestSession), n.propagationContext && (this._propagationContext = n.propagationContext)), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._span = void 0, this._session = void 0, this._notifyScopeListeners(), this._attachments = [], this._propagationContext = da(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, t) {
    const s = typeof t == "number" ? t : ll;
    if (s <= 0)
      return this;
    const r = {
      timestamp: Es(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(r), this._breadcrumbs = o.length > s ? o.slice(-s) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */
  getAttachments() {
    return this.getScopeData().attachments;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    const {
      _breadcrumbs: n,
      _attachments: t,
      _contexts: s,
      _tags: r,
      _extra: o,
      _user: a,
      _level: i,
      _fingerprint: _,
      _eventProcessors: p,
      _propagationContext: c,
      _sdkProcessingMetadata: d,
      _transactionName: g,
      _span: m
    } = this;
    return {
      breadcrumbs: n,
      attachments: t,
      contexts: s,
      tags: r,
      extra: o,
      user: a,
      level: i,
      fingerprint: _ || [],
      eventProcessors: p,
      propagationContext: c,
      sdkProcessingMetadata: d,
      transactionName: g,
      span: m
    };
  }
  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */
  applyToEvent(n, t = {}, s = []) {
    Zi(n, this.getScopeData());
    const r = [
      ...s,
      // eslint-disable-next-line deprecation/deprecation
      ...to(),
      ...this._eventProcessors
    ];
    return es(r, n, t);
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
function ml() {
  return Vs || (Vs = new xe()), Vs;
}
function da() {
  return {
    traceId: ze(),
    spanId: ze().substring(16)
  };
}
const hr = "7.91.0", Qi = parseFloat(hr), fl = 100;
class so {
  /** Is a {@link Layer}[] containing the client and scope */
  /** Contains the last event id of a captured event.  */
  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
  constructor(n, t = new xe(), s = new xe(), r = Qi) {
    this._version = r, this._stack = [{ scope: t }], n && this.bindClient(n), this._isolationScope = s;
  }
  /**
   * @inheritDoc
   */
  isOlderThan(n) {
    return this._version < n;
  }
  /**
   * @inheritDoc
   */
  bindClient(n) {
    const t = this.getStackTop();
    t.client = n, n && n.setupIntegrations && n.setupIntegrations();
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */
  pushScope() {
    const n = this.getScope().clone();
    return this.getStack().push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */
  popScope() {
    return this.getStack().length <= 1 ? !1 : !!this.getStack().pop();
  }
  /**
   * @inheritDoc
   */
  withScope(n) {
    const t = this.pushScope();
    try {
      return n(t);
    } finally {
      this.popScope();
    }
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this.getStackTop().client;
  }
  /** Returns the scope of the top stack. */
  getScope() {
    return this.getStackTop().scope;
  }
  /** @inheritdoc */
  getIsolationScope() {
    return this._isolationScope;
  }
  /** Returns the scope stack for domains or the process. */
  getStack() {
    return this._stack;
  }
  /** Returns the topmost scope layer in the order domain > local > process. */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * @inheritDoc
   */
  captureException(n, t) {
    const s = this._lastEventId = t && t.event_id ? t.event_id : ze(), r = new Error("Sentry syntheticException");
    return this._withClient((o, a) => {
      o.captureException(
        n,
        {
          originalException: n,
          syntheticException: r,
          ...t,
          event_id: s
        },
        a
      );
    }), s;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, t, s) {
    const r = this._lastEventId = s && s.event_id ? s.event_id : ze(), o = new Error(n);
    return this._withClient((a, i) => {
      a.captureMessage(
        n,
        t,
        {
          originalException: n,
          syntheticException: o,
          ...s,
          event_id: r
        },
        i
      );
    }), r;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, t) {
    const s = t && t.event_id ? t.event_id : ze();
    return n.type || (this._lastEventId = s), this._withClient((r, o) => {
      r.captureEvent(n, { ...t, event_id: s }, o);
    }), s;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, t) {
    const { scope: s, client: r } = this.getStackTop();
    if (!r)
      return;
    const { beforeBreadcrumb: o = null, maxBreadcrumbs: a = fl } = r.getOptions && r.getOptions() || {};
    if (a <= 0)
      return;
    const _ = { timestamp: Es(), ...n }, p = o ? Zr(() => o(_, t)) : _;
    p !== null && (r.emit && r.emit("beforeAddBreadcrumb", p, t), s.addBreadcrumb(p, a));
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    this.getScope().setUser(n);
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    this.getScope().setTags(n);
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    this.getScope().setExtras(n);
  }
  /**
   * @inheritDoc
   */
  setTag(n, t) {
    this.getScope().setTag(n, t);
  }
  /**
   * @inheritDoc
   */
  setExtra(n, t) {
    this.getScope().setExtra(n, t);
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setContext(n, t) {
    this.getScope().setContext(n, t);
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */
  configureScope(n) {
    const { scope: t, client: s } = this.getStackTop();
    s && n(t);
  }
  /**
   * @inheritDoc
   */
  run(n) {
    const t = ua(this);
    try {
      n(this);
    } finally {
      ua(t);
    }
  }
  /**
   * @inheritDoc
   */
  getIntegration(n) {
    const t = this.getClient();
    if (!t)
      return null;
    try {
      return t.getIntegration(n);
    } catch {
      return q && M.warn(`Cannot retrieve integration ${n.id} from the current Hub`), null;
    }
  }
  /**
   * @inheritDoc
   */
  startTransaction(n, t) {
    const s = this._callExtensionMethod("startTransaction", n, t);
    return q && !s && (this.getClient() ? M.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`) : M.warn(
      "Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'"
    )), s;
  }
  /**
   * @inheritDoc
   */
  traceHeaders() {
    return this._callExtensionMethod("traceHeaders");
  }
  /**
   * @inheritDoc
   */
  captureSession(n = !1) {
    if (n)
      return this.endSession();
    this._sendSessionUpdate();
  }
  /**
   * @inheritDoc
   */
  endSession() {
    const t = this.getStackTop().scope, s = t.getSession();
    s && al(s), this._sendSessionUpdate(), t.setSession();
  }
  /**
   * @inheritDoc
   */
  startSession(n) {
    const { scope: t, client: s } = this.getStackTop(), { release: r, environment: o = no } = s && s.getOptions() || {}, { userAgent: a } = K.navigator || {}, i = ol({
      release: r,
      environment: o,
      user: t.getUser(),
      ...a && { userAgent: a },
      ...n
    }), _ = t.getSession && t.getSession();
    return _ && _.status === "ok" && Yn(_, { status: "exited" }), this.endSession(), t.setSession(i), i;
  }
  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
  shouldSendDefaultPii() {
    const n = this.getClient(), t = n && n.getOptions();
    return !!(t && t.sendDefaultPii);
  }
  /**
   * Sends the current Session on the scope
   */
  _sendSessionUpdate() {
    const { scope: n, client: t } = this.getStackTop(), s = n.getSession();
    s && t && t.captureSession && t.captureSession(s);
  }
  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
  _withClient(n) {
    const { scope: t, client: s } = this.getStackTop();
    s && n(s, t);
  }
  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _callExtensionMethod(n, ...t) {
    const r = bs().__SENTRY__;
    if (r && r.extensions && typeof r.extensions[n] == "function")
      return r.extensions[n].apply(this, t);
    q && M.warn(`Extension method ${n} couldn't be found, doing nothing.`);
  }
}
function bs() {
  return K.__SENTRY__ = K.__SENTRY__ || {
    extensions: {},
    hub: void 0
  }, K;
}
function ua(e) {
  const n = bs(), t = Er(n);
  return e_(n, e), t;
}
function Sn() {
  const e = bs();
  if (e.__SENTRY__ && e.__SENTRY__.acs) {
    const n = e.__SENTRY__.acs.getCurrentHub();
    if (n)
      return n;
  }
  return hl(e);
}
function gl() {
  return Sn().getIsolationScope();
}
function hl(e = bs()) {
  return (!El(e) || Er(e).isOlderThan(Qi)) && e_(e, new so()), Er(e);
}
function El(e) {
  return !!(e && e.__SENTRY__ && e.__SENTRY__.hub);
}
function Er(e) {
  return ji("hub", () => new so(), e);
}
function e_(e, n) {
  if (!e)
    return !1;
  const t = e.__SENTRY__ = e.__SENTRY__ || {};
  return t.hub = n, !0;
}
function bl(e, n, t) {
  const s = n.getOptions(), { publicKey: r } = n.getDsn() || {}, { segment: o } = t && t.getUser() || {}, a = hs({
    environment: s.environment || no,
    release: s.release,
    user_segment: o,
    public_key: r,
    trace_id: e
  });
  return n.emit && n.emit("createDsc", a), a;
}
function kl(e, n, t, s, r, o) {
  const { normalizeDepth: a = 3, normalizeMaxBreadth: i = 1e3 } = e, _ = {
    ...n,
    event_id: n.event_id || t.event_id || ze(),
    timestamp: n.timestamp || Es()
  }, p = t.integrations || e.integrations.map((A) => A.name);
  vl(_, e), yl(_, p), n.type === void 0 && Tl(_, e.stackParser);
  const c = Ol(s, t.captureContext);
  t.mechanism && Tt(_, t.mechanism);
  const d = r && r.getEventProcessors ? r.getEventProcessors() : [], g = ml().getScopeData();
  if (o) {
    const A = o.getScopeData();
    ca(g, A);
  }
  if (c) {
    const A = c.getScopeData();
    ca(g, A);
  }
  const m = [...t.attachments || [], ...g.attachments];
  m.length && (t.attachments = m), Zi(_, g);
  const R = [
    ...d,
    // eslint-disable-next-line deprecation/deprecation
    ...to(),
    // Run scope event processors _after_ all other processors
    ...g.eventProcessors
  ];
  return es(R, _, t).then((A) => (A && Rl(A), typeof a == "number" && a > 0 ? Il(A, a, i) : A));
}
function vl(e, n) {
  const { environment: t, release: s, dist: r, maxValueLength: o = 250 } = n;
  "environment" in e || (e.environment = "environment" in n ? t : no), e.release === void 0 && s !== void 0 && (e.release = s), e.dist === void 0 && r !== void 0 && (e.dist = r), e.message && (e.message = Bn(e.message, o));
  const a = e.exception && e.exception.values && e.exception.values[0];
  a && a.value && (a.value = Bn(a.value, o));
  const i = e.request;
  i && i.url && (i.url = Bn(i.url, o));
}
const la = /* @__PURE__ */ new WeakMap();
function Tl(e, n) {
  const t = K._sentryDebugIds;
  if (!t)
    return;
  let s;
  const r = la.get(n);
  r ? s = r : (s = /* @__PURE__ */ new Map(), la.set(n, s));
  const o = Object.keys(t).reduce((a, i) => {
    let _;
    const p = s.get(i);
    p ? _ = p : (_ = n(i), s.set(i, _));
    for (let c = _.length - 1; c >= 0; c--) {
      const d = _[c];
      if (d.filename) {
        a[d.filename] = t[i];
        break;
      }
    }
    return a;
  }, {});
  try {
    e.exception.values.forEach((a) => {
      a.stacktrace.frames.forEach((i) => {
        i.filename && (i.debug_id = o[i.filename]);
      });
    });
  } catch {
  }
}
function Rl(e) {
  const n = {};
  try {
    e.exception.values.forEach((s) => {
      s.stacktrace.frames.forEach((r) => {
        r.debug_id && (r.abs_path ? n[r.abs_path] = r.debug_id : r.filename && (n[r.filename] = r.debug_id), delete r.debug_id);
      });
    });
  } catch {
  }
  if (Object.keys(n).length === 0)
    return;
  e.debug_meta = e.debug_meta || {}, e.debug_meta.images = e.debug_meta.images || [];
  const t = e.debug_meta.images;
  Object.keys(n).forEach((s) => {
    t.push({
      type: "sourcemap",
      code_file: s,
      debug_id: n[s]
    });
  });
}
function yl(e, n) {
  n.length > 0 && (e.sdk = e.sdk || {}, e.sdk.integrations = [...e.sdk.integrations || [], ...n]);
}
function Il(e, n, t) {
  if (!e)
    return null;
  const s = {
    ...e,
    ...e.breadcrumbs && {
      breadcrumbs: e.breadcrumbs.map((r) => ({
        ...r,
        ...r.data && {
          data: sn(r.data, n, t)
        }
      }))
    },
    ...e.user && {
      user: sn(e.user, n, t)
    },
    ...e.contexts && {
      contexts: sn(e.contexts, n, t)
    },
    ...e.extra && {
      extra: sn(e.extra, n, t)
    }
  };
  return e.contexts && e.contexts.trace && s.contexts && (s.contexts.trace = e.contexts.trace, e.contexts.trace.data && (s.contexts.trace.data = sn(e.contexts.trace.data, n, t))), e.spans && (s.spans = e.spans.map((r) => (r.data && (r.data = sn(r.data, n, t)), r))), s;
}
function Ol(e, n) {
  if (!n)
    return e;
  const t = e ? e.clone() : new xe();
  return t.update(n), t;
}
function Nl(e) {
  if (e)
    return Dl(e) ? { captureContext: e } : Sl(e) ? {
      captureContext: e
    } : e;
}
function Dl(e) {
  return e instanceof xe || typeof e == "function";
}
const Al = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function Sl(e) {
  return Object.keys(e).some((n) => Al.includes(n));
}
function wl(e, n) {
  return Sn().captureException(e, Nl(n));
}
function n_(e, n) {
  return Sn().captureEvent(e, n);
}
function Nn(e, n) {
  Sn().addBreadcrumb(e, n);
}
function Hl(e) {
  return Sn().withScope(e);
}
function je() {
  return Sn().getClient();
}
function Ul(e, n) {
  return n && (e.sdk = e.sdk || {}, e.sdk.name = e.sdk.name || n.name, e.sdk.version = e.sdk.version || n.version, e.sdk.integrations = [...e.sdk.integrations || [], ...n.integrations || []], e.sdk.packages = [...e.sdk.packages || [], ...n.packages || []]), e;
}
function Cl(e, n, t, s) {
  const r = qi(t), o = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...r && { sdk: r },
    ...!!s && n && { dsn: Nt(n) }
  }, a = "aggregates" in e ? [{ type: "sessions" }, e] : [{ type: "session" }, e.toJSON()];
  return $n(o, [a]);
}
function Pl(e, n, t, s) {
  const r = qi(t), o = e.type && e.type !== "replay_event" ? e.type : "event";
  Ul(e, t && t.sdk);
  const a = qu(e, r, s, n);
  return delete e.sdkProcessingMetadata, $n(a, [[{ type: o }, e]]);
}
const Ml = "7";
function Ll(e) {
  const n = e.protocol ? `${e.protocol}:` : "", t = e.port ? `:${e.port}` : "";
  return `${n}//${e.host}${t}${e.path ? `/${e.path}` : ""}/api/`;
}
function Gl(e) {
  return `${Ll(e)}${e.projectId}/envelope/`;
}
function xl(e, n) {
  return su({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: e.publicKey,
    sentry_version: Ml,
    ...n && { sentry_client: `${n.name}/${n.version}` }
  });
}
function Bl(e, n = {}) {
  const t = typeof n == "string" ? n : n.tunnel, s = typeof n == "string" || !n._metadata ? void 0 : n._metadata.sdk;
  return t || `${Gl(e)}?${xl(e, s)}`;
}
const ma = [];
function jl(e, n) {
  const t = {};
  return n.forEach((s) => {
    s && t_(e, s, t);
  }), t;
}
function t_(e, n, t) {
  if (t[n.name] = n, ma.indexOf(n.name) === -1 && (n.setupOnce(rl, Sn), ma.push(n.name)), n.setup && typeof n.setup == "function" && n.setup(e), e.on && typeof n.preprocessEvent == "function") {
    const s = n.preprocessEvent.bind(n);
    e.on("preprocessEvent", (r, o) => s(r, o, e));
  }
  if (e.addEventProcessor && typeof n.processEvent == "function") {
    const s = n.processEvent.bind(n), r = Object.assign((o, a) => s(o, a, e), {
      id: n.name
    });
    e.addEventProcessor(r);
  }
  q && M.log(`Integration installed: ${n.name}`);
}
function mn(e, n) {
  return Object.assign(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(...s) {
      return {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: () => {
        },
        ...n(...s)
      };
    },
    { id: e }
  );
}
function Vl(e) {
  let n = "";
  for (const t of e) {
    const s = Object.entries(t.tags), r = s.length > 0 ? `|#${s.map(([o, a]) => `${o}:${a}`).join(",")}` : "";
    n += `${t.name}@${t.unit}:${t.metric}|${t.metricType}${r}|T${t.timestamp}
`;
  }
  return n;
}
function Fl(e, n, t, s) {
  const r = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString()
  };
  t && t.sdk && (r.sdk = {
    name: t.sdk.name,
    version: t.sdk.version
  }), s && n && (r.dsn = Nt(n));
  const o = Wl(e);
  return $n(r, [o]);
}
function Wl(e) {
  const n = Vl(e);
  return [{
    type: "statsd",
    length: n.length
  }, n];
}
const fa = "Not capturing exception because it's already been captured.";
class Yl {
  /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */
  /** Options passed to the SDK. */
  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */
  /** Array of set up integrations. */
  /** Indicates whether this client's integrations have been set up. */
  /** Number of calls being processed */
  /** Holds flushable  */
  // eslint-disable-next-line @typescript-eslint/ban-types
  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  constructor(n) {
    if (this._options = n, this._integrations = {}, this._integrationsInitialized = !1, this._numProcessing = 0, this._outcomes = {}, this._hooks = {}, this._eventProcessors = [], n.dsn ? this._dsn = tu(n.dsn) : q && M.warn("No DSN provided, client will not send events."), this._dsn) {
      const t = Bl(this._dsn, n);
      this._transport = n.transport({
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...n.transportOptions,
        url: t
      });
    }
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  captureException(n, t, s) {
    if (sa(n)) {
      q && M.log(fa);
      return;
    }
    let r = t && t.event_id;
    return this._process(
      this.eventFromException(n, t).then((o) => this._captureEvent(o, t, s)).then((o) => {
        r = o;
      })
    ), r;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, t, s, r) {
    let o = s && s.event_id;
    const a = Jr(n) ? this.eventFromMessage(String(n), t, s) : this.eventFromException(n, s);
    return this._process(
      a.then((i) => this._captureEvent(i, s, r)).then((i) => {
        o = i;
      })
    ), o;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, t, s) {
    if (t && t.originalException && sa(t.originalException)) {
      q && M.log(fa);
      return;
    }
    let r = t && t.event_id;
    return this._process(
      this._captureEvent(n, t, s).then((o) => {
        r = o;
      })
    ), r;
  }
  /**
   * @inheritDoc
   */
  captureSession(n) {
    typeof n.release != "string" ? q && M.warn("Discarded session because of missing or non-string release") : (this.sendSession(n), Yn(n, { init: !1 }));
  }
  /**
   * @inheritDoc
   */
  getDsn() {
    return this._dsn;
  }
  /**
   * @inheritDoc
   */
  getOptions() {
    return this._options;
  }
  /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */
  getSdkMetadata() {
    return this._options._metadata;
  }
  /**
   * @inheritDoc
   */
  getTransport() {
    return this._transport;
  }
  /**
   * @inheritDoc
   */
  flush(n) {
    const t = this._transport;
    return t ? (this.metricsAggregator && this.metricsAggregator.flush(), this._isClientDoneProcessing(n).then((s) => t.flush(n).then((r) => s && r))) : Wn(!0);
  }
  /**
   * @inheritDoc
   */
  close(n) {
    return this.flush(n).then((t) => (this.getOptions().enabled = !1, this.metricsAggregator && this.metricsAggregator.close(), t));
  }
  /** Get all installed event processors. */
  getEventProcessors() {
    return this._eventProcessors;
  }
  /** @inheritDoc */
  addEventProcessor(n) {
    this._eventProcessors.push(n);
  }
  /**
   * Sets up the integrations
   */
  setupIntegrations(n) {
    (n && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) && (this._integrations = jl(this, this._options.integrations), this._integrationsInitialized = !0);
  }
  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */
  getIntegrationById(n) {
    return this._integrations[n];
  }
  /**
   * @inheritDoc
   */
  getIntegration(n) {
    try {
      return this._integrations[n.id] || null;
    } catch {
      return q && M.warn(`Cannot retrieve integration ${n.id} from the current Client`), null;
    }
  }
  /**
   * @inheritDoc
   */
  addIntegration(n) {
    t_(this, n, this._integrations);
  }
  /**
   * @inheritDoc
   */
  sendEvent(n, t = {}) {
    this.emit("beforeSendEvent", n, t);
    let s = Pl(n, this._dsn, this._options._metadata, this._options.tunnel);
    for (const o of t.attachments || [])
      s = Ku(
        s,
        Ju(
          o,
          this._options.transportOptions && this._options.transportOptions.textEncoder
        )
      );
    const r = this._sendEnvelope(s);
    r && r.then((o) => this.emit("afterSendEvent", n, o), null);
  }
  /**
   * @inheritDoc
   */
  sendSession(n) {
    const t = Cl(n, this._dsn, this._options._metadata, this._options.tunnel);
    this._sendEnvelope(t);
  }
  /**
   * @inheritDoc
   */
  recordDroppedEvent(n, t, s) {
    if (this._options.sendClientReports) {
      const r = `${n}:${t}`;
      q && M.log(`Adding outcome: "${r}"`), this._outcomes[r] = this._outcomes[r] + 1 || 1;
    }
  }
  /**
   * @inheritDoc
   */
  captureAggregateMetrics(n) {
    q && M.log(`Flushing aggregated metrics, number of metrics: ${n.length}`);
    const t = Fl(
      n,
      this._dsn,
      this._options._metadata,
      this._options.tunnel
    );
    this._sendEnvelope(t);
  }
  // Keep on() & emit() signatures in sync with types' client.ts interface
  /* eslint-disable @typescript-eslint/unified-signatures */
  /** @inheritdoc */
  /** @inheritdoc */
  on(n, t) {
    this._hooks[n] || (this._hooks[n] = []), this._hooks[n].push(t);
  }
  /** @inheritdoc */
  /** @inheritdoc */
  emit(n, ...t) {
    this._hooks[n] && this._hooks[n].forEach((s) => s(...t));
  }
  /* eslint-enable @typescript-eslint/unified-signatures */
  /** Updates existing session based on the provided event */
  _updateSessionFromEvent(n, t) {
    let s = !1, r = !1;
    const o = t.exception && t.exception.values;
    if (o) {
      r = !0;
      for (const _ of o) {
        const p = _.mechanism;
        if (p && p.handled === !1) {
          s = !0;
          break;
        }
      }
    }
    const a = n.status === "ok";
    (a && n.errors === 0 || a && s) && (Yn(n, {
      ...s && { status: "crashed" },
      errors: n.errors || Number(r || s)
    }), this.captureSession(n));
  }
  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
  _isClientDoneProcessing(n) {
    return new Te((t) => {
      let s = 0;
      const r = 1, o = setInterval(() => {
        this._numProcessing == 0 ? (clearInterval(o), t(!0)) : (s += r, n && s >= n && (clearInterval(o), t(!1)));
      }, r);
    });
  }
  /** Determines whether this SDK is enabled and a transport is present. */
  _isEnabled() {
    return this.getOptions().enabled !== !1 && this._transport !== void 0;
  }
  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
  _prepareEvent(n, t, s, r = gl()) {
    const o = this.getOptions(), a = Object.keys(this._integrations);
    return !t.integrations && a.length > 0 && (t.integrations = a), this.emit("preprocessEvent", n, t), kl(o, n, t, s, this, r).then((i) => {
      if (i === null)
        return i;
      const { propagationContext: _ } = i.sdkProcessingMetadata || {};
      if (!(i.contexts && i.contexts.trace) && _) {
        const { traceId: c, spanId: d, parentSpanId: g, dsc: m } = _;
        i.contexts = {
          trace: {
            trace_id: c,
            span_id: d,
            parent_span_id: g
          },
          ...i.contexts
        };
        const R = m || bl(c, this, s);
        i.sdkProcessingMetadata = {
          dynamicSamplingContext: R,
          ...i.sdkProcessingMetadata
        };
      }
      return i;
    });
  }
  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
  _captureEvent(n, t = {}, s) {
    return this._processEvent(n, t, s).then(
      (r) => r.event_id,
      (r) => {
        if (q) {
          const o = r;
          o.logLevel === "log" ? M.log(o.message) : M.warn(o);
        }
      }
    );
  }
  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
  _processEvent(n, t, s) {
    const r = this.getOptions(), { sampleRate: o } = r, a = r_(n), i = s_(n), _ = n.type || "error", p = `before send for type \`${_}\``;
    if (i && typeof o == "number" && Math.random() > o)
      return this.recordDroppedEvent("sample_rate", "error", n), eo(
        new Ge(
          `Discarding event because it's not included in the random sample (sampling rate = ${o})`,
          "log"
        )
      );
    const c = _ === "replay_event" ? "replay" : _;
    return this._prepareEvent(n, t, s).then((d) => {
      if (d === null)
        throw this.recordDroppedEvent("event_processor", c, n), new Ge("An event processor returned `null`, will not send event.", "log");
      if (t.data && t.data.__sentry__ === !0)
        return d;
      const m = Xl(r, d, t);
      return Kl(m, p);
    }).then((d) => {
      if (d === null)
        throw this.recordDroppedEvent("before_send", c, n), new Ge(`${p} returned \`null\`, will not send event.`, "log");
      const g = s && s.getSession();
      !a && g && this._updateSessionFromEvent(g, d);
      const m = d.transaction_info;
      if (a && m && d.transaction !== n.transaction) {
        const R = "custom";
        d.transaction_info = {
          ...m,
          source: R
        };
      }
      return this.sendEvent(d, t), d;
    }).then(null, (d) => {
      throw d instanceof Ge ? d : (this.captureException(d, {
        data: {
          __sentry__: !0
        },
        originalException: d
      }), new Ge(
        `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${d}`
      ));
    });
  }
  /**
   * Occupies the client with processing and event
   */
  _process(n) {
    this._numProcessing++, n.then(
      (t) => (this._numProcessing--, t),
      (t) => (this._numProcessing--, t)
    );
  }
  /**
   * @inheritdoc
   */
  _sendEnvelope(n) {
    if (this.emit("beforeEnvelope", n), this._isEnabled() && this._transport)
      return this._transport.send(n).then(null, (t) => {
        q && M.error("Error while sending event:", t);
      });
    q && M.error("Transport disabled");
  }
  /**
   * Clears outcomes on this client and returns them.
   */
  _clearOutcomes() {
    const n = this._outcomes;
    return this._outcomes = {}, Object.keys(n).map((t) => {
      const [s, r] = t.split(":");
      return {
        reason: s,
        category: r,
        quantity: n[t]
      };
    });
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
}
function Kl(e, n) {
  const t = `${n} must return \`null\` or a valid event.`;
  if (zr(e))
    return e.then(
      (s) => {
        if (!Fn(s) && s !== null)
          throw new Ge(t);
        return s;
      },
      (s) => {
        throw new Ge(`${n} rejected with ${s}`);
      }
    );
  if (!Fn(e) && e !== null)
    throw new Ge(t);
  return e;
}
function Xl(e, n, t) {
  const { beforeSend: s, beforeSendTransaction: r } = e;
  return s_(n) && s ? s(n, t) : r_(n) && r ? r(n, t) : n;
}
function s_(e) {
  return e.type === void 0;
}
function r_(e) {
  return e.type === "transaction";
}
const $l = 30;
function Jl(e, n, t = ju(
  e.bufferSize || $l
)) {
  let s = {};
  const r = (a) => t.drain(a);
  function o(a) {
    const i = [];
    if (_a(a, (d, g) => {
      const m = pa(g);
      if (tl(s, m)) {
        const R = ga(d, g);
        e.recordDroppedEvent("ratelimit_backoff", m, R);
      } else
        i.push(d);
    }), i.length === 0)
      return Wn();
    const _ = $n(a[0], i), p = (d) => {
      _a(_, (g, m) => {
        const R = ga(g, m);
        e.recordDroppedEvent(d, pa(m), R);
      });
    }, c = () => n({ body: Xu(_, e.textEncoder) }).then(
      (d) => (d.statusCode !== void 0 && (d.statusCode < 200 || d.statusCode >= 300) && q && M.warn(`Sentry responded with status code ${d.statusCode} to sent event.`), s = sl(s, d), d),
      (d) => {
        throw p("network_error"), d;
      }
    );
    return t.add(c).then(
      (d) => d,
      (d) => {
        if (d instanceof Ge)
          return q && M.error("Skipped sending event because buffer is full."), p("queue_overflow"), Wn();
        throw d;
      }
    );
  }
  return o.__sentry__baseTransport__ = !0, {
    send: o,
    flush: r
  };
}
function ga(e, n) {
  if (!(n !== "event" && n !== "transaction"))
    return Array.isArray(e) ? e[1] : void 0;
}
let ha;
const o_ = "FunctionToString", zl = () => ({
  name: o_,
  setupOnce() {
    ha = Function.prototype.toString;
    try {
      Function.prototype.toString = function(...e) {
        const n = Qr(this) || this;
        return ha.apply(n, e);
      };
    } catch {
    }
  }
}), ql = mn(o_, zl), Zl = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/], Ql = [
  /^.*\/healthcheck$/,
  /^.*\/healthy$/,
  /^.*\/live$/,
  /^.*\/ready$/,
  /^.*\/heartbeat$/,
  /^.*\/health$/,
  /^.*\/healthz$/
], a_ = "InboundFilters", em = (e) => ({
  name: a_,
  processEvent(n, t, s) {
    const r = s.getOptions(), o = tm(e, r);
    return sm(n, o) ? null : n;
  }
}), nm = mn(a_, em);
function tm(e = {}, n = {}) {
  return {
    allowUrls: [...e.allowUrls || [], ...n.allowUrls || []],
    denyUrls: [...e.denyUrls || [], ...n.denyUrls || []],
    ignoreErrors: [
      ...e.ignoreErrors || [],
      ...n.ignoreErrors || [],
      ...e.disableErrorDefaults ? [] : Zl
    ],
    ignoreTransactions: [
      ...e.ignoreTransactions || [],
      ...n.ignoreTransactions || [],
      ...e.disableTransactionDefaults ? [] : Ql
    ],
    ignoreInternal: e.ignoreInternal !== void 0 ? e.ignoreInternal : !0
  };
}
function sm(e, n) {
  return n.ignoreInternal && pm(e) ? (q && M.warn(`Event dropped due to being internal Sentry Error.
Event: ${on(e)}`), !0) : rm(e, n.ignoreErrors) ? (q && M.warn(
    `Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${on(e)}`
  ), !0) : om(e, n.ignoreTransactions) ? (q && M.warn(
    `Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${on(e)}`
  ), !0) : am(e, n.denyUrls) ? (q && M.warn(
    `Event dropped due to being matched by \`denyUrls\` option.
Event: ${on(
      e
    )}.
Url: ${ns(e)}`
  ), !0) : im(e, n.allowUrls) ? !1 : (q && M.warn(
    `Event dropped due to not being matched by \`allowUrls\` option.
Event: ${on(
      e
    )}.
Url: ${ns(e)}`
  ), !0);
}
function rm(e, n) {
  return e.type || !n || !n.length ? !1 : _m(e).some((t) => fs(t, n));
}
function om(e, n) {
  if (e.type !== "transaction" || !n || !n.length)
    return !1;
  const t = e.transaction;
  return t ? fs(t, n) : !1;
}
function am(e, n) {
  if (!n || !n.length)
    return !1;
  const t = ns(e);
  return t ? fs(t, n) : !1;
}
function im(e, n) {
  if (!n || !n.length)
    return !0;
  const t = ns(e);
  return t ? fs(t, n) : !0;
}
function _m(e) {
  const n = [];
  e.message && n.push(e.message);
  let t;
  try {
    t = e.exception.values[e.exception.values.length - 1];
  } catch {
  }
  return t && t.value && (n.push(t.value), t.type && n.push(`${t.type}: ${t.value}`)), q && n.length === 0 && M.error(`Could not extract message for event ${on(e)}`), n;
}
function pm(e) {
  try {
    return e.exception.values[0].type === "SentryError";
  } catch {
  }
  return !1;
}
function cm(e = []) {
  for (let n = e.length - 1; n >= 0; n--) {
    const t = e[n];
    if (t && t.filename !== "<anonymous>" && t.filename !== "[native code]")
      return t.filename || null;
  }
  return null;
}
function ns(e) {
  try {
    let n;
    try {
      n = e.exception.values[0].stacktrace.frames;
    } catch {
    }
    return n ? cm(n) : null;
  } catch {
    return q && M.error(`Cannot extract url for event ${on(e)}`), null;
  }
}
const Z = K;
let br = 0;
function i_() {
  return br > 0;
}
function dm() {
  br++, setTimeout(() => {
    br--;
  });
}
function Kn(e, n = {}, t) {
  if (typeof e != "function")
    return e;
  try {
    const r = e.__sentry_wrapped__;
    if (r)
      return r;
    if (Qr(e))
      return e;
  } catch {
    return e;
  }
  const s = function() {
    const r = Array.prototype.slice.call(arguments);
    try {
      t && typeof t == "function" && t.apply(this, arguments);
      const o = r.map((a) => Kn(a, n));
      return e.apply(this, o);
    } catch (o) {
      throw dm(), Hl((a) => {
        a.addEventProcessor((i) => (n.mechanism && (_r(i, void 0, void 0), Tt(i, n.mechanism)), i.extra = {
          ...i.extra,
          arguments: r
        }, i)), wl(o);
      }), o;
    }
  };
  try {
    for (const r in e)
      Object.prototype.hasOwnProperty.call(e, r) && (s[r] = e[r]);
  } catch {
  }
  Wi(s, e), vt(e, "__sentry_wrapped__", s);
  try {
    Object.getOwnPropertyDescriptor(s, "name").configurable && Object.defineProperty(s, "name", {
      get() {
        return e.name;
      }
    });
  } catch {
  }
  return s;
}
const _n = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__;
function __(e, n) {
  const t = ro(e, n), s = {
    type: n && n.name,
    value: fm(n)
  };
  return t.length && (s.stacktrace = { frames: t }), s.type === void 0 && s.value === "" && (s.value = "Unrecoverable error caught"), s;
}
function um(e, n, t, s) {
  const r = je(), o = r && r.getOptions().normalizeDepth, a = {
    exception: {
      values: [
        {
          type: ms(n) ? n.constructor.name : s ? "UnhandledRejection" : "Error",
          value: Em(n, { isUnhandledRejection: s })
        }
      ]
    },
    extra: {
      __serialized__: $i(n, o)
    }
  };
  if (t) {
    const i = ro(e, t);
    i.length && (a.exception.values[0].stacktrace = { frames: i });
  }
  return a;
}
function Fs(e, n) {
  return {
    exception: {
      values: [__(e, n)]
    }
  };
}
function ro(e, n) {
  const t = n.stacktrace || n.stack || "", s = mm(n);
  try {
    return e(t, s);
  } catch {
  }
  return [];
}
const lm = /Minified React error #\d+;/i;
function mm(e) {
  if (e) {
    if (typeof e.framesToPop == "number")
      return e.framesToPop;
    if (lm.test(e.message))
      return 1;
  }
  return 0;
}
function fm(e) {
  const n = e && e.message;
  return n ? n.error && typeof n.error.message == "string" ? n.error.message : n : "No error message";
}
function gm(e, n, t, s) {
  const r = t && t.syntheticException || void 0, o = oo(e, n, r, s);
  return Tt(o), o.level = "error", t && t.event_id && (o.event_id = t.event_id), Wn(o);
}
function hm(e, n, t = "info", s, r) {
  const o = s && s.syntheticException || void 0, a = kr(e, n, o, r);
  return a.level = t, s && s.event_id && (a.event_id = s.event_id), Wn(a);
}
function oo(e, n, t, s, r) {
  let o;
  if ($r(n) && n.error)
    return Fs(e, n.error);
  if ($o(n) || Gd(n)) {
    const a = n;
    if ("stack" in n)
      o = Fs(e, n);
    else {
      const i = a.name || ($o(a) ? "DOMError" : "DOMException"), _ = a.message ? `${i}: ${a.message}` : i;
      o = kr(e, _, t, s), _r(o, _);
    }
    return "code" in a && (o.tags = { ...o.tags, "DOMException.code": `${a.code}` }), o;
  }
  return xi(n) ? Fs(e, n) : Fn(n) || ms(n) ? (o = um(e, n, t, r), Tt(o, {
    synthetic: !0
  }), o) : (o = kr(e, n, t, s), _r(o, `${n}`, void 0), Tt(o, {
    synthetic: !0
  }), o);
}
function kr(e, n, t, s) {
  const r = {
    message: n
  };
  if (s && t) {
    const o = ro(e, t);
    o.length && (r.exception = {
      values: [{ value: n, stacktrace: { frames: o } }]
    });
  }
  return r;
}
function Em(e, { isUnhandledRejection: n }) {
  const t = ru(e), s = n ? "promise rejection" : "exception";
  return $r(e) ? `Event \`ErrorEvent\` captured as ${s} with message \`${e.message}\`` : ms(e) ? `Event \`${bm(e)}\` (type=${e.type}) captured as ${s}` : `Object captured as ${s} with keys: ${t}`;
}
function bm(e) {
  try {
    const n = Object.getPrototypeOf(e);
    return n ? n.constructor.name : void 0;
  } catch {
  }
}
function km(e, {
  metadata: n,
  tunnel: t,
  dsn: s
}) {
  const r = {
    event_id: e.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...n && n.sdk && {
      sdk: {
        name: n.sdk.name,
        version: n.sdk.version
      }
    },
    ...!!t && !!s && { dsn: Nt(s) }
  }, o = vm(e);
  return $n(r, [o]);
}
function vm(e) {
  return [{
    type: "user_report"
  }, e];
}
class Tm extends Yl {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  constructor(n) {
    const t = Z.SENTRY_SDK_SOURCE || Uu();
    n._metadata = n._metadata || {}, n._metadata.sdk = n._metadata.sdk || {
      name: "sentry.javascript.browser",
      packages: [
        {
          name: `${t}:@sentry/browser`,
          version: hr
        }
      ],
      version: hr
    }, super(n), n.sendClientReports && Z.document && Z.document.addEventListener("visibilitychange", () => {
      Z.document.visibilityState === "hidden" && this._flushOutcomes();
    });
  }
  /**
   * @inheritDoc
   */
  eventFromException(n, t) {
    return gm(this._options.stackParser, n, t, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  eventFromMessage(n, t = "info", s) {
    return hm(this._options.stackParser, n, t, s, this._options.attachStacktrace);
  }
  /**
   * Sends user feedback to Sentry.
   */
  captureUserFeedback(n) {
    if (!this._isEnabled()) {
      _n && M.warn("SDK not enabled, will not capture user feedback.");
      return;
    }
    const t = km(n, {
      metadata: this.getSdkMetadata(),
      dsn: this.getDsn(),
      tunnel: this.getOptions().tunnel
    });
    this._sendEnvelope(t);
  }
  /**
   * @inheritDoc
   */
  _prepareEvent(n, t, s) {
    return n.platform = n.platform || "javascript", super._prepareEvent(n, t, s);
  }
  /**
   * Sends client reports as an envelope.
   */
  _flushOutcomes() {
    const n = this._clearOutcomes();
    if (n.length === 0) {
      _n && M.log("No outcomes to send");
      return;
    }
    if (!this._dsn) {
      _n && M.log("No dsn provided, will not send outcomes");
      return;
    }
    _n && M.log("Sending outcomes:", n);
    const t = Zu(n, this._options.tunnel && Nt(this._dsn));
    this._sendEnvelope(t);
  }
}
let rt;
function Rm() {
  if (rt)
    return rt;
  if (ur(Z.fetch))
    return rt = Z.fetch.bind(Z);
  const e = Z.document;
  let n = Z.fetch;
  if (e && typeof e.createElement == "function")
    try {
      const t = e.createElement("iframe");
      t.hidden = !0, e.head.appendChild(t);
      const s = t.contentWindow;
      s && s.fetch && (n = s.fetch), e.head.removeChild(t);
    } catch (t) {
      _n && M.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", t);
    }
  return rt = n.bind(Z);
}
function ym() {
  rt = void 0;
}
function Im(e, n = Rm()) {
  let t = 0, s = 0;
  function r(o) {
    const a = o.body.length;
    t += a, s++;
    const i = {
      body: o.body,
      method: "POST",
      referrerPolicy: "origin",
      headers: e.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: t <= 6e4 && s < 15,
      ...e.fetchOptions
    };
    try {
      return n(e.url, i).then((_) => (t -= a, s--, {
        statusCode: _.status,
        headers: {
          "x-sentry-rate-limits": _.headers.get("X-Sentry-Rate-Limits"),
          "retry-after": _.headers.get("Retry-After")
        }
      }));
    } catch (_) {
      return ym(), t -= a, s--, eo(_);
    }
  }
  return Jl(e, r);
}
const ks = "?", Om = 30, Nm = 40, Dm = 50;
function ao(e, n, t, s) {
  const r = {
    filename: e,
    function: n,
    in_app: !0
    // All browser frames are considered in_app
  };
  return t !== void 0 && (r.lineno = t), s !== void 0 && (r.colno = s), r;
}
const Am = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, Sm = /\((\S*)(?::(\d+))(?::(\d+))\)/, wm = (e) => {
  const n = Am.exec(e);
  if (n) {
    if (n[2] && n[2].indexOf("eval") === 0) {
      const o = Sm.exec(n[2]);
      o && (n[2] = o[1], n[3] = o[2], n[4] = o[3]);
    }
    const [s, r] = p_(n[1] || ks, n[2]);
    return ao(r, s, n[3] ? +n[3] : void 0, n[4] ? +n[4] : void 0);
  }
}, Hm = [Om, wm], Um = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, Cm = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, Pm = (e) => {
  const n = Um.exec(e);
  if (n) {
    if (n[3] && n[3].indexOf(" > eval") > -1) {
      const o = Cm.exec(n[3]);
      o && (n[1] = n[1] || "eval", n[3] = o[1], n[4] = o[2], n[5] = "");
    }
    let s = n[3], r = n[1] || ks;
    return [r, s] = p_(r, s), ao(s, r, n[4] ? +n[4] : void 0, n[5] ? +n[5] : void 0);
  }
}, Mm = [Dm, Pm], Lm = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i, Gm = (e) => {
  const n = Lm.exec(e);
  return n ? ao(n[2], n[1] || ks, +n[3], n[4] ? +n[4] : void 0) : void 0;
}, xm = [Nm, Gm], Bm = [Hm, Mm, xm], jm = ou(...Bm), p_ = (e, n) => {
  const t = e.indexOf("safari-extension") !== -1, s = e.indexOf("safari-web-extension") !== -1;
  return t || s ? [
    e.indexOf("@") !== -1 ? e.split("@")[0] : ks,
    t ? `safari-extension:${n}` : `safari-web-extension:${n}`
  ] : [e, n];
}, c_ = "GlobalHandlers", Vm = (e = {}) => {
  const n = {
    onerror: !0,
    onunhandledrejection: !0,
    ...e
  };
  return {
    name: c_,
    setupOnce() {
      Error.stackTraceLimit = 50;
    },
    setup(t) {
      n.onerror && (Wm(t), Ea("onerror")), n.onunhandledrejection && (Ym(t), Ea("onunhandledrejection"));
    }
  };
}, Fm = mn(c_, Vm);
function Wm(e) {
  vu((n) => {
    const { stackParser: t, attachStacktrace: s } = u_();
    if (je() !== e || i_())
      return;
    const { msg: r, url: o, line: a, column: i, error: _ } = n, p = _ === void 0 && Je(r) ? $m(r, o, a, i) : d_(
      oo(t, _ || r, void 0, s, !1),
      o,
      a,
      i
    );
    p.level = "error", n_(p, {
      originalException: _,
      mechanism: {
        handled: !1,
        type: "onerror"
      }
    });
  });
}
function Ym(e) {
  Ru((n) => {
    const { stackParser: t, attachStacktrace: s } = u_();
    if (je() !== e || i_())
      return;
    const r = Km(n), o = Jr(r) ? Xm(r) : oo(t, r, void 0, s, !0);
    o.level = "error", n_(o, {
      originalException: r,
      mechanism: {
        handled: !1,
        type: "onunhandledrejection"
      }
    });
  });
}
function Km(e) {
  if (Jr(e))
    return e;
  const n = e;
  try {
    if ("reason" in n)
      return n.reason;
    if ("detail" in n && "reason" in n.detail)
      return n.detail.reason;
  } catch {
  }
  return e;
}
function Xm(e) {
  return {
    exception: {
      values: [
        {
          type: "UnhandledRejection",
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(e)}`
        }
      ]
    }
  };
}
function $m(e, n, t, s) {
  const r = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
  let o = $r(e) ? e.message : e, a = "Error";
  const i = o.match(r);
  return i && (a = i[1], o = i[2]), d_({
    exception: {
      values: [
        {
          type: a,
          value: o
        }
      ]
    }
  }, n, t, s);
}
function d_(e, n, t, s) {
  const r = e.exception = e.exception || {}, o = r.values = r.values || [], a = o[0] = o[0] || {}, i = a.stacktrace = a.stacktrace || {}, _ = i.frames = i.frames || [], p = isNaN(parseInt(s, 10)) ? void 0 : s, c = isNaN(parseInt(t, 10)) ? void 0 : t, d = Je(n) && n.length > 0 ? n : $d();
  return _.length === 0 && _.push({
    colno: p,
    filename: d,
    function: "?",
    in_app: !0,
    lineno: c
  }), e;
}
function Ea(e) {
  _n && M.log(`Global Handler attached: ${e}`);
}
function u_() {
  const e = je();
  return e && e.getOptions() || {
    stackParser: () => [],
    attachStacktrace: !1
  };
}
const Jm = [
  "EventTarget",
  "Window",
  "Node",
  "ApplicationCache",
  "AudioTrackList",
  "BroadcastChannel",
  "ChannelMergerNode",
  "CryptoOperation",
  "EventSource",
  "FileReader",
  "HTMLUnknownElement",
  "IDBDatabase",
  "IDBRequest",
  "IDBTransaction",
  "KeyOperation",
  "MediaController",
  "MessagePort",
  "ModalWindow",
  "Notification",
  "SVGElementInstance",
  "Screen",
  "SharedWorker",
  "TextTrack",
  "TextTrackCue",
  "TextTrackList",
  "WebSocket",
  "WebSocketWorker",
  "Worker",
  "XMLHttpRequest",
  "XMLHttpRequestEventTarget",
  "XMLHttpRequestUpload"
], l_ = "TryCatch", zm = (e = {}) => {
  const n = {
    XMLHttpRequest: !0,
    eventTarget: !0,
    requestAnimationFrame: !0,
    setInterval: !0,
    setTimeout: !0,
    ...e
  };
  return {
    name: l_,
    // TODO: This currently only works for the first client this is setup
    // We may want to adjust this to check for client etc.
    setupOnce() {
      n.setTimeout && ie(Z, "setTimeout", ba), n.setInterval && ie(Z, "setInterval", ba), n.requestAnimationFrame && ie(Z, "requestAnimationFrame", Zm), n.XMLHttpRequest && "XMLHttpRequest" in Z && ie(XMLHttpRequest.prototype, "send", Qm);
      const t = n.eventTarget;
      t && (Array.isArray(t) ? t : Jm).forEach(ef);
    }
  };
}, qm = mn(l_, zm);
function ba(e) {
  return function(...n) {
    const t = n[0];
    return n[0] = Kn(t, {
      mechanism: {
        data: { function: cn(e) },
        handled: !1,
        type: "instrument"
      }
    }), e.apply(this, n);
  };
}
function Zm(e) {
  return function(n) {
    return e.apply(this, [
      Kn(n, {
        mechanism: {
          data: {
            function: "requestAnimationFrame",
            handler: cn(e)
          },
          handled: !1,
          type: "instrument"
        }
      })
    ]);
  };
}
function Qm(e) {
  return function(...n) {
    const t = this;
    return ["onload", "onerror", "onprogress", "onreadystatechange"].forEach((r) => {
      r in t && typeof t[r] == "function" && ie(t, r, function(o) {
        const a = {
          mechanism: {
            data: {
              function: r,
              handler: cn(o)
            },
            handled: !1,
            type: "instrument"
          }
        }, i = Qr(o);
        return i && (a.mechanism.data.handler = cn(i)), Kn(o, a);
      });
    }), e.apply(this, n);
  };
}
function ef(e) {
  const n = Z, t = n[e] && n[e].prototype;
  !t || !t.hasOwnProperty || !t.hasOwnProperty("addEventListener") || (ie(t, "addEventListener", function(s) {
    return function(r, o, a) {
      try {
        typeof o.handleEvent == "function" && (o.handleEvent = Kn(o.handleEvent, {
          mechanism: {
            data: {
              function: "handleEvent",
              handler: cn(o),
              target: e
            },
            handled: !1,
            type: "instrument"
          }
        }));
      } catch {
      }
      return s.apply(this, [
        r,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Kn(o, {
          mechanism: {
            data: {
              function: "addEventListener",
              handler: cn(o),
              target: e
            },
            handled: !1,
            type: "instrument"
          }
        }),
        a
      ]);
    };
  }), ie(
    t,
    "removeEventListener",
    function(s) {
      return function(r, o, a) {
        const i = o;
        try {
          const _ = i && i.__sentry_wrapped__;
          _ && s.call(this, r, _, a);
        } catch {
        }
        return s.call(this, r, i, a);
      };
    }
  ));
}
const Bt = 1024, m_ = "Breadcrumbs", nf = (e = {}) => {
  const n = {
    console: !0,
    dom: !0,
    fetch: !0,
    history: !0,
    sentry: !0,
    xhr: !0,
    ...e
  };
  return {
    name: m_,
    setup(t) {
      n.console && iu(of(t)), n.dom && du(rf(t, n.dom)), n.xhr && Au(af(t)), n.fetch && Eu(_f(t)), n.history && Ou(pf(t)), n.sentry && t.on && t.on("beforeSendEvent", sf(t));
    }
  };
}, tf = mn(m_, nf);
function sf(e) {
  return function(t) {
    je() === e && Nn(
      {
        category: `sentry.${t.type === "transaction" ? "transaction" : "event"}`,
        event_id: t.event_id,
        level: t.level,
        message: on(t)
      },
      {
        event: t
      }
    );
  };
}
function rf(e, n) {
  return function(s) {
    if (je() !== e)
      return;
    let r, o, a = typeof n == "object" ? n.serializeAttribute : void 0, i = typeof n == "object" && typeof n.maxStringLength == "number" ? n.maxStringLength : void 0;
    i && i > Bt && (_n && M.warn(
      `\`dom.maxStringLength\` cannot exceed ${Bt}, but a value of ${i} was configured. Sentry will use ${Bt} instead.`
    ), i = Bt), typeof a == "string" && (a = [a]);
    try {
      const p = s.event, c = cf(p) ? p.target : p;
      r = Vi(c, { keyAttrs: a, maxStringLength: i }), o = Jd(c);
    } catch {
      r = "<unknown>";
    }
    if (r.length === 0)
      return;
    const _ = {
      category: `ui.${s.name}`,
      message: r
    };
    o && (_.data = { "ui.component_name": o }), Nn(_, {
      event: s.event,
      name: s.name,
      global: s.global
    });
  };
}
function of(e) {
  return function(t) {
    if (je() !== e)
      return;
    const s = {
      category: "console",
      data: {
        arguments: t.args,
        logger: "console"
      },
      level: Fu(t.level),
      message: Jo(t.args, " ")
    };
    if (t.level === "assert")
      if (t.args[0] === !1)
        s.message = `Assertion failed: ${Jo(t.args.slice(1), " ") || "console.assert"}`, s.data.arguments = t.args.slice(1);
      else
        return;
    Nn(s, {
      input: t.args,
      level: t.level
    });
  };
}
function af(e) {
  return function(t) {
    if (je() !== e)
      return;
    const { startTimestamp: s, endTimestamp: r } = t, o = t.xhr[st];
    if (!s || !r || !o)
      return;
    const { method: a, url: i, status_code: _, body: p } = o, c = {
      method: a,
      url: i,
      status_code: _
    }, d = {
      xhr: t.xhr,
      input: p,
      startTimestamp: s,
      endTimestamp: r
    };
    Nn(
      {
        category: "xhr",
        data: c,
        type: "http"
      },
      d
    );
  };
}
function _f(e) {
  return function(t) {
    if (je() !== e)
      return;
    const { startTimestamp: s, endTimestamp: r } = t;
    if (r && !(t.fetchData.url.match(/sentry_key/) && t.fetchData.method === "POST"))
      if (t.error) {
        const o = t.fetchData, a = {
          data: t.error,
          input: t.args,
          startTimestamp: s,
          endTimestamp: r
        };
        Nn(
          {
            category: "fetch",
            data: o,
            level: "error",
            type: "http"
          },
          a
        );
      } else {
        const o = t.response, a = {
          ...t.fetchData,
          status_code: o && o.status
        }, i = {
          input: t.args,
          response: o,
          startTimestamp: s,
          endTimestamp: r
        };
        Nn(
          {
            category: "fetch",
            data: a,
            type: "http"
          },
          i
        );
      }
  };
}
function pf(e) {
  return function(t) {
    if (je() !== e)
      return;
    let s = t.from, r = t.to;
    const o = Bs(Z.location.href);
    let a = s ? Bs(s) : void 0;
    const i = Bs(r);
    (!a || !a.path) && (a = o), o.protocol === i.protocol && o.host === i.host && (r = i.relative), o.protocol === a.protocol && o.host === a.host && (s = a.relative), Nn({
      category: "navigation",
      data: {
        from: s,
        to: r
      }
    });
  };
}
function cf(e) {
  return !!e && !!e.target;
}
const df = "cause", uf = 5, f_ = "LinkedErrors", lf = (e = {}) => {
  const n = e.limit || uf, t = e.key || df;
  return {
    name: f_,
    preprocessEvent(s, r, o) {
      const a = o.getOptions();
      Wd(
        // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
        __,
        a.stackParser,
        a.maxValueLength,
        t,
        n,
        s,
        r
      );
    }
  };
}, mf = mn(f_, lf), g_ = "HttpContext", ff = () => ({
  name: g_,
  preprocessEvent(e) {
    if (!Z.navigator && !Z.location && !Z.document)
      return;
    const n = e.request && e.request.url || Z.location && Z.location.href, { referrer: t } = Z.document || {}, { userAgent: s } = Z.navigator || {}, r = {
      ...e.request && e.request.headers,
      ...t && { Referer: t },
      ...s && { "User-Agent": s }
    }, o = { ...e.request, ...n && { url: n }, headers: r };
    e.request = o;
  }
}), gf = mn(g_, ff), h_ = "Dedupe", hf = () => {
  let e;
  return {
    name: h_,
    processEvent(n) {
      if (n.type)
        return n;
      try {
        if (bf(n, e))
          return _n && M.warn("Event dropped due to being a duplicate of previously captured event."), null;
      } catch {
      }
      return e = n;
    }
  };
}, Ef = mn(h_, hf);
function bf(e, n) {
  return n ? !!(kf(e, n) || vf(e, n)) : !1;
}
function kf(e, n) {
  const t = e.message, s = n.message;
  return !(!t && !s || t && !s || !t && s || t !== s || !b_(e, n) || !E_(e, n));
}
function vf(e, n) {
  const t = ka(n), s = ka(e);
  return !(!t || !s || t.type !== s.type || t.value !== s.value || !b_(e, n) || !E_(e, n));
}
function E_(e, n) {
  let t = va(e), s = va(n);
  if (!t && !s)
    return !0;
  if (t && !s || !t && s || (t = t, s = s, s.length !== t.length))
    return !1;
  for (let r = 0; r < s.length; r++) {
    const o = s[r], a = t[r];
    if (o.filename !== a.filename || o.lineno !== a.lineno || o.colno !== a.colno || o.function !== a.function)
      return !1;
  }
  return !0;
}
function b_(e, n) {
  let t = e.fingerprint, s = n.fingerprint;
  if (!t && !s)
    return !0;
  if (t && !s || !t && s)
    return !1;
  t = t, s = s;
  try {
    return t.join("") === s.join("");
  } catch {
    return !1;
  }
}
function ka(e) {
  return e.exception && e.exception.values && e.exception.values[0];
}
function va(e) {
  const n = e.exception;
  if (n)
    try {
      return n.values[0].stacktrace.frames;
    } catch {
      return;
    }
}
const Tf = [
  new nm(),
  new ql(),
  new qm(),
  new tf(),
  new Fm(),
  new mf(),
  new Ef(),
  new gf()
];
class Rf {
  constructor({ logPayload: n, credentials: t }) {
    Ie(this, "_logPayload"), Ie(this, "_hub", null), this._logPayload = n;
    const { enabled: s, dsn: r, release: o } = t;
    if (!s) {
      console.warn("Sentry not enabled, skipping Sentry initialization.");
      return;
    }
    if ([r, o].some((i) => !i)) {
      console.warn(
        "Skipping Sentry initialization because some credentials are missing.",
        `These are your current credentials:
`,
        {
          dsn: r,
          release: o
        }
      );
      return;
    }
    this._hub = this._initializeSentry(t);
  }
  /**
   * Sends the log message to Sentry.
   *
   * We only send fatal and error log levels to Sentry.
   */
  send(n) {
    if (!this._hub) {
      console.warn("Sentry not initialized, skipping Sentry log.");
      return;
    }
    const t = this._logPayload.level;
    [Xe.FATAL, Xe.ERROR].includes(t) && this._hub.captureMessage(n, t, {
      captureContext: (s) => (s.setExtra("payload", this._logPayload), s)
    });
  }
  /**
   * Initializes Sentry using the provided credentials.
   *
   * We use the Sentry client directly instead of using the `Sentry.init()`
   * function because we do not want to pollute the Sentry global state in
   * the application that is using this logger.
   *
   * For more information about it check the following documentation.
   * @link https://docs.sentry.io/platforms/javascript/troubleshooting/#using-a-client-directly
   */
  _initializeSentry(n) {
    const { dsn: t, release: s } = n, r = this._logPayload.environment, o = new Tm({
      dsn: t,
      environment: r,
      release: s,
      transport: Im,
      stackParser: jm,
      integrations: [...Tf]
    });
    return new so(o);
  }
}
function yf({
  logPayload: e,
  credentials: n
}) {
  const t = [];
  return Xo.logSenders.includes(bt.NEW_RELIC) && t.push(new Ld({ logPayload: e, credentials: n.newrelic ?? {} })), Xo.logSenders.includes(bt.SENTRY) && t.push(new Rf({ logPayload: e, credentials: n.sentry ?? {} })), t.length === 0 && console.warn("No log sender is defined. Please check the settings."), t;
}
class If {
  constructor({
    name: n,
    environment: t,
    extraLogPayload: s,
    credentials: r
  }) {
    Ie(this, "name"), Ie(this, "_logger"), Ie(this, "_environment"), Ie(this, "_extraLogPayload"), Ie(this, "_credentials"), this.name = n, this._logger = Md.initialize({ name: n, environment: t }), this._environment = t, this._extraLogPayload = s ?? {}, this._credentials = r ?? {};
  }
  /**
   * Logs detailed information needed to trace program execution flow.
   * Ignore this during normal program execution flow in production.
   */
  trace({ eventCode: n, scope: t, message: s, ...r }) {
    this._log({ level: Xe.TRACE, eventCode: n, scope: t, message: s, ...r });
  }
  /**
   * Logs information for debugging.
   * Ignore this during normal program execution flow in production.
   */
  debug({ eventCode: n, scope: t, message: s, ...r }) {
    this._log({ level: Xe.DEBUG, eventCode: n, scope: t, message: s, ...r });
  }
  /**
   * Logs general information about an event that has occurred.
   * Ignore this during normal program execution flow in production.
   */
  info({ eventCode: n, scope: t, message: s, ...r }) {
    this._log({ level: Xe.INFO, eventCode: n, scope: t, message: s, ...r });
  }
  /**
   * Logs event that could cause an error in the application and
   * unexpected events that do not stop normal program execution.
   */
  warn({ eventCode: n, scope: t, message: s, ...r }) {
    this._log({ level: Xe.WARN, eventCode: n, scope: t, message: s, ...r });
  }
  /**
   * Logs event when a functionality within the application has failed,
   * but doesn't prevent the entire program execution from completing.
   */
  error({ eventCode: n, scope: t, message: s, ...r }) {
    this._log({ level: Xe.ERROR, eventCode: n, scope: t, message: s, ...r });
  }
  /**
   * Logs event when one or more events occur that prevent the application
   * from completing its flow. Think of a fatal error as one which cannot
   * be recovered from.
   */
  fatal({ eventCode: n, scope: t, message: s, ...r }) {
    this._log({ level: Xe.FATAL, eventCode: n, scope: t, message: s, ...r });
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _log({ level: n, eventCode: t, scope: s, message: r, ...o }) {
    throw new dd("Method not implemented.");
  }
  /**
   * Prepares the log payload to be sent to an external service.
   *
   * It adds metadata to the log payload. The data in the props are related
   * to the specific log that contains those metadata. The data in the
   * extraLogPayload are related to every log that is sent by the logger.
   */
  _prepareLogPayload({
    level: n,
    serviceType: t,
    eventCode: s,
    scope: r,
    ...o
  }) {
    return {
      level: n,
      serviceType: t,
      eventCode: s,
      scope: r,
      serviceName: this.name,
      environment: this._environment,
      ...o,
      ...this._extraLogPayload
    };
  }
  /**
   * Sends the log message with an payload to an external service.
   *
   * Only sends the log to an external service in non-local environment.
   */
  _sendLogToExternalServices(n, t) {
    if ([Zt.DEV, Zt.PROD].includes(
      this._environment
    )) {
      const r = yf({
        logPayload: t,
        credentials: this._credentials
      });
      for (const o of r)
        o.send(n);
    }
  }
}
class Of extends If {
  constructor({
    name: n,
    environment: t,
    extraLogPayload: s,
    credentials: r
  }) {
    super({ name: n, environment: t, extraLogPayload: s, credentials: r });
  }
  _log({
    level: n,
    eventCode: t,
    scope: s,
    message: r,
    ...o
  }) {
    const a = this._prepareLogPayload({
      level: n,
      serviceType: Pi.CLIENT,
      eventCode: t,
      scope: s,
      ...o
    });
    this._logger[n](a, r), this._sendLogToExternalServices(r, a);
  }
}
const k_ = "0.90.2";
function Nf(e) {
  if (e)
    return `${e}@${k_}`;
}
const Df = "Web components", Af = {
  serviceVersion: k_
}, Sf = "prod", wf = {
  newrelic: {
    enabled: !0,
    licenseKey: "c979a28e3f2c73267a8de41fd552a317FFFFNRAL"
  },
  sentry: {
    enabled: !0,
    dsn: "https://ac7c988eaf2d5ae28e4444c63ee9f45a@o33765.ingest.sentry.io/4506541619216384",
    release: Nf("ats-web-components")
  }
}, Hf = new Of({
  name: Df,
  environment: Sf,
  extraLogPayload: Af,
  credentials: wf
});
function Uf({ store: e }) {
  e.$state = {
    ...e.$state,
    currentFetchPromise: null,
    loadingStatus: Fe.INITIAL
  }, e.isLoaded = lt(() => e.$state.loadingStatus === Fe.LOADED), e.isLoading = lt(() => e.$state.loadingStatus === Fe.LOADING), e.hasError = lt(() => e.$state.loadingStatus === Fe.ERROR), e.loadData = async function(n = {}) {
    if (!e._loadData)
      throw new Error("Missing _loadData method in store");
    const { force: t = !1 } = n;
    if (!(e.$state.loadingStatus === Fe.LOADED && !t)) {
      if (e.$state.currentFetchPromise && !t)
        return e.$state.currentFetchPromise;
      e.$state.loadingStatus = Fe.LOADING, e.$state.currentFetchPromise = (async () => {
        try {
          await e._loadData(n), e.$state.loadingStatus = Fe.LOADED;
        } catch (s) {
          e.$state.loadingStatus = Fe.ERROR, Hf.error({
            eventCode: Ci.REQUEST,
            scope: Ui.GLOBAL,
            message: `Error fetching data in ${e.$id} store`,
            error: s
          });
        } finally {
          e.$state.currentFetchPromise = null;
        }
      })(), await e.$state.currentFetchPromise;
    }
  };
}
const v_ = ed();
v_.use(Uf);
const Cf = /* @__PURE__ */ _s(
  () => import("./SeamlessHeader.ce-88f3b87c.js")
), Pf = /* @__PURE__ */ _s(
  () => import("./SeamlessFooter.ce-29787956.js")
), Mf = /* @__PURE__ */ _s(
  () => import("./PricingBreakdown.ce-de23ee52.js")
), Lf = /* @__PURE__ */ _s(
  () => import("./CheckoutEntryPoint.ce-9ccc9548.js")
);
function Gf() {
  er(Zc).use(v_);
}
function xf() {
  const e = "ats-web";
  [
    {
      name: "seamless-header",
      component: Cf
    },
    {
      name: "seamless-footer",
      component: Pf
    },
    {
      name: "pricing-breakdown",
      component: Mf
    },
    {
      name: "checkout-entry-point",
      component: Lf
    }
  ].forEach((t) => {
    const s = /* @__PURE__ */ Kc(t.component);
    customElements.define(`${e}-${t.name}`, s);
  });
}
async function Kf() {
  Gf(), xf();
}
export {
  Ui as A,
  Lf as C,
  Ci as E,
  _d as L,
  cd as P,
  Cf as S,
  Wf as a,
  Yf as b,
  Bf as c,
  Vf as d,
  yi as e,
  jf as f,
  pd as g,
  Mf as h,
  Pf as i,
  Hf as l,
  Ff as m,
  Or as n,
  cc as o,
  Kf as r,
  M_ as t
};
//# sourceMappingURL=main.lib-685de80d.js.map
